// src/types/enums.ts
var UserStatus = {
  PENDING_VERIFICATION: "PENDING_VERIFICATION",
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  DELETED: "DELETED"
};
var OrgStatus = {
  PENDING_VERIFICATION: "PENDING_VERIFICATION",
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  CANCELLED: "CANCELLED"
};
var MeasurementUnit = {
  INCH: "INCH",
  CM: "CM"
};
var ConnectionType = {
  SHOPIFY: "SHOPIFY",
  WOOCOMMERCE: "WOOCOMMERCE",
  TIKTOK: "TIKTOK",
  ORDER_DESK: "ORDER_DESK",
  ETSY: "ETSY",
  AMAZON: "AMAZON",
  CUSTOM_API: "CUSTOM_API"
};
var ConnectionStatus = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  DISCONNECTED: "DISCONNECTED",
  ERROR: "ERROR",
  SUSPENDED: "SUSPENDED"
};
var SyncStatus = {
  PENDING: "PENDING",
  SYNCING: "SYNCING",
  SYNCED: "SYNCED",
  ERROR: "ERROR",
  /** DEPRECATED (full-sync model) — kept for legacy rows only. */
  DRIFT_DETECTED: "DRIFT_DETECTED",
  /** Merchant action needed to reconcile external changes (e.g. removed variants). */
  SYNC_REQUIRED: "SYNC_REQUIRED"
};
var ProductType = {
  DTF_BY_SIZE: "DTF_BY_SIZE",
  GANGSHEET: "GANGSHEET",
  UV_STICKER: "UV_STICKER",
  APPAREL: "APPAREL",
  DRINKWARE: "DRINKWARE",
  ACCESSORIES: "ACCESSORIES",
  HOME_DECOR: "HOME_DECOR",
  STATIONERY: "STATIONERY",
  CUSTOM: "CUSTOM"
};
var DesignerMode = {
  NONE: "NONE",
  DTF_BY_SIZE: "DTF_BY_SIZE",
  GANGSHEET: "GANGSHEET",
  APPAREL: "APPAREL",
  PRODUCT_MOCKUP: "PRODUCT_MOCKUP"
};
var DesignContext = {
  STOREFRONT: "STOREFRONT",
  PRODUCT: "PRODUCT",
  MERCHANT_PRODUCT: "MERCHANT_PRODUCT"
};
var ProductSourceType = {
  TEMPLATE_PUBLISH: "TEMPLATE_PUBLISH",
  DESIGN_GENERATED: "DESIGN_GENERATED"
};
var PreviewJobStatus = {
  PENDING: "PENDING",
  RUNNING: "RUNNING",
  DONE: "DONE",
  FAILED: "FAILED"
};
var UPTStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED"
};
var ExportFormat = {
  PNG: "PNG",
  JPEG: "JPEG",
  PDF: "PDF",
  TIFF: "TIFF"
};
var ColorSpace = {
  RGB: "RGB",
  CMYK: "CMYK",
  GRAYSCALE: "GRAYSCALE"
};
var BackgroundType = {
  TRANSPARENT: "TRANSPARENT",
  SOLID_COLOR: "SOLID_COLOR",
  IMAGE: "IMAGE",
  GARMENT_COLOR: "GARMENT_COLOR",
  MASK_PNG: "MASK_PNG"
};
var PrintTechnique = {
  DTG: "DTG",
  DTF: "DTF",
  SUBLIMATION: "SUBLIMATION",
  SCREEN_PRINT: "SCREEN_PRINT",
  EMBROIDERY: "EMBROIDERY",
  VINYL: "VINYL",
  UV_PRINT: "UV_PRINT",
  LASER_ENGRAVE: "LASER_ENGRAVE"
};
var SizeCategory = {
  BABY: "BABY",
  TODDLER: "TODDLER",
  YOUTH: "YOUTH",
  ADULT: "ADULT",
  PLUS: "PLUS"
};
var MockupType = {
  FLAT: "FLAT",
  GHOST: "GHOST",
  MODEL: "MODEL",
  SCENE: "SCENE",
  THREE_D: "THREE_D"
};
var MockupLayerType = {
  GARMENT: "GARMENT",
  DESIGN_OVERLAY: "DESIGN_OVERLAY",
  SHADOW: "SHADOW",
  MASK: "MASK",
  HIGHLIGHT: "HIGHLIGHT",
  TEXTURE: "TEXTURE"
};
var PlacementStatus = {
  PENDING: "PENDING",
  DESIGN_ATTACHED: "DESIGN_ATTACHED",
  EXPORTED: "EXPORTED",
  APPROVED: "APPROVED"
};
var PublishMethod = {
  PUBLISH_NEW: "PUBLISH_NEW",
  CONNECT_EXISTING: "CONNECT_EXISTING"
};
var ProductStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
  SYNC_ERROR: "SYNC_ERROR"
};
var InventoryPolicy = {
  CONTINUE: "CONTINUE",
  DENY: "DENY"
};
var PricingStrategy = {
  PRESET_PRICE: "PRESET_PRICE",
  SQ_IN: "SQ_IN",
  LINEAR_IN: "LINEAR_IN",
  APPAREL_COMPOSITE: "APPAREL_COMPOSITE",
  FORMULA: "FORMULA"
};
var RoundingRule = {
  ROUND_UP: "ROUND_UP",
  ROUND_DOWN: "ROUND_DOWN",
  ROUND_NEAREST: "ROUND_NEAREST",
  NONE: "NONE"
};
var PricingOverrideType = {
  MULTIPLIER: "MULTIPLIER",
  FIXED_ADD: "FIXED_ADD",
  REPLACE_RATE: "REPLACE_RATE",
  FIXED_PRICE: "FIXED_PRICE",
  DISCOUNT_PERCENT: "DISCOUNT_PERCENT"
};
var CustomerGroupType = {
  RETAIL: "RETAIL",
  WHOLESALE: "WHOLESALE",
  VIP: "VIP",
  CONTRACT: "CONTRACT"
};
var PaymentStatus = {
  PENDING: "PENDING",
  AUTHORIZED: "AUTHORIZED",
  PAID: "PAID",
  PARTIALLY_REFUNDED: "PARTIALLY_REFUNDED",
  REFUNDED: "REFUNDED",
  FAILED: "FAILED"
};
var OrderSource = {
  MANUAL: "MANUAL",
  SHOPIFY: "SHOPIFY",
  WOOCOMMERCE: "WOOCOMMERCE",
  API: "API"
};
var OrderStatus = {
  DRAFT: "DRAFT",
  NEW: "NEW",
  DESIGN_PENDING: "DESIGN_PENDING",
  DESIGN_ATTACHED: "DESIGN_ATTACHED",
  EXPORT_QUEUED: "EXPORT_QUEUED",
  EXPORT_PROCESSING: "EXPORT_PROCESSING",
  EXPORTED: "EXPORTED",
  EXPORT_FAILED: "EXPORT_FAILED",
  IN_PRODUCTION: "IN_PRODUCTION",
  PRODUCTION_DONE: "PRODUCTION_DONE",
  READY_TO_SHIP: "READY_TO_SHIP",
  SHIPPED: "SHIPPED",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
  FAILED: "FAILED",
  ON_HOLD: "ON_HOLD",
  FRAUD_HOLD: "FRAUD_HOLD",
  CANCEL_REQUESTED: "CANCEL_REQUESTED",
  // Manual fulfillment method: waiting for the merchant's Shopify
  // "Request fulfillment" click before routing/charging.
  AWAITING_FULFILLMENT_REQUEST: "AWAITING_FULFILLMENT_REQUEST"
};
var ChannelOrderStatus = {
  PENDING: "PENDING",
  DESIGN_READY: "DESIGN_READY",
  PROCESSING: "PROCESSING",
  IN_PRODUCTION: "IN_PRODUCTION",
  READY_TO_SHIP: "READY_TO_SHIP",
  SHIPPED: "SHIPPED",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
  FAILED: "FAILED",
  ON_HOLD: "ON_HOLD"
};
var OrderEventType = {
  // Standard lifecycle
  ORDER_CREATED: "ORDER_CREATED",
  DESIGN_ATTACHED: "DESIGN_ATTACHED",
  EXPORT_STARTED: "EXPORT_STARTED",
  EXPORT_COMPLETED: "EXPORT_COMPLETED",
  EXPORT_FAILED: "EXPORT_FAILED",
  EXPORT_REGENERATED: "EXPORT_REGENERATED",
  PRODUCTION_STARTED: "PRODUCTION_STARTED",
  PRODUCTION_COMPLETED: "PRODUCTION_COMPLETED",
  SHIPPED: "SHIPPED",
  DELIVERED: "DELIVERED",
  // Cancel / Hold
  CANCEL_REQUESTED: "CANCEL_REQUESTED",
  CANCELLED: "CANCELLED",
  ON_HOLD: "ON_HOLD",
  HOLD_RELEASED: "HOLD_RELEASED",
  FRAUD_HOLD: "FRAUD_HOLD",
  FRAUD_CLEARED: "FRAUD_CLEARED",
  // Edit
  ADDRESS_CHANGED: "ADDRESS_CHANGED",
  VARIANT_CHANGED: "VARIANT_CHANGED",
  // Post-order design edit (apparel/gangsheet revision system). Recorded when a
  // merchant/admin edits a line's artwork after the order exists, producing a
  // new revision and re-render.
  DESIGN_EDITED: "DESIGN_EDITED",
  NOTE_UPDATED: "NOTE_UPDATED",
  NOTE_ADDED: "NOTE_ADDED",
  TAG_ADDED: "TAG_ADDED",
  TAG_REMOVED: "TAG_REMOVED",
  // Reprint / RMA
  REPRINT_REQUESTED: "REPRINT_REQUESTED",
  REPRINT_APPROVED: "REPRINT_APPROVED",
  REPRINT_REJECTED: "REPRINT_REJECTED",
  REPRINTED: "REPRINTED",
  RMA_OPENED: "RMA_OPENED",
  RMA_RESOLVED: "RMA_RESOLVED",
  REFUND_ISSUED: "REFUND_ISSUED",
  CREDIT_ISSUED: "CREDIT_ISSUED",
  // Fulfillment
  PARTIAL_SHIPPED: "PARTIAL_SHIPPED",
  SPLIT_CREATED: "SPLIT_CREATED",
  FULFILLMENT_REQUESTED: "FULFILLMENT_REQUESTED",
  // Frozen per-line fulfillment decision at ingest, and later admin
  // switch-to-self. Payload identifies the line; it carries no customer PII.
  FULFILLMENT_SNAPSHOT: "FULFILLMENT_SNAPSHOT",
  // Shipment lifecycle
  SHIPMENT_CREATED: "SHIPMENT_CREATED",
  SHIPMENT_UPDATED: "SHIPMENT_UPDATED",
  SHIPMENT_CANCELLED: "SHIPMENT_CANCELLED",
  TRACKING_UPDATED: "TRACKING_UPDATED",
  SHIPMENT_DELIVERED: "SHIPMENT_DELIVERED",
  // Item-level cancellation
  ITEM_CANCELLED: "ITEM_CANCELLED",
  // Provider submission
  PROVIDER_ASSIGNED: "PROVIDER_ASSIGNED",
  PROVIDER_SUBMITTED: "PROVIDER_SUBMITTED",
  PROVIDER_ACKED: "PROVIDER_ACKED",
  PROVIDER_FAILED: "PROVIDER_FAILED",
  PROVIDER_CANCEL_SENT: "PROVIDER_CANCEL_SENT",
  PROVIDER_CANCELLED: "PROVIDER_CANCELLED",
  // Provider callback arrived after admin takeover — recorded, not applied.
  PROVIDER_CONFLICT: "PROVIDER_CONFLICT",
  // QC
  QC_PASSED: "QC_PASSED",
  QC_FAILED: "QC_FAILED",
  QC_EVIDENCE_UPLOADED: "QC_EVIDENCE_UPLOADED",
  // Proofing
  PROOF_SENT: "PROOF_SENT",
  PROOF_APPROVED: "PROOF_APPROVED",
  PROOF_REJECTED: "PROOF_REJECTED",
  // Payment
  PAYMENT_CAPTURED: "PAYMENT_CAPTURED",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  PAYMENT_RETRY: "PAYMENT_RETRY",
  // Provider override
  PROVIDER_OVERRIDDEN: "PROVIDER_OVERRIDDEN",
  // Design revision
  DESIGN_REVISION_REQUESTED: "DESIGN_REVISION_REQUESTED",
  DESIGN_RESUBMITTED: "DESIGN_RESUBMITTED",
  // External channel sync (Shopify / future: ShipStation)
  SHOPIFY_SYNCED: "SHOPIFY_SYNCED",
  SHOPIFY_SYNC_FAILED: "SHOPIFY_SYNC_FAILED",
  // GDPR — order had provider submissions at redaction time; the erasure
  // notice must be forwarded to the provider manually (mirrors the
  // GDPR_PROVIDER_NOTIFY anomaly on the order timeline).
  GDPR_PROVIDER_NOTIFY_REQUIRED: "GDPR_PROVIDER_NOTIFY_REQUIRED",
  // Ops / reconciliation — ingest detected a health problem on this order
  // (mirrors an OrderAnomaly row on the order timeline).
  INGEST_ANOMALY_DETECTED: "INGEST_ANOMALY_DETECTED",
  // Generic
  STATUS_CHANGED: "STATUS_CHANGED"
};
var OrderAnomalyType = {
  PAID_ORDER_NO_DESIGN: "PAID_ORDER_NO_DESIGN",
  ORDER_STUCK_NEW: "ORDER_STUCK_NEW",
  EXPORT_FAILED_STALE: "EXPORT_FAILED_STALE",
  SUMMARY_PDF_FAILED: "SUMMARY_PDF_FAILED",
  WEBHOOK_POISON: "WEBHOOK_POISON",
  ORDER_INGEST_FAILED: "ORDER_INGEST_FAILED",
  // Wholesale-settled order with provider-routed items whose dispatch never
  // progressed past the delay + grace window (swallowed enqueue, lost job).
  PROVIDER_DISPATCH_STALLED: "PROVIDER_DISPATCH_STALLED",
  // Shipment stuck in LABEL_CREATED beyond threshold — carrier-handoff
  // callback never arrived (lost callback or package never moved).
  SHIPMENT_LABEL_STALLED: "SHIPMENT_LABEL_STALLED",
  // Submission stuck in SUBMITTED/ACKED beyond threshold — the provider
  // received the order but never progressed or failed it (silent stall).
  PROVIDER_SUBMISSION_STALLED: "PROVIDER_SUBMISSION_STALLED",
  // Virtual type synthesized by the API-side watchdog (never persisted).
  RECONCILE_TICK_OVERDUE: "RECONCILE_TICK_OVERDUE",
  // POD-lane order computed a $0 wholesale cost — settlement never opens
  // (NONE -> PENDING requires cents > 0) so the provider submit never fires.
  WHOLESALE_COST_ZERO: "WHOLESALE_COST_ZERO",
  // GDPR erasure hit an order already submitted to an external provider —
  // ops must forward the erasure notice manually (no provider erasure API).
  GDPR_PROVIDER_NOTIFY: "GDPR_PROVIDER_NOTIFY",
  STRIPE_WEBHOOK_REJECTED: "STRIPE_WEBHOOK_REJECTED",
  // Option line attached with a problem the order still kept: expired
  // submission, variant or quantity mismatch. ORDERED reuse is dropped.
  OPTION_LINE_MISMATCH: "OPTION_LINE_MISMATCH",
  // Paid options line with no submission attached.
  OPTIONS_LINE_WITHOUT_SUBMISSION: "OPTIONS_LINE_WITHOUT_SUBMISSION",
  // Option line whose customer file is not ready to produce.
  OPTION_UPLOAD_NOT_READY: "OPTION_UPLOAD_NOT_READY"
};
var OrderAnomalySeverity = {
  CRITICAL: "CRITICAL",
  WARNING: "WARNING",
  INFO: "INFO"
};
var OrderAnomalyStatus = {
  OPEN: "OPEN",
  ACKNOWLEDGED: "ACKNOWLEDGED",
  RESOLVED: "RESOLVED",
  // Terminal and permanent — sweeps never flip IGNORED back to OPEN.
  IGNORED: "IGNORED"
};
var OrderAnomalyResolution = {
  AUTO: "AUTO",
  MANUAL: "MANUAL"
};
var ReconciliationRunStatus = {
  RUNNING: "RUNNING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
};
var FulfillmentStatus = {
  UNFULFILLED: "UNFULFILLED",
  PARTIAL: "PARTIAL",
  FULFILLED: "FULFILLED"
};
var FulfillmentProvider = {
  TK_POD: "TK_POD",
  SELF: "SELF"
};
var FulfillmentMethod = {
  AUTO: "AUTO",
  MANUAL: "MANUAL"
};
var FulfillmentSyncStatus = {
  SYNCED: "SYNCED",
  PENDING: "PENDING",
  ERROR: "ERROR"
};
var ReprintType = {
  QUALITY_ISSUE: "QUALITY_ISSUE",
  CUSTOMER_ERROR: "CUSTOMER_ERROR",
  SHIPPING_DAMAGE: "SHIPPING_DAMAGE",
  MISSING_ITEM: "MISSING_ITEM",
  OTHER: "OTHER"
};
var ReprintStatus = {
  REQUESTED: "REQUESTED",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  IN_PRODUCTION: "IN_PRODUCTION",
  SHIPPED: "SHIPPED",
  COMPLETED: "COMPLETED"
};
var QCStatus = {
  PENDING: "PENDING",
  PASSED: "PASSED",
  FAILED: "FAILED",
  REWORK: "REWORK"
};
var ProofStatus = {
  NOT_REQUIRED: "NOT_REQUIRED",
  PROOF_PENDING: "PROOF_PENDING",
  PROOF_SENT: "PROOF_SENT",
  PROOF_APPROVED: "PROOF_APPROVED",
  PROOF_REJECTED: "PROOF_REJECTED"
};
var InvoiceLineType = {
  PRODUCTION: "PRODUCTION",
  SHIPPING: "SHIPPING",
  REPRINT: "REPRINT",
  CREDIT: "CREDIT",
  TAX: "TAX",
  DISCOUNT: "DISCOUNT",
  SUBSCRIPTION: "SUBSCRIPTION",
  ADJUSTMENT: "ADJUSTMENT"
};
var CreditNoteStatus = {
  DRAFT: "DRAFT",
  ISSUED: "ISSUED",
  APPLIED: "APPLIED",
  VOID: "VOID"
};
var InvoiceStatus = {
  DRAFT: "DRAFT",
  ISSUED: "ISSUED",
  PAID: "PAID",
  VOID: "VOID",
  OVERDUE: "OVERDUE"
};
var DesignStatus = {
  DRAFT: "DRAFT",
  SAVED: "SAVED",
  EXPORTED: "EXPORTED",
  LOCKED: "LOCKED"
};
var ExportStatus = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  READY: "READY",
  FAILED: "FAILED"
};
var ProviderType = {
  INTERNAL: "INTERNAL",
  EXTERNAL_API: "EXTERNAL_API",
  MANUAL: "MANUAL"
};
var ProviderStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  ARCHIVED: "ARCHIVED",
  MAINTENANCE: "MAINTENANCE"
};
var InkteoFulfillmentType = {
  SHIPPING: "SHIPPING",
  PICKUP: "PICKUP"
};
var ProductionType = {
  REGULAR: "REGULAR",
  RUSH: "RUSH"
};
var ProductionTypeSource = {
  DEFAULT: "DEFAULT",
  SHOPIFY_TAG: "SHOPIFY_TAG",
  ADMIN: "ADMIN"
};
var ProviderSubmissionStatus = {
  QUEUED: "QUEUED",
  SUBMITTED: "SUBMITTED",
  ACKED: "ACKED",
  IN_PRODUCTION: "IN_PRODUCTION",
  PRODUCED: "PRODUCED",
  SHIPPED: "SHIPPED",
  FAILED: "FAILED",
  CANCEL_REQUESTED: "CANCEL_REQUESTED",
  CANCELLED: "CANCELLED",
  // Admin took over fulfillment for this submission; provider callbacks are
  // no longer applied to the order (recorded as PROVIDER_CONFLICT events).
  ADMIN_OVERRIDDEN: "ADMIN_OVERRIDDEN"
};
var ShippingProviderType = {
  SHIPSTATION: "SHIPSTATION",
  EASYPOST: "EASYPOST",
  SHIPPO: "SHIPPO",
  FEDEX_DIRECT: "FEDEX_DIRECT",
  UPS_DIRECT: "UPS_DIRECT",
  USPS_DIRECT: "USPS_DIRECT",
  DHL_DIRECT: "DHL_DIRECT",
  MANUAL: "MANUAL",
  CUSTOM_API: "CUSTOM_API"
};
var ShippingMarkupType = {
  PERCENTAGE: "PERCENTAGE",
  FIXED_AMOUNT: "FIXED_AMOUNT"
};
var ShipmentStatus = {
  PENDING: "PENDING",
  LABEL_CREATED: "LABEL_CREATED",
  PICKED_UP: "PICKED_UP",
  IN_TRANSIT: "IN_TRANSIT",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
  DELIVERED: "DELIVERED",
  EXCEPTION: "EXCEPTION",
  RETURNED: "RETURNED",
  CANCELLED: "CANCELLED"
};
var WalletTransactionType = {
  CREDIT: "CREDIT",
  DEBIT: "DEBIT",
  HOLD: "HOLD",
  RELEASE: "RELEASE",
  ADJUSTMENT: "ADJUSTMENT"
};
var WalletTransactionReason = {
  TOP_UP: "TOP_UP",
  AUTO_RECHARGE: "AUTO_RECHARGE",
  ORDER_FULFILLMENT: "ORDER_FULFILLMENT",
  ORDER_REFUND: "ORDER_REFUND",
  MANUAL_ADJUSTMENT: "MANUAL_ADJUSTMENT",
  CHARGEBACK: "CHARGEBACK",
  CHARGEBACK_REVERSAL: "CHARGEBACK_REVERSAL",
  PROMOTIONAL_CREDIT: "PROMOTIONAL_CREDIT",
  HOLD_PLACED: "HOLD_PLACED",
  HOLD_RELEASED: "HOLD_RELEASED",
  ORDER_CARD_CHARGE: "ORDER_CARD_CHARGE",
  HOUSE_SUBSIDY: "HOUSE_SUBSIDY"
};
var WholesaleChargeStatus = {
  NONE: "NONE",
  PENDING: "PENDING",
  CHARGING: "CHARGING",
  PAID: "PAID",
  FAILED: "FAILED",
  ON_HOLD: "ON_HOLD"
};
var WholesaleSettledVia = {
  WALLET: "WALLET",
  CARD: "CARD",
  HYBRID: "HYBRID",
  HOUSE: "HOUSE"
};
var OrganizationAccountKind = {
  MERCHANT: "MERCHANT",
  HOUSE: "HOUSE"
};
var TaxExemptionKind = {
  RESALE: "RESALE",
  OTHER: "OTHER"
};
var TaxExemptionReviewStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var PaymentMethodType = {
  CARD: "CARD",
  BANK_ACCOUNT: "BANK_ACCOUNT",
  WALLET_ONLY: "WALLET_ONLY"
};
var RefundMode = {
  STRIPE: "STRIPE",
  WALLET_CREDIT: "WALLET_CREDIT"
};
var RefundStatus = {
  PENDING: "PENDING",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
  CANCELED: "CANCELED"
};
var RefundReason = {
  REQUESTED_BY_CUSTOMER: "REQUESTED_BY_CUSTOMER",
  DUPLICATE: "DUPLICATE",
  FRAUDULENT: "FRAUDULENT",
  PRODUCT_UNACCEPTABLE: "PRODUCT_UNACCEPTABLE",
  ORDER_CHANGE: "ORDER_CHANGE",
  OTHER: "OTHER"
};
var PaymentMethodStatus = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  FAILED: "FAILED",
  REMOVED: "REMOVED"
};
var SubscriptionStatus = {
  ACTIVE: "ACTIVE",
  TRIALING: "TRIALING",
  PAST_DUE: "PAST_DUE",
  CANCELLED: "CANCELLED",
  PAUSED: "PAUSED",
  INCOMPLETE: "INCOMPLETE",
  INCOMPLETE_EXPIRED: "INCOMPLETE_EXPIRED",
  UNPAID: "UNPAID"
};
var SubscriptionProvider = {
  SHOPIFY: "SHOPIFY",
  STRIPE: "STRIPE"
};
var NotificationType = {
  ORDER_RECEIVED: "ORDER_RECEIVED",
  ORDER_IN_PRODUCTION: "ORDER_IN_PRODUCTION",
  ORDER_SHIPPED: "ORDER_SHIPPED",
  ORDER_DELIVERED: "ORDER_DELIVERED",
  ORDER_CANCELLED: "ORDER_CANCELLED",
  WELCOME: "WELCOME",
  PASSWORD_RESET: "PASSWORD_RESET",
  EMAIL_VERIFICATION: "EMAIL_VERIFICATION",
  PAYMENT_RECEIVED: "PAYMENT_RECEIVED",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  LOW_BALANCE: "LOW_BALANCE",
  INVOICE_CREATED: "INVOICE_CREATED",
  SYNC_ERROR: "SYNC_ERROR",
  WEBHOOK_FAILURE: "WEBHOOK_FAILURE",
  EXPORT_READY: "EXPORT_READY",
  TICKET_CREATED: "TICKET_CREATED",
  TICKET_REPLY: "TICKET_REPLY",
  TICKET_RESOLVED: "TICKET_RESOLVED",
  // v3
  CATALOG_DRIFT_DETECTED: "CATALOG_DRIFT_DETECTED",
  REPUBLISH_REQUIRED: "REPUBLISH_REQUIRED",
  REPRINT_REQUESTED: "REPRINT_REQUESTED",
  REPRINT_RESOLVED: "REPRINT_RESOLVED",
  PROOF_READY: "PROOF_READY",
  QC_FAILED: "QC_FAILED",
  ORDER_ON_HOLD: "ORDER_ON_HOLD",
  FRAUD_ALERT: "FRAUD_ALERT",
  ORDER_AWAITING_APPROVAL: "ORDER_AWAITING_APPROVAL",
  // v3: Shopify-side change detection
  SHOPIFY_PRODUCT_CHANGED: "SHOPIFY_PRODUCT_CHANGED",
  SHOPIFY_PRODUCT_DELETED: "SHOPIFY_PRODUCT_DELETED",
  SHOPIFY_VARIANT_ADDED: "SHOPIFY_VARIANT_ADDED",
  SHOPIFY_VARIANT_REMOVED: "SHOPIFY_VARIANT_REMOVED",
  SHOPIFY_SKU_CHANGED: "SHOPIFY_SKU_CHANGED",
  SYNC_RESYNC_REQUIRED: "SYNC_RESYNC_REQUIRED",
  // v3: Provider submission
  PROVIDER_SUBMIT_FAILED: "PROVIDER_SUBMIT_FAILED",
  PROVIDER_MANUAL_ACTION: "PROVIDER_MANUAL_ACTION"
};
var NotificationChannel = {
  EMAIL: "EMAIL",
  PORTAL: "PORTAL",
  SMS: "SMS",
  WEBHOOK: "WEBHOOK"
};
var NotificationStatus = {
  PENDING: "PENDING",
  SENT: "SENT",
  DELIVERED: "DELIVERED",
  READ: "READ",
  FAILED: "FAILED"
};
var NotificationCategory = {
  TRANSACTIONAL: "TRANSACTIONAL",
  MARKETING: "MARKETING"
};
var BroadcastStatus = {
  DRAFT: "DRAFT",
  SCHEDULED: "SCHEDULED",
  SENDING: "SENDING",
  SENT: "SENT",
  CANCELLED: "CANCELLED"
};
var BroadcastAudienceType = {
  ALL_ORGANIZATIONS: "ALL_ORGANIZATIONS",
  SPECIFIC_ORGANIZATIONS: "SPECIFIC_ORGANIZATIONS",
  BY_PLAN: "BY_PLAN",
  BY_ROLE: "BY_ROLE",
  SPECIFIC_USERS: "SPECIFIC_USERS"
};
var TicketCategory = {
  ORDER_ISSUE: "ORDER_ISSUE",
  TECHNICAL: "TECHNICAL",
  BILLING: "BILLING",
  FEATURE_REQUEST: "FEATURE_REQUEST",
  GENERAL: "GENERAL"
};
var TicketPriority = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  URGENT: "URGENT"
};
var TicketStatus = {
  OPEN: "OPEN",
  AWAITING_CUSTOMER: "AWAITING_CUSTOMER",
  AWAITING_SUPPORT: "AWAITING_SUPPORT",
  IN_PROGRESS: "IN_PROGRESS",
  RESOLVED: "RESOLVED",
  CLOSED: "CLOSED"
};
var MessageSenderType = {
  CUSTOMER: "CUSTOMER",
  SUPPORT: "SUPPORT",
  SYSTEM: "SYSTEM"
};
var ChatProvider = {
  INTERCOM: "INTERCOM",
  ZENDESK: "ZENDESK",
  FRESHDESK: "FRESHDESK",
  CRISP: "CRISP",
  TAWK: "TAWK",
  CUSTOM: "CUSTOM"
};
var QueueType = {
  ORDER_INGEST: "ORDER_INGEST",
  RENDER: "RENDER",
  EXPORT: "EXPORT",
  AUTO_PACK: "AUTO_PACK",
  ZIP: "ZIP",
  SYNC: "SYNC",
  CLEANUP: "CLEANUP"
};
var JobStatus = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED"
};
var WebhookStatus = {
  RECEIVED: "RECEIVED",
  PROCESSING: "PROCESSING",
  PROCESSED: "PROCESSED",
  FAILED: "FAILED",
  IGNORED: "IGNORED"
};
var OptionUIType = {
  DROPDOWN: "DROPDOWN",
  COLOR_SWATCH: "COLOR_SWATCH",
  BUTTON_GROUP: "BUTTON_GROUP",
  RADIO: "RADIO",
  IMAGE_CARD: "IMAGE_CARD"
};
var ProductOptionType = {
  // Legacy (pre custom-product-options). Kept so historical rows stay valid.
  STRING: "STRING",
  BOOLEAN: "BOOLEAN",
  NUMBER: "NUMBER",
  SELECT: "SELECT",
  // Custom product options.
  TEXT: "TEXT",
  TEXTAREA: "TEXTAREA",
  CHECKBOX: "CHECKBOX",
  CHECKBOX_GROUP: "CHECKBOX_GROUP",
  RADIO: "RADIO",
  SWATCH: "SWATCH",
  BUTTON_GROUP: "BUTTON_GROUP",
  DATE: "DATE",
  FILE_UPLOAD: "FILE_UPLOAD",
  IMAGE_UPLOAD_SIZED: "IMAGE_UPLOAD_SIZED",
  GANGSHEET_UPLOAD_SIZED: "GANGSHEET_UPLOAD_SIZED",
  CUSTOM_SIZE: "CUSTOM_SIZE",
  INFO: "INFO"
};
var ProductOptionRole = {
  ADDON: "ADDON",
  VARIANT_SELECTOR: "VARIANT_SELECTOR"
};
var PriceDeltaMode = {
  NONE: "NONE",
  PER_UNIT: "PER_UNIT",
  PER_LINE: "PER_LINE",
  PERCENT_OF_VARIANT: "PERCENT_OF_VARIANT"
};

// src/types/rbac.ts
var OrgResource = {
  ORGANIZATION: "organization",
  MEMBER: "member",
  ROLE: "role",
  CONNECTION: "connection",
  PRODUCT: "product",
  ORDER: "order",
  DESIGN: "design",
  WALLET: "wallet",
  INVOICE: "invoice",
  TICKET: "ticket",
  SETTINGS: "settings",
  ANALYTICS: "analytics",
  NOTIFICATION: "notification"
};
var AdminResource = {
  ADMIN_USER: "admin_user",
  ADMIN_ROLE: "admin_role",
  ORGANIZATION: "organization",
  USER: "user",
  ORDER: "order",
  PRODUCT_TEMPLATE: "product_template",
  PRICING: "pricing",
  PROVIDER: "provider",
  WAREHOUSE: "warehouse",
  SHIPPING: "shipping",
  WEBHOOK: "webhook",
  JOB: "job",
  AUDIT_LOG: "audit_log",
  SETTINGS: "settings",
  ANALYTICS: "analytics",
  SUPPORT_TICKET: "support_ticket",
  OPTION_TYPE: "option_type",
  PROVIDER_VARIANT: "provider_variant",
  NOTIFICATION: "notification",
  LIBRARY: "library",
  API_KEY: "apikeys",
  /** Ops-health anomaly center (order reconciliation findings). */
  ANOMALY: "anomaly"
};
var Action = {
  CREATE: "create",
  READ: "read",
  UPDATE: "update",
  DELETE: "delete",
  LIST: "list",
  /** Full management (implies all CRUD + extra) */
  MANAGE: "manage"
};
var ExtendedAction = {
  // Organization
  INVITE: "invite",
  REMOVE_MEMBER: "remove_member",
  CHANGE_ROLE: "change_role",
  // Orders
  CANCEL: "cancel",
  HOLD: "hold",
  RELEASE_HOLD: "release_hold",
  EXPORT: "export",
  ASSIGN_PROVIDER: "assign_provider",
  ROUTING_OVERRIDE: "routing_override",
  // Wallet
  TOP_UP: "top_up",
  REFUND: "refund",
  ADJUST: "adjust",
  // Provider
  HARD_DELETE: "hard_delete",
  // Admin
  SUSPEND: "suspend",
  ACTIVATE: "activate",
  IMPERSONATE: "impersonate",
  // Orders — provider-scoped
  UPDATE_STATUS: "update_status",
  // Library
  WRITE: "write",
  ADMIN: "admin"
};
function buildPermission(resource, action) {
  return `${resource}:${action}`;
}
function parsePermission(permission) {
  const [resource, action] = permission.split(":");
  if (!resource || !action) {
    throw new Error(`Invalid permission format: "${permission}". Expected "resource:action".`);
  }
  return { resource, action };
}
function hasPermission(userPermissions, required) {
  if (userPermissions.includes(required)) return true;
  const { resource } = parsePermission(required);
  return userPermissions.includes(buildPermission(resource, Action.MANAGE));
}
function hasAllPermissions(userPermissions, required) {
  const missing = required.filter((p) => !hasPermission(userPermissions, p));
  return {
    allowed: missing.length === 0,
    missing: missing.length > 0 ? missing : void 0
  };
}
function hasAnyPermission(userPermissions, required) {
  return required.some((p) => hasPermission(userPermissions, p));
}

// src/types/product.ts
var DYNAMIC_OPTION_PRODUCT_TYPES = /* @__PURE__ */ new Set([
  "APPAREL",
  "DRINKWARE",
  "ACCESSORIES",
  "DTF_BY_SIZE",
  "GANGSHEET"
]);

// src/types/money.ts
var SUPPORTED_CURRENCIES = ["USD"];
var CURRENCY_FRACTION_DIGITS = {
  USD: 2
};
var MoneyError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "MoneyError";
  }
};
function assertCurrency(currency) {
  if (!SUPPORTED_CURRENCIES.includes(currency)) {
    throw new MoneyError(`Unsupported currency: ${currency}`);
  }
}
function assertSameCurrency(a, b) {
  if (a.currency !== b.currency) {
    throw new MoneyError(
      `Currency mismatch: ${a.currency} vs ${b.currency}`
    );
  }
}
function moneyFromCents(amountCents, currency = "USD") {
  assertCurrency(currency);
  const cents = typeof amountCents === "bigint" ? amountCents : BigInt(amountCents);
  return Object.freeze({ amountCents: cents, currency });
}
function zeroMoney(currency = "USD") {
  return moneyFromCents(0n, currency);
}
function moneyFromDecimalString(decimal, currency = "USD") {
  assertCurrency(currency);
  const fractionDigits = CURRENCY_FRACTION_DIGITS[currency];
  const trimmed2 = decimal.trim();
  if (!/^-?\d+(\.\d+)?$/.test(trimmed2)) {
    throw new MoneyError(`Invalid decimal string: ${decimal}`);
  }
  const [intPart, fracPart = ""] = trimmed2.split(".");
  if (fracPart.length > fractionDigits) {
    throw new MoneyError(
      `Decimal has more fractional digits than ${currency} supports`
    );
  }
  const padded = fracPart.padEnd(fractionDigits, "0");
  const sign = intPart.startsWith("-") ? -1n : 1n;
  const intMagnitude = intPart.replace(/^-/, "");
  const cents = sign * (BigInt(intMagnitude) * 10n ** BigInt(fractionDigits) + BigInt(padded));
  return moneyFromCents(cents, currency);
}
function moneyToDecimalString(money) {
  const fractionDigits = CURRENCY_FRACTION_DIGITS[money.currency];
  const negative = money.amountCents < 0n;
  const magnitude = negative ? -money.amountCents : money.amountCents;
  const divisor = 10n ** BigInt(fractionDigits);
  const wholePart = magnitude / divisor;
  const fracPart = magnitude % divisor;
  const fracStr = fracPart.toString().padStart(fractionDigits, "0");
  return `${negative ? "-" : ""}${wholePart.toString()}.${fracStr}`;
}
function moneyToDto(money) {
  return {
    amountCents: money.amountCents.toString(),
    currency: money.currency
  };
}
function moneyFromDto(dto) {
  assertCurrency(dto.currency);
  if (!/^-?\d+$/.test(dto.amountCents)) {
    throw new MoneyError(`Invalid amountCents string: ${dto.amountCents}`);
  }
  return moneyFromCents(BigInt(dto.amountCents), dto.currency);
}
function addMoney(a, b) {
  assertSameCurrency(a, b);
  return moneyFromCents(a.amountCents + b.amountCents, a.currency);
}
function subtractMoney(a, b) {
  assertSameCurrency(a, b);
  return moneyFromCents(a.amountCents - b.amountCents, a.currency);
}
function negateMoney(m) {
  return moneyFromCents(-m.amountCents, m.currency);
}
function compareMoney(a, b) {
  assertSameCurrency(a, b);
  if (a.amountCents < b.amountCents) return -1;
  if (a.amountCents > b.amountCents) return 1;
  return 0;
}
var moneyIsZero = (m) => m.amountCents === 0n;
var moneyIsNegative = (m) => m.amountCents < 0n;
var moneyIsPositive = (m) => m.amountCents > 0n;
function formatMoney(money, options = {}) {
  const fractionDigits = CURRENCY_FRACTION_DIGITS[money.currency];
  const locale = options.locale ?? "en-US";
  const negative = money.amountCents < 0n;
  const magnitude = negative ? -money.amountCents : money.amountCents;
  const divisor = 10n ** BigInt(fractionDigits);
  const whole = Number(magnitude / divisor);
  const frac = Number(magnitude % divisor) / Number(divisor);
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: money.currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });
  const formatted = formatter.format(whole + frac);
  if (negative) return `-${formatted}`;
  if (options.sign === "always" && money.amountCents > 0n) return `+${formatted}`;
  return formatted;
}
function formatMoneyDto(dto, options) {
  return formatMoney(moneyFromDto(dto), options);
}
function formatCentsString(amountCentsString, currency = "USD", options) {
  return formatMoney(moneyFromDto({ amountCents: amountCentsString, currency }), options);
}

// src/types/error.ts
var AuthErrorCode = {
  TOKEN_EXPIRED: "AUTH_TOKEN_EXPIRED",
  TOKEN_INVALID: "AUTH_TOKEN_INVALID",
  TOKEN_VERSION_MISMATCH: "AUTH_TOKEN_VERSION_MISMATCH",
  REFRESH_TOKEN_EXPIRED: "AUTH_REFRESH_TOKEN_EXPIRED",
  REFRESH_TOKEN_INVALID: "AUTH_REFRESH_TOKEN_INVALID",
  REFRESH_TOKEN_REUSE: "AUTH_REFRESH_TOKEN_REUSE",
  CSRF_MISSING: "AUTH_CSRF_MISSING",
  CSRF_INVALID: "AUTH_CSRF_INVALID",
  CREDENTIALS_INVALID: "AUTH_CREDENTIALS_INVALID",
  EMAIL_NOT_VERIFIED: "AUTH_EMAIL_NOT_VERIFIED",
  ACCOUNT_SUSPENDED: "AUTH_ACCOUNT_SUSPENDED",
  ACCOUNT_DELETED: "AUTH_ACCOUNT_DELETED",
  SESSION_LIMIT_EXCEEDED: "AUTH_SESSION_LIMIT_EXCEEDED",
  TWO_FACTOR_REQUIRED: "AUTH_TWO_FACTOR_REQUIRED",
  TWO_FACTOR_INVALID: "AUTH_TWO_FACTOR_INVALID",
  UNAUTHORIZED: "AUTH_UNAUTHORIZED",
  FORBIDDEN: "AUTH_FORBIDDEN"
};
var ValidationErrorCode = {
  VALIDATION_FAILED: "VALIDATION_FAILED",
  INVALID_INPUT: "INVALID_INPUT",
  MISSING_REQUIRED_FIELD: "MISSING_REQUIRED_FIELD",
  INVALID_FORMAT: "INVALID_FORMAT"
};
var ResourceErrorCode = {
  NOT_FOUND: "RESOURCE_NOT_FOUND",
  ALREADY_EXISTS: "RESOURCE_ALREADY_EXISTS",
  CONFLICT: "RESOURCE_CONFLICT",
  GONE: "RESOURCE_GONE"
};
var RateLimitErrorCode = {
  RATE_LIMITED: "RATE_LIMITED",
  TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS"
};
var ServerErrorCode = {
  INTERNAL_ERROR: "INTERNAL_ERROR",
  SERVICE_UNAVAILABLE: "SERVICE_UNAVAILABLE",
  EXTERNAL_SERVICE_ERROR: "EXTERNAL_SERVICE_ERROR"
};
var TenantErrorCode = {
  ORG_NOT_FOUND: "TENANT_ORG_NOT_FOUND",
  ORG_SUSPENDED: "TENANT_ORG_SUSPENDED",
  ORG_ACCESS_DENIED: "TENANT_ORG_ACCESS_DENIED",
  MEMBER_NOT_FOUND: "TENANT_MEMBER_NOT_FOUND",
  ROLE_NOT_FOUND: "TENANT_ROLE_NOT_FOUND"
};
var WebhookErrorCode = {
  SIGNATURE_INVALID: "WEBHOOK_SIGNATURE_INVALID",
  TIMESTAMP_EXPIRED: "WEBHOOK_TIMESTAMP_EXPIRED",
  DUPLICATE_EVENT: "WEBHOOK_DUPLICATE_EVENT",
  PROCESSING_FAILED: "WEBHOOK_PROCESSING_FAILED"
};

// src/types/state-machine.ts
var ORDER_TRANSITIONS = {
  DRAFT: ["NEW", "CANCELLED"],
  NEW: ["DESIGN_PENDING", "IN_PRODUCTION", "ON_HOLD", "FRAUD_HOLD", "CANCELLED"],
  DESIGN_PENDING: ["DESIGN_ATTACHED", "IN_PRODUCTION", "ON_HOLD", "FRAUD_HOLD", "CANCELLED"],
  DESIGN_ATTACHED: ["EXPORT_QUEUED", "IN_PRODUCTION", "ON_HOLD", "CANCELLED"],
  EXPORT_QUEUED: ["EXPORT_PROCESSING", "ON_HOLD", "CANCELLED"],
  EXPORT_PROCESSING: ["EXPORTED", "EXPORT_FAILED", "ON_HOLD"],
  EXPORTED: ["IN_PRODUCTION", "ON_HOLD"],
  // Export failed (recoverable). The "Regenerate exports" action drives the
  // EXPORT_FAILED → EXPORT_QUEUED path via OrderExportService (with its own
  // guard), so it is intentionally NOT a generic forward transition here.
  EXPORT_FAILED: ["ON_HOLD", "CANCELLED"],
  IN_PRODUCTION: ["PRODUCTION_DONE", "READY_TO_SHIP", "ON_HOLD", "CANCEL_REQUESTED"],
  PRODUCTION_DONE: ["READY_TO_SHIP", "ON_HOLD", "CANCEL_REQUESTED"],
  READY_TO_SHIP: ["SHIPPED", "ON_HOLD", "CANCEL_REQUESTED"],
  SHIPPED: ["DELIVERED", "FAILED"],
  // ON_HOLD / FRAUD_HOLD exits are dynamic — resolved via previousStatus stored on the order
  ON_HOLD: [],
  FRAUD_HOLD: [],
  CANCEL_REQUESTED: ["CANCELLED", "IN_PRODUCTION"],
  // Manual fulfillment hold (entered at ingest). Released ONLY by the Shopify
  // "Request fulfillment" webhook — the release computes the correct target
  // based on export progress (exports keep running during the hold). No
  // manual forward buttons in the UI (auto-managed); cancel stays available.
  AWAITING_FULFILLMENT_REQUEST: [
    "NEW",
    "DESIGN_PENDING",
    "EXPORT_QUEUED",
    "EXPORT_PROCESSING",
    "EXPORTED",
    "ON_HOLD",
    "CANCELLED"
  ],
  DELIVERED: [],
  CANCELLED: [],
  FAILED: []
};
var PROVIDER_TRANSITIONS = {
  NEW: { next: "DESIGN_PENDING", label: "Acknowledge Order" },
  DESIGN_PENDING: { next: "IN_PRODUCTION", label: "Start Production" },
  IN_PRODUCTION: { next: "PRODUCTION_DONE", label: "Mark Produced" },
  PRODUCTION_DONE: { next: "READY_TO_SHIP", label: "Ready to Ship" },
  READY_TO_SHIP: { next: "SHIPPED", label: "Mark as Shipped" }
};
var PROVIDER_REJECT_STATUSES = /* @__PURE__ */ new Set([
  "NEW",
  "DESIGN_PENDING",
  "IN_PRODUCTION",
  "PRODUCTION_DONE"
]);
var ORDER_TERMINAL_STATUSES = /* @__PURE__ */ new Set([
  "DELIVERED",
  "CANCELLED",
  "FAILED"
]);
var ORDER_DANGER_STATUSES = /* @__PURE__ */ new Set([
  "CANCELLED",
  "CANCEL_REQUESTED",
  "FAILED"
]);
var SHIPMENT_TRANSITIONS = {
  PENDING: ["LABEL_CREATED", "PICKED_UP", "IN_TRANSIT", "CANCELLED"],
  LABEL_CREATED: ["PICKED_UP", "IN_TRANSIT", "CANCELLED"],
  PICKED_UP: ["IN_TRANSIT"],
  IN_TRANSIT: ["OUT_FOR_DELIVERY", "DELIVERED", "EXCEPTION", "RETURNED"],
  OUT_FOR_DELIVERY: ["DELIVERED", "EXCEPTION", "RETURNED"],
  EXCEPTION: ["IN_TRANSIT", "RETURNED"],
  DELIVERED: [],
  RETURNED: [],
  CANCELLED: []
};
var SHIPMENT_TERMINAL_STATUSES = /* @__PURE__ */ new Set([
  "DELIVERED",
  "RETURNED",
  "CANCELLED"
]);
var ORDER_AUTO_MANAGED_STATUSES = /* @__PURE__ */ new Set([
  "EXPORT_QUEUED",
  "EXPORT_PROCESSING",
  // Released exclusively by the Shopify "Request fulfillment" webhook —
  // operators must not push the order forward manually.
  "AWAITING_FULFILLMENT_REQUEST"
]);
var ORDER_PRIMARY_TRANSITION = {
  DRAFT: "NEW",
  NEW: "DESIGN_PENDING",
  DESIGN_PENDING: "DESIGN_ATTACHED",
  DESIGN_ATTACHED: "EXPORT_QUEUED",
  EXPORT_QUEUED: "EXPORT_PROCESSING",
  EXPORT_PROCESSING: "EXPORTED",
  EXPORTED: "IN_PRODUCTION",
  IN_PRODUCTION: "PRODUCTION_DONE",
  PRODUCTION_DONE: "READY_TO_SHIP",
  READY_TO_SHIP: "SHIPPED",
  SHIPPED: "DELIVERED",
  ON_HOLD: null,
  FRAUD_HOLD: null,
  CANCEL_REQUESTED: "CANCELLED",
  AWAITING_FULFILLMENT_REQUEST: null
};
var ORDER_STATUS_VARIANT = {
  DRAFT: "default",
  NEW: "primary",
  DESIGN_PENDING: "warning",
  DESIGN_ATTACHED: "warning",
  EXPORT_QUEUED: "info",
  EXPORT_PROCESSING: "info",
  EXPORTED: "info",
  EXPORT_FAILED: "danger",
  IN_PRODUCTION: "warning",
  PRODUCTION_DONE: "info",
  READY_TO_SHIP: "info",
  SHIPPED: "success",
  DELIVERED: "success",
  CANCELLED: "danger",
  ON_HOLD: "default",
  FRAUD_HOLD: "danger",
  CANCEL_REQUESTED: "danger",
  FAILED: "danger",
  AWAITING_FULFILLMENT_REQUEST: "warning"
};
var ORDER_STATUS_LABELS = {
  DRAFT: "Draft",
  NEW: "New",
  DESIGN_PENDING: "Design Pending",
  DESIGN_ATTACHED: "Design Ready",
  EXPORT_QUEUED: "Export Queued",
  EXPORT_PROCESSING: "Exporting",
  EXPORTED: "Exported",
  EXPORT_FAILED: "Export Failed",
  IN_PRODUCTION: "In Production",
  PRODUCTION_DONE: "Produced",
  READY_TO_SHIP: "Ready to Ship",
  SHIPPED: "Shipped",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled",
  ON_HOLD: "On Hold",
  FRAUD_HOLD: "Fraud Hold",
  CANCEL_REQUESTED: "Cancel Requested",
  FAILED: "Failed",
  AWAITING_FULFILLMENT_REQUEST: "Awaiting Approval"
};
var ORDER_STATUS_MERCHANT_LABELS = {
  ...ORDER_STATUS_LABELS,
  EXPORT_QUEUED: "Order Processing",
  EXPORT_PROCESSING: "Order Processing",
  EXPORTED: "Order Processing",
  EXPORT_FAILED: "Order Processing",
  IN_PRODUCTION: "Order Processing",
  PRODUCTION_DONE: "Order Processing",
  READY_TO_SHIP: "In Production"
};
var ORDER_STATUS_MERCHANT_VARIANT = {
  ...ORDER_STATUS_VARIANT,
  EXPORT_QUEUED: "info",
  EXPORT_PROCESSING: "info",
  EXPORTED: "info",
  EXPORT_FAILED: "info",
  IN_PRODUCTION: "info",
  PRODUCTION_DONE: "info",
  READY_TO_SHIP: "warning"
};
function getMerchantOrderStatusLabel(status) {
  return ORDER_STATUS_MERCHANT_LABELS[status] ?? status;
}
function isMerchantMaskedDanger(status) {
  return ORDER_STATUS_VARIANT[status] === "danger" && ORDER_STATUS_MERCHANT_VARIANT[status] !== "danger";
}
var MERCHANT_ORDER_PROCESSING_STATUSES = [
  "EXPORT_QUEUED",
  "EXPORT_PROCESSING",
  "EXPORTED",
  "EXPORT_FAILED",
  "IN_PRODUCTION",
  "PRODUCTION_DONE"
];
var ORDER_TRANSITION_LABELS = {
  NEW: "Approve Order",
  DESIGN_PENDING: "Move to Design Pending",
  DESIGN_ATTACHED: "Mark Design Attached",
  EXPORT_QUEUED: "Queue for Export",
  EXPORT_PROCESSING: "Start Export",
  EXPORTED: "Mark Exported",
  IN_PRODUCTION: "Start Production",
  PRODUCTION_DONE: "Mark as Produced",
  READY_TO_SHIP: "Mark Ready to Ship",
  SHIPPED: "Mark as Shipped",
  DELIVERED: "Mark as Delivered",
  CANCELLED: "Cancel Order",
  CANCEL_REQUESTED: "Request Cancellation",
  FAILED: "Mark as Failed",
  ON_HOLD: "Put on Hold"
};
var ORDER_STATUS_DESCRIPTIONS = {
  DRAFT: "Order is in draft state.",
  NEW: "New order, awaiting processing.",
  DESIGN_PENDING: "Waiting for design files.",
  DESIGN_ATTACHED: "Design ready, can start production.",
  EXPORT_QUEUED: "Order queued for export processing.",
  EXPORT_PROCESSING: "Export in progress.",
  EXPORTED: "Export complete, ready for production.",
  EXPORT_FAILED: "Print file export failed. Regenerate to retry.",
  IN_PRODUCTION: "Order is being produced.",
  PRODUCTION_DONE: "Production complete.",
  READY_TO_SHIP: "Ready for shipment.",
  SHIPPED: "Order has been shipped.",
  DELIVERED: "Order delivered to customer.",
  CANCELLED: "Order has been cancelled.",
  ON_HOLD: "Order is paused. Release to continue.",
  FRAUD_HOLD: "Order flagged for fraud review.",
  CANCEL_REQUESTED: "Cancellation requested, pending confirmation.",
  FAILED: "Order has failed.",
  AWAITING_FULFILLMENT_REQUEST: 'Waiting for the merchant to click "Request fulfillment" in their Shopify admin.'
};
var ORDER_STATUS_FLOW = [
  "DRAFT",
  "NEW",
  "DESIGN_PENDING",
  "DESIGN_ATTACHED",
  "EXPORT_QUEUED",
  "EXPORT_PROCESSING",
  "EXPORTED",
  "IN_PRODUCTION",
  "PRODUCTION_DONE",
  "READY_TO_SHIP",
  "SHIPPED",
  "DELIVERED"
];
var SHIPMENT_STATUS_VARIANT = {
  PENDING: "default",
  LABEL_CREATED: "info",
  PICKED_UP: "info",
  IN_TRANSIT: "primary",
  OUT_FOR_DELIVERY: "warning",
  DELIVERED: "success",
  EXCEPTION: "danger",
  RETURNED: "danger",
  CANCELLED: "danger"
};
var SHIPMENT_STATUS_LABELS = {
  PENDING: "Pending",
  LABEL_CREATED: "Label Created",
  PICKED_UP: "Picked Up",
  IN_TRANSIT: "In Transit",
  OUT_FOR_DELIVERY: "Out for Delivery",
  DELIVERED: "Delivered",
  EXCEPTION: "Exception",
  RETURNED: "Returned",
  CANCELLED: "Cancelled"
};
function isValidOrderTransition(from, to) {
  return (ORDER_TRANSITIONS[from] ?? []).includes(to);
}
function isValidShipmentTransition(from, to) {
  return (SHIPMENT_TRANSITIONS[from] ?? []).includes(to);
}
function isOrderTerminal(status) {
  return ORDER_TERMINAL_STATUSES.has(status);
}
function isShipmentTerminal(status) {
  return SHIPMENT_TERMINAL_STATUSES.has(status);
}
function getProviderTransition(status) {
  return PROVIDER_TRANSITIONS[status] ?? null;
}
function canProviderReject(status) {
  return PROVIDER_REJECT_STATUSES.has(status);
}
function getOrderTransitionLists(status) {
  const transitions = ORDER_TRANSITIONS[status] ?? [];
  const sorted = [...transitions].sort((a, b) => {
    const ai = ORDER_STATUS_FLOW.indexOf(a);
    const bi = ORDER_STATUS_FLOW.indexOf(b);
    if (ai === -1 && bi === -1) return 0;
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });
  const isAutoManaged = ORDER_AUTO_MANAGED_STATUSES.has(status);
  const forwardTransitions = isAutoManaged ? [] : sorted.filter((t) => !ORDER_DANGER_STATUSES.has(t) && t !== "ON_HOLD");
  const holdTransition = sorted.find((t) => t === "ON_HOLD") ?? null;
  const dangerTransitions = sorted.filter((t) => ORDER_DANGER_STATUSES.has(t));
  const isOnHold = status === "ON_HOLD";
  const isTerminal = ORDER_TERMINAL_STATUSES.has(status);
  const primaryTarget = ORDER_PRIMARY_TRANSITION[status];
  const primaryTransition = isAutoManaged ? null : primaryTarget && transitions.includes(primaryTarget) ? primaryTarget : null;
  return {
    forwardTransitions,
    holdTransition,
    dangerTransitions,
    isOnHold,
    isTerminal,
    isAutoManaged,
    primaryTransition,
    hasAnyActions: forwardTransitions.length > 0 || !!holdTransition || dangerTransitions.length > 0 || isOnHold
  };
}
var EDITABLE_STATUSES = {
  address: /* @__PURE__ */ new Set([
    "DRAFT",
    "NEW",
    "DESIGN_PENDING",
    "DESIGN_ATTACHED",
    "EXPORT_QUEUED",
    "EXPORT_PROCESSING",
    "EXPORTED",
    // Manual hold happens before routing/production — address still editable.
    "AWAITING_FULFILLMENT_REQUEST"
  ]),
  items: /* @__PURE__ */ new Set([
    "DRAFT",
    "NEW",
    "DESIGN_PENDING",
    "DESIGN_ATTACHED",
    // Once the order enters EXPORT_QUEUED, OrderExportService locks the
    // underlying Design (`isLocked: true`). Editing items at that point
    // would invalidate the pending export job, so we block it in the UI.
    // EXPORTED is kept editable because the render is done and the user
    // can still swap items before transitioning to IN_PRODUCTION (a new
    // export will be queued if items change).
    "EXPORTED"
  ]),
  notes: /* @__PURE__ */ new Set([
    "DRAFT",
    "NEW",
    "DESIGN_PENDING",
    "DESIGN_ATTACHED",
    "EXPORT_QUEUED",
    "EXPORT_PROCESSING",
    "EXPORTED",
    "IN_PRODUCTION",
    "PRODUCTION_DONE",
    "READY_TO_SHIP",
    "SHIPPED",
    "DELIVERED",
    "ON_HOLD",
    "FRAUD_HOLD",
    "CANCEL_REQUESTED",
    "AWAITING_FULFILLMENT_REQUEST"
  ]),
  tags: /* @__PURE__ */ new Set([
    "DRAFT",
    "NEW",
    "DESIGN_PENDING",
    "DESIGN_ATTACHED",
    "EXPORT_QUEUED",
    "EXPORT_PROCESSING",
    "EXPORTED",
    "IN_PRODUCTION",
    "PRODUCTION_DONE",
    "READY_TO_SHIP",
    "SHIPPED",
    "DELIVERED",
    "ON_HOLD",
    "FRAUD_HOLD",
    "CANCEL_REQUESTED",
    "AWAITING_FULFILLMENT_REQUEST"
  ])
};
function isEditable(status, field) {
  return EDITABLE_STATUSES[field]?.has(status) ?? false;
}
function getCancelAbility(status) {
  if ([
    "DRAFT",
    "NEW",
    "DESIGN_PENDING",
    "DESIGN_ATTACHED",
    "EXPORT_QUEUED",
    // Pre-approval hold — nothing routed/charged yet, direct cancel is safe.
    "AWAITING_FULFILLMENT_REQUEST"
  ].includes(status)) return "direct";
  if (["IN_PRODUCTION", "PRODUCTION_DONE", "READY_TO_SHIP"].includes(status)) return "request";
  return "none";
}

// src/types/apparel-render-job.ts
var APPAREL_RENDER_QUEUE = "apparel-render";
var APPAREL_LIBRARY_PREVIEW_QUEUE = "apparel-library-preview";
var APPAREL_RENDER_JOB = {
  PRINT_EXPORT: "print-export",
  VARIANT_PREVIEW: "variant-preview"
};
var APPAREL_LIBRARY_PREVIEW_JOB = "library-preview";
var JOB_ID_SEP = "__";
function printExportJobId(designId, printAreaId, dimsKey, renderRevision) {
  const parts = [APPAREL_RENDER_JOB.PRINT_EXPORT, designId, printAreaId];
  if (dimsKey) parts.push(dimsKey);
  if (renderRevision != null) parts.push(`r${renderRevision}`);
  return parts.join(JOB_ID_SEP);
}
function variantPreviewJobId(designId, productVariantId, printAreaId, renderRevision) {
  const parts = [
    APPAREL_RENDER_JOB.VARIANT_PREVIEW,
    designId,
    productVariantId,
    printAreaId
  ];
  if (renderRevision != null) parts.push(`r${renderRevision}`);
  return parts.join(JOB_ID_SEP);
}
function libraryPreviewJobId(libraryDesignId) {
  return [APPAREL_LIBRARY_PREVIEW_JOB, libraryDesignId].join(JOB_ID_SEP);
}

// src/types/shopify-media-sync-job.ts
var SHOPIFY_MEDIA_SYNC_QUEUE = "shopify-media-sync";
var SHOPIFY_MEDIA_SYNC_JOB = "product-media-sync";
var JOB_ID_SEP2 = "__";
function shopifyMediaSyncJobId(productId) {
  return [SHOPIFY_MEDIA_SYNC_JOB, productId].join(JOB_ID_SEP2);
}

// src/types/shopify-cost-sync-job.ts
var SHOPIFY_COST_SYNC_QUEUE = "shopify-cost-sync";
var SHOPIFY_COST_SYNC_JOB = "product-cost-sync";
var JOB_ID_SEP3 = "__";
function shopifyCostSyncJobId(productId) {
  return [SHOPIFY_COST_SYNC_JOB, productId].join(JOB_ID_SEP3);
}

// src/types/shopify-product-publish-job.ts
var SHOPIFY_PRODUCT_PUBLISH_QUEUE = "shopify-product-publish";
var SHOPIFY_PRODUCT_PUBLISH_JOB = "product-publish";
var JOB_ID_SEP4 = "__";
function shopifyProductPublishJobId(productId) {
  return [SHOPIFY_PRODUCT_PUBLISH_JOB, productId].join(JOB_ID_SEP4);
}

// src/types/shopify-fulfillment-sync-job.ts
var SHOPIFY_FULFILLMENT_SYNC_QUEUE = "shopify-fulfillment-sync";
var SHOPIFY_FULFILLMENT_SYNC_JOB = "product-fulfillment-sync";
var JOB_ID_SEP5 = "__";
function shopifyFulfillmentSyncJobId(productId) {
  return [SHOPIFY_FULFILLMENT_SYNC_JOB, productId].join(JOB_ID_SEP5);
}

// src/types/shopify-launch-config-backfill-job.ts
var SHOPIFY_LAUNCH_CONFIG_BACKFILL_QUEUE = "shopify-launch-config-backfill";
var SHOPIFY_LAUNCH_CONFIG_BACKFILL_JOB = "launch-config-backfill";
var JOB_ID_SEP6 = "__";
function shopifyLaunchConfigBackfillJobId(shopDomain) {
  return [SHOPIFY_LAUNCH_CONFIG_BACKFILL_JOB, shopDomain.toLowerCase()].join(
    JOB_ID_SEP6
  );
}

// src/types/shopify-branding-sync-job.ts
var SHOPIFY_BRANDING_SYNC_QUEUE = "shopify-branding-sync";

// src/utils/design-refs.ts
var ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
var TOKEN_LENGTH = 14;
var DESIGN_REF_ID_REGEX = /^DR_[A-HJ-NP-Za-km-z2-9]{14}$/;
var ORDER_SUMMARY_TOKEN_REGEX = /^OS_[A-HJ-NP-Za-km-z2-9]{14}$/;
var ORDER_EXPORT_TOKEN_REGEX = /^OE_[A-HJ-NP-Za-km-z2-9]{14}$/;
var REJECTION_CUTOFF = 256 - 256 % ALPHABET.length;
function generateToken(prefix) {
  const cryptoObj = typeof globalThis !== "undefined" ? globalThis.crypto : void 0;
  if (!cryptoObj || typeof cryptoObj.getRandomValues !== "function") {
    throw new Error(
      "generateToken: secure RNG (globalThis.crypto.getRandomValues) is required"
    );
  }
  let out = "";
  while (out.length < TOKEN_LENGTH) {
    const need = TOKEN_LENGTH - out.length;
    const batch = new Uint8Array(need + 4);
    cryptoObj.getRandomValues(batch);
    for (let i = 0; i < batch.length && out.length < TOKEN_LENGTH; i += 1) {
      const b = batch[i];
      if (b < REJECTION_CUTOFF) {
        out += ALPHABET[b % ALPHABET.length];
      }
    }
  }
  return `${prefix}${out}`;
}
function generateDesignRefId() {
  return generateToken("DR_");
}
function isValidDesignRefId(value) {
  return typeof value === "string" && DESIGN_REF_ID_REGEX.test(value);
}
function generateOrderSummaryToken() {
  return generateToken("OS_");
}
function isValidOrderSummaryToken(value) {
  return typeof value === "string" && ORDER_SUMMARY_TOKEN_REGEX.test(value);
}
function generateOrderExportToken() {
  return generateToken("OE_");
}
function isValidOrderExportToken(value) {
  return typeof value === "string" && ORDER_EXPORT_TOKEN_REGEX.test(value);
}

// src/types/order-summary-pdf-job.ts
var ORDER_SUMMARY_PDF_QUEUE = "order-summary-pdf";
var ORDER_SUMMARY_PDF_JOB = "order-summary-pdf.generate";
var ORDER_SUMMARY_PDF_MAX_PREVIEW_RETRIES = 6;
var ORDER_SUMMARY_PDF_PREVIEW_RETRY_DELAY_MS = 2e4;
var JOB_ID_SEP7 = "__";
function orderSummaryPdfJobId(orderId, revision) {
  return ["order-summary-pdf", orderId, `r${revision}`].join(JOB_ID_SEP7);
}
function orderSummaryPdfStorageKey(args) {
  const safeNumber = args.orderNumber.replace(/[^A-Za-z0-9_-]+/g, "");
  return `orders/${args.orderId}/revisions/${args.revision}/order-${safeNumber}-summary.pdf`;
}
function buildOrderSummaryPdfUrl(args) {
  if (!args.apiBaseUrl) throw new Error("apiBaseUrl is required");
  if (!isValidOrderSummaryToken(args.token)) {
    throw new Error("Invalid order-summary token");
  }
  const base = args.apiBaseUrl.replace(/\/+$/, "");
  return `${base}/api/v1/public/orders/summary/${args.token}.pdf`;
}

// src/types/inkteo-submit-job.ts
var INKTEO_SUBMIT_QUEUE = "inkteo-submit";
var INKTEO_SUBMIT_JOB = "inkteo-submit";
var JOB_ID_SEP8 = "__";
function inkteoSubmitJobId(orderId) {
  return [INKTEO_SUBMIT_JOB, orderId].join(JOB_ID_SEP8);
}

// src/types/image-tools-job.ts
var IMAGE_TOOLS_QUEUE_NAMES = {
  /** Run an ordered operation pipeline over one source image. */
  PROCESS: "image-tools"
};
var IMAGE_TOOLS_JOB = {
  PROCESS: "image-tools-process"
};
var MAX_UPSCALE_PASSES = 2;
var IMAGE_TOOL_OPERATION_ORDER = [
  // sharp-upscale first for the same reason as AI upscale: every later stage
  // works better with more pixels. It never appears alongside AI upscale (the
  // API rejects the combination), so their relative order is moot.
  "sharp-upscale",
  "upscale",
  "bg-removal",
  // Vectorize last: it should trace the final artwork — after the background
  // is gone — not the backdrop.
  "vectorize"
];
var OPERATION_SIGNATURE_VERSION = {
  // v2: the model result is used as an alpha mask over the source pixels, and
  // the default model moved to a product-photo-trained one.
  // v3: default model moved to Ideogram after a bake-off showed Bria cutting
  // into non-background elements (white label plates on garment mockups).
  // v4: photographic artwork routes to the model even on a flat border, the
  // fringe is un-blended exactly against measured background colours, and the
  // model's rim colour estimate is used when the background is unknown
  // (white-halo fix).
  // v5: hole filling is off on the model path as well as the keyed path.
  // Ideogram already treats enclosed white (handle loops, letter counters)
  // as background; filling restored original white into those interiors.
  "bg-removal": 5
};
function imageToolPipelineSignature(operations) {
  return sortImageToolOperations(operations).map((operation) => {
    const base = operation.op === "upscale" || operation.op === "sharp-upscale" ? `${operation.op}-${operation.scale}x` : operation.op;
    const version = OPERATION_SIGNATURE_VERSION[operation.op];
    return version ? `${base}@${version}` : base;
  }).join("+");
}
function imageToolOpsFromSignature(signature) {
  const ops = [];
  for (const segment of signature.split("+")) {
    if (segment.startsWith("sharp-upscale-")) {
      ops.push("sharp-upscale");
    } else if (segment.startsWith("upscale-")) {
      ops.push("upscale");
    } else if (segment.startsWith("bg-removal")) {
      ops.push("bg-removal");
    } else if (segment.startsWith("vectorize")) {
      ops.push("vectorize");
    }
  }
  return ops;
}
function isMeteredImageToolPipeline(operations) {
  return operations.some((operation) => operation.op !== "sharp-upscale");
}
function sortImageToolOperations(operations) {
  return [...operations].sort(
    (a, b) => IMAGE_TOOL_OPERATION_ORDER.indexOf(a.op) - IMAGE_TOOL_OPERATION_ORDER.indexOf(b.op)
  );
}

// src/types/pod-product-types.ts
var SHOPIFY_TEMPLATE_CONTEXTS = [
  "PRODUCT",
  "STOREFRONT"
];
function isShopifyTemplateContext(value) {
  return typeof value === "string" && SHOPIFY_TEMPLATE_CONTEXTS.includes(value);
}
var DESIGN_CONTEXT_CARD_INFO = {
  PRODUCT: "Create a product with your own design",
  STOREFRONT: "Let your customers personalize and order with the built-in designer"
};
function cardInfoForDesignContext(context) {
  if (context === "STOREFRONT") {
    return DESIGN_CONTEXT_CARD_INFO.STOREFRONT;
  }
  return DESIGN_CONTEXT_CARD_INFO.PRODUCT;
}

// src/types/designer-branding.ts
import { z } from "zod";
var hexColorSchema = z.string().regex(/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/, "Must be a hex color like #2563eb");
var storageKeySchema = z.string().min(1).max(512).regex(/^[a-zA-Z0-9][a-zA-Z0-9._/-]*$/, "Invalid storage key").refine((v) => !v.includes(".."), "Invalid storage key");
var designerLogoVariantSchema = z.enum(["dark", "light", "auto"]);
var designerBrandingInputSchema = z.object({
  logoStorageKey: storageKeySchema.nullish(),
  lightLogoStorageKey: storageKeySchema.nullish(),
  defaultLogoVariant: designerLogoVariantSchema.optional(),
  accentColor: hexColorSchema.nullish(),
  buttonTextColor: hexColorSchema.nullish()
});
var EMPTY_RESOLVED_BRANDING = {
  logoUrl: null,
  lightLogoUrl: null,
  defaultLogoVariant: "auto",
  accentColor: null,
  buttonTextColor: null,
  storeName: null,
  source: "default"
};
function selectDesignerLogoUrl(branding, opts = {}) {
  const dark = branding.logoUrl ?? null;
  const light = branding.lightLogoUrl ?? null;
  switch (branding.defaultLogoVariant) {
    case "dark":
      return dark ?? light;
    case "light":
      return light ?? dark;
    case "auto":
    default:
      return opts.backgroundIsDark ? light ?? dark : dark ?? light;
  }
}
function resolveDesignerBrandingDisplay(branding, opts = {}) {
  const url = selectDesignerLogoUrl(branding, opts);
  if (url) return { kind: "logo", url };
  const name = branding.storeName?.trim();
  if (name) return { kind: "text", label: name };
  return { kind: "default" };
}

// src/types/designer-checkout.ts
import { z as z2 } from "zod";
var DESIGNER_CHECKOUT_QUESTION_TYPES = ["CHECKBOX", "SELECT", "TEXT"];
var DESIGNER_CHECKOUT_MAX_PER_TYPE = 2;
var DESIGNER_CHECKOUT_LIMITS = {
  messageMaxLength: 300,
  questionLabelMaxLength: 200,
  selectOptionMaxLength: 100,
  selectOptionsMax: 10,
  /** Short label used as the Shopify line item property KEY — keep it terse. */
  lineItemLabelMaxLength: 30
};
function isValidLineItemLabel(value) {
  const v = value.trim();
  if (v.length === 0 || v.length > DESIGNER_CHECKOUT_LIMITS.lineItemLabelMaxLength) {
    return false;
  }
  if (v.startsWith("_")) return false;
  if (v.includes("[") || v.includes("]")) return false;
  if (/[\u0000-\u001f\u007f]/.test(v)) return false;
  return true;
}
var EMPTY_RESOLVED_CHECKOUT = {
  printAnywayMessage: null,
  termsMessage: null,
  questions: []
};
var trimmedString = (max) => z2.string().trim().min(1, "Must not be empty").max(max, `Must be at most ${max} characters`);
var designerCheckoutQuestionInputSchema = z2.object({
  /** Absent on create — the service assigns a stable id. */
  id: z2.string().trim().min(1).max(64).optional(),
  type: z2.enum(["CHECKBOX", "SELECT", "TEXT"]),
  label: trimmedString(DESIGNER_CHECKOUT_LIMITS.questionLabelMaxLength),
  options: z2.array(trimmedString(DESIGNER_CHECKOUT_LIMITS.selectOptionMaxLength)).max(DESIGNER_CHECKOUT_LIMITS.selectOptionsMax).optional(),
  required: z2.boolean(),
  active: z2.boolean(),
  addToOrder: z2.boolean(),
  lineItemLabel: z2.string().trim().max(DESIGNER_CHECKOUT_LIMITS.lineItemLabelMaxLength).optional()
}).superRefine((q, ctx) => {
  if (q.type === "SELECT" && (!q.options || q.options.length < 2)) {
    ctx.addIssue({
      code: z2.ZodIssueCode.custom,
      message: "Select questions need at least 2 options",
      path: ["options"]
    });
  }
  if (q.addToOrder) {
    if (!q.lineItemLabel || !isValidLineItemLabel(q.lineItemLabel)) {
      ctx.addIssue({
        code: z2.ZodIssueCode.custom,
        message: `Questions added to the order need a short line item label (max ${DESIGNER_CHECKOUT_LIMITS.lineItemLabelMaxLength} characters, no leading underscore, no brackets)`,
        path: ["lineItemLabel"]
      });
    }
  } else if (q.lineItemLabel && !isValidLineItemLabel(q.lineItemLabel)) {
    ctx.addIssue({
      code: z2.ZodIssueCode.custom,
      message: `Line item label must be at most ${DESIGNER_CHECKOUT_LIMITS.lineItemLabelMaxLength} characters, with no leading underscore and no brackets`,
      path: ["lineItemLabel"]
    });
  }
});
var designerCheckoutInputSchema = z2.object({
  printAnywayMessage: trimmedString(
    DESIGNER_CHECKOUT_LIMITS.messageMaxLength
  ).nullish(),
  termsMessage: trimmedString(
    DESIGNER_CHECKOUT_LIMITS.messageMaxLength
  ).nullish(),
  questions: z2.array(designerCheckoutQuestionInputSchema).max(
    DESIGNER_CHECKOUT_MAX_PER_TYPE * DESIGNER_CHECKOUT_QUESTION_TYPES.length
  ).optional()
}).superRefine((input, ctx) => {
  if (!input.questions) return;
  for (const type of DESIGNER_CHECKOUT_QUESTION_TYPES) {
    const ofType = input.questions.filter((q) => q.type === type);
    if (ofType.length > DESIGNER_CHECKOUT_MAX_PER_TYPE) {
      ctx.addIssue({
        code: z2.ZodIssueCode.custom,
        message: `At most ${DESIGNER_CHECKOUT_MAX_PER_TYPE} ${type.toLowerCase()} questions are allowed`,
        path: ["questions"]
      });
    }
    const addToOrderCount = ofType.filter((q) => q.addToOrder).length;
    if (addToOrderCount > 1) {
      ctx.addIssue({
        code: z2.ZodIssueCode.custom,
        message: `Only one ${type.toLowerCase()} question can add its answer to the order line item`,
        path: ["questions"]
      });
    }
  }
});
function parseDesignerCheckoutStored(json) {
  if (!json || typeof json !== "object") return null;
  const obj = json;
  const result = {};
  if (typeof obj.printAnywayMessage === "string" && obj.printAnywayMessage.trim()) {
    result.printAnywayMessage = obj.printAnywayMessage;
  }
  if (typeof obj.termsMessage === "string" && obj.termsMessage.trim()) {
    result.termsMessage = obj.termsMessage;
  }
  if (Array.isArray(obj.questions)) {
    const questions = [];
    for (const raw of obj.questions) {
      const q = parseQuestion(raw);
      if (q) questions.push(q);
    }
    if (questions.length > 0) result.questions = questions;
  }
  if (typeof obj.updatedAt === "string") result.updatedAt = obj.updatedAt;
  return Object.keys(result).length > 0 ? result : null;
}
function parseQuestion(raw) {
  if (!raw || typeof raw !== "object") return null;
  const q = raw;
  if (typeof q.id !== "string" || !q.id) return null;
  if (q.type !== "CHECKBOX" && q.type !== "SELECT" && q.type !== "TEXT") return null;
  if (typeof q.label !== "string" || !q.label.trim()) return null;
  const options = Array.isArray(q.options) ? q.options.filter((o) => typeof o === "string" && o.trim().length > 0) : void 0;
  if (q.type === "SELECT" && (!options || options.length < 2)) return null;
  const lineItemLabel = typeof q.lineItemLabel === "string" && isValidLineItemLabel(q.lineItemLabel) ? q.lineItemLabel.trim() : void 0;
  return {
    id: q.id,
    type: q.type,
    label: q.label,
    ...q.type === "SELECT" ? { options } : {},
    required: q.required === true,
    active: q.active !== false,
    addToOrder: q.addToOrder === true,
    ...lineItemLabel ? { lineItemLabel } : {}
  };
}
function resolveDesignerCheckout(stored) {
  if (!stored) return { ...EMPTY_RESOLVED_CHECKOUT, questions: [] };
  const addToOrderSeen = /* @__PURE__ */ new Set();
  return {
    printAnywayMessage: stored.printAnywayMessage ?? null,
    termsMessage: stored.termsMessage ?? null,
    questions: (stored.questions ?? []).filter((q) => q.active).map(({ id, type, label, options, required, addToOrder, lineItemLabel }) => {
      const effectiveAddToOrder = addToOrder === true && typeof lineItemLabel === "string" && isValidLineItemLabel(lineItemLabel) && !addToOrderSeen.has(type);
      if (effectiveAddToOrder) addToOrderSeen.add(type);
      return {
        id,
        type,
        label,
        ...options ? { options } : {},
        required,
        addToOrder: effectiveAddToOrder,
        ...effectiveAddToOrder ? { lineItemLabel: lineItemLabel.trim() } : {}
      };
    })
  };
}

// src/types/designer-text.ts
import { z as z3 } from "zod";
var BUILTIN_FONT_FAMILIES = [
  "Arial",
  "Helvetica",
  "Times New Roman",
  "Courier New"
];
var DESIGNER_TEXT_LIMITS = {
  /** Hard ceiling for the per-store allowlist size. */
  maxAllowedFonts: 200
};
var FONT_UPLOAD_FALLBACKS = {
  allowed: true,
  maxFonts: 20,
  maxFileSizeMb: 5
};
var FONT_UPLOAD_CEILINGS = {
  maxFonts: 100,
  maxFileSizeMb: 30
};
var DEFAULT_RESOLVED_DESIGNER_TEXT = {
  enabled: true,
  allowedFontIds: null
};
var designerTextInputSchema = z3.object({
  enabled: z3.boolean().optional(),
  allowedFontIds: z3.array(z3.string().trim().min(1).max(64)).max(DESIGNER_TEXT_LIMITS.maxAllowedFonts).optional()
});
var fontUploadInputSchema = z3.object({
  allowed: z3.boolean().optional(),
  maxFonts: z3.number().int().min(0).max(FONT_UPLOAD_CEILINGS.maxFonts).optional(),
  maxFileSizeMb: z3.number().int().min(1).max(FONT_UPLOAD_CEILINGS.maxFileSizeMb).optional()
});
function parseDesignerTextStored(json) {
  if (!json || typeof json !== "object") return null;
  const obj = json;
  const result = {};
  if (typeof obj.enabled === "boolean") result.enabled = obj.enabled;
  if (Array.isArray(obj.allowedFontIds)) {
    const ids = obj.allowedFontIds.filter(
      (v) => typeof v === "string" && v.trim().length > 0
    );
    result.allowedFontIds = ids;
  }
  if (typeof obj.updatedAt === "string") result.updatedAt = obj.updatedAt;
  return Object.keys(result).length > 0 ? result : null;
}
function parseFontUploadStored(json) {
  if (!json || typeof json !== "object") return null;
  const obj = json;
  const result = {};
  if (typeof obj.allowed === "boolean") result.allowed = obj.allowed;
  if (typeof obj.maxFonts === "number" && Number.isInteger(obj.maxFonts) && obj.maxFonts >= 0) {
    result.maxFonts = Math.min(obj.maxFonts, FONT_UPLOAD_CEILINGS.maxFonts);
  }
  if (typeof obj.maxFileSizeMb === "number" && Number.isInteger(obj.maxFileSizeMb) && obj.maxFileSizeMb >= 1) {
    result.maxFileSizeMb = Math.min(obj.maxFileSizeMb, FONT_UPLOAD_CEILINGS.maxFileSizeMb);
  }
  if (typeof obj.updatedAt === "string") result.updatedAt = obj.updatedAt;
  return Object.keys(result).length > 0 ? result : null;
}
function resolveDesignerText(stored) {
  if (!stored) return { ...DEFAULT_RESOLVED_DESIGNER_TEXT };
  return {
    enabled: stored.enabled !== false,
    allowedFontIds: stored.allowedFontIds && stored.allowedFontIds.length > 0 ? [...stored.allowedFontIds] : null
  };
}
function resolveFontUpload(stored, platformDefaults) {
  const base = {
    allowed: platformDefaults?.allowed ?? FONT_UPLOAD_FALLBACKS.allowed,
    maxFonts: clampInt(
      platformDefaults?.maxFonts ?? FONT_UPLOAD_FALLBACKS.maxFonts,
      0,
      FONT_UPLOAD_CEILINGS.maxFonts
    ),
    maxFileSizeMb: clampInt(
      platformDefaults?.maxFileSizeMb ?? FONT_UPLOAD_FALLBACKS.maxFileSizeMb,
      1,
      FONT_UPLOAD_CEILINGS.maxFileSizeMb
    )
  };
  if (!stored) return base;
  return {
    allowed: stored.allowed ?? base.allowed,
    maxFonts: stored.maxFonts !== void 0 ? clampInt(stored.maxFonts, 0, FONT_UPLOAD_CEILINGS.maxFonts) : base.maxFonts,
    maxFileSizeMb: stored.maxFileSizeMb !== void 0 ? clampInt(stored.maxFileSizeMb, 1, FONT_UPLOAD_CEILINGS.maxFileSizeMb) : base.maxFileSizeMb
  };
}
function clampInt(value, min, max) {
  return Math.max(min, Math.min(max, Math.round(value)));
}
var BOLD_CAPABLE_MIN_WEIGHT = 600;
function deriveFontStyleCapabilities(files, source) {
  if (source === "builtin") {
    return { hasItalic: true, hasBold: true, hasBoldItalic: true };
  }
  return {
    hasItalic: files.some((f) => f.style === "italic"),
    hasBold: files.some(
      (f) => f.style === "normal" && f.weight >= BOLD_CAPABLE_MIN_WEIGHT
    ),
    hasBoldItalic: files.some(
      (f) => f.style === "italic" && f.weight >= BOLD_CAPABLE_MIN_WEIGHT
    )
  };
}
function resolveProductTextOverride(designConfigJson) {
  if (!designConfigJson || typeof designConfigJson !== "object") return null;
  const text = designConfigJson.text;
  if (!text || typeof text !== "object") return null;
  const enabled = text.enabled;
  return typeof enabled === "boolean" ? enabled : null;
}

// src/types/designer-embed.ts
var DESIGNER_EMBED_PROTOCOL_VERSION = 1;
var DESIGNER_EMBED_MESSAGE_SOURCE = "tk-designer";
function createDesignerEmbedEnvelope(payload) {
  return {
    source: DESIGNER_EMBED_MESSAGE_SOURCE,
    version: DESIGNER_EMBED_PROTOCOL_VERSION,
    payload
  };
}
function parseDesignerEmbedEnvelope(data) {
  if (typeof data !== "object" || data === null) return null;
  const obj = data;
  if (obj.source !== DESIGNER_EMBED_MESSAGE_SOURCE) return null;
  if (obj.version !== DESIGNER_EMBED_PROTOCOL_VERSION) return null;
  const payload = obj.payload;
  if (typeof payload !== "object" || payload === null) return null;
  if (typeof payload.type !== "string") return null;
  return obj;
}
function isDesignerChildMessage(payload) {
  switch (payload.type) {
    case "ready":
    case "resize":
    case "add-to-cart-relay":
    case "add-to-cart":
    case "saved":
    case "close":
    case "error":
    case "auth-request":
    case "login-probe":
      return true;
    default:
      return false;
  }
}
function isDesignerParentMessage(payload) {
  return payload.type === "handshake" || payload.type === "auth" || payload.type === "cart-result" || payload.type === "close-request";
}
function isAllowedEmbedOrigin(origin, allowList) {
  if (!origin) return false;
  let candidate;
  try {
    candidate = new URL(origin);
  } catch {
    return false;
  }
  const isLocalhost = candidate.hostname === "localhost" || candidate.hostname === "127.0.0.1";
  if (candidate.protocol !== "https:" && !(candidate.protocol === "http:" && isLocalhost)) {
    return false;
  }
  for (const raw of allowList) {
    const entry = raw.trim();
    if (!entry) continue;
    const wildcardIdx = entry.indexOf("://*.");
    if (wildcardIdx !== -1) {
      const scheme = entry.slice(0, wildcardIdx);
      const suffix = entry.slice(wildcardIdx + "://*.".length);
      if (candidate.protocol === `${scheme}:`) {
        const host = candidate.host;
        if (host === suffix) continue;
        if (host.endsWith(`.${suffix}`)) return true;
      }
      continue;
    }
    try {
      if (candidate.origin === new URL(entry).origin) return true;
    } catch {
    }
  }
  return false;
}

// src/types/designer-launch.ts
var DESIGNER_LAUNCH_MODES = [
  "redirect",
  "overlay",
  "inline"
];
function resolveDesignerLaunchMode(raw) {
  if (raw === "overlay" || raw === "inline") return raw;
  return "redirect";
}
function parseDesignerLaunchMode(raw) {
  return raw === "redirect" || raw === "overlay" || raw === "inline" ? raw : null;
}
function resolveProductLaunchOverride(designConfigJson) {
  if (!designConfigJson || typeof designConfigJson !== "object") return null;
  const launch = designConfigJson.launch;
  if (!launch || typeof launch !== "object") return null;
  return parseDesignerLaunchMode(launch.mode);
}

// src/types/library.ts
var LibraryAssetStatus = {
  PROCESSING: "PROCESSING",
  READY: "READY",
  FAILED: "FAILED",
  ARCHIVED: "ARCHIVED",
  DELETED: "DELETED",
  PURGED: "PURGED"
};
var LibraryAssetSourceType = {
  UPLOAD: "UPLOAD",
  GOOGLE_DRIVE: "GOOGLE_DRIVE",
  CANVA: "CANVA",
  DROPBOX: "DROPBOX",
  API: "API"
};
var LibraryUploadBatchStatus = {
  UPLOADING: "UPLOADING",
  PROCESSING: "PROCESSING",
  REVIEW: "REVIEW",
  COMPLETED: "COMPLETED"
};
var LibraryTagSource = {
  MANUAL: "MANUAL",
  IMPORT: "IMPORT",
  AI: "AI"
};
var LibraryDownloadVariant = {
  /** Current working copy (trimmed when the original had trimmable alpha). Default. */
  WORKING: "working",
  /** Lossless original bytes, exactly as uploaded. */
  ORIGINAL: "original"
};
var LIBRARY_QUEUE_NAMES = {
  /** Per-asset validate → trim → derive variants → mark READY. */
  ASSET_PROCESS: "library-asset-process",
  /** Cron: archive→delete→purge lifecycle + abandoned-upload cleanup. */
  LIFECYCLE_CLEANUP: "library-lifecycle-cleanup"
};
function libraryOriginalKey(assetId, version, ext) {
  const clean = ext.replace(/^\.+/, "").toLowerCase() || "bin";
  return `library/assets/${assetId}/v${version}/original.${clean}`;
}
function libraryDerivedWorkingKey(contentHash) {
  return `library/derived/${contentHash}/working.png`;
}
function libraryDerivedThumbKey(contentHash) {
  return `library/derived/${contentHash}/thumb.webp`;
}
function libraryDerivedLargeKey(contentHash) {
  return `library/derived/${contentHash}/large.webp`;
}
var LIBRARY_WORKING_KEY_PATTERN = /^library\/derived\/[a-f0-9]{64}\/working\.png$/;
var LIBRARY_ASSET_ID_PATTERN = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|c[a-z0-9]{20,32})$/;
function isLibraryAssetId(id) {
  return LIBRARY_ASSET_ID_PATTERN.test(id);
}
var LIBRARY_ORIGINAL_KEY_PATTERN = /^library\/assets\/(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|c[a-z0-9]{20,32})\/v\d{1,6}\/original\.[a-z0-9]{1,8}$/;
function isLibraryPrintKey(key) {
  return LIBRARY_WORKING_KEY_PATTERN.test(key) || LIBRARY_ORIGINAL_KEY_PATTERN.test(key);
}
function isLibraryKey(key) {
  return key.startsWith("library/");
}
var LIBRARY_THUMB_MAX_PX = 400;
var LIBRARY_LARGE_MAX_PX = 2048;
var LIBRARY_WEBP_QUALITY = 82;
var LIBRARY_ALPHA_TRIM_THRESHOLD = 2;
var LIBRARY_WORKING_MAX_EDGE_PX = 9e3;
var LIBRARY_HARD_MAX_PIXELS = 1e9;
var LIBRARY_TRIM_SCAN_MAX_PIXELS = 1e8;
var LIBRARY_ALLOWED_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp"
];
var LibrarySearchField = {
  ALL: "all",
  SKU: "sku",
  FILE_NAME: "fileName",
  TITLE: "title",
  DESCRIPTION: "description"
};
var LibrarySortOrder = {
  RECENT: "createdAt",
  POPULAR: "popular"
};
var LibraryMissingField = {
  TITLE: "title",
  DESCRIPTION: "description",
  KEYWORDS: "keywords",
  TAGS: "tags"
};
var LIBRARY_MAX_PAGE_SIZE = 100;
var LIBRARY_MAX_BATCH_FILES = 500;
var LIBRARY_UPLOAD_DEFAULT_MAX_FILE_MB = 100;
var LIBRARY_MAX_EXCEL_ROWS = 5e3;
var LIBRARY_IMPORT_MAX_RAW_ROWS = 5e4;
var LIBRARY_IMPORT_MAX_FILE_BYTES = 20 * 1024 * 1024;
var LIBRARY_IMPORT_PREVIEW_ROWS = 200;
var LIBRARY_IMPORT_TITLE_MAX_LENGTH = 300;
var LIBRARY_MAX_BULK_ASSETS = 500;
var GallerySortOrder = {
  RECENT: "recent",
  POPULAR: "popular"
};
var LibraryApiScope = {
  READ: "library:read",
  DOWNLOAD: "library:download"
};
var LIBRARY_API_KEY_PREFIX = "tk_lib_";

// src/constants/permissions.ts
var OrgPermissions = {
  // Organization management
  ORGANIZATION_READ: buildPermission(OrgResource.ORGANIZATION, Action.READ),
  ORGANIZATION_UPDATE: buildPermission(OrgResource.ORGANIZATION, Action.UPDATE),
  ORGANIZATION_MANAGE: buildPermission(OrgResource.ORGANIZATION, Action.MANAGE),
  // Member management
  MEMBER_LIST: buildPermission(OrgResource.MEMBER, Action.LIST),
  MEMBER_READ: buildPermission(OrgResource.MEMBER, Action.READ),
  MEMBER_INVITE: buildPermission(OrgResource.MEMBER, ExtendedAction.INVITE),
  MEMBER_REMOVE: buildPermission(OrgResource.MEMBER, ExtendedAction.REMOVE_MEMBER),
  MEMBER_CHANGE_ROLE: buildPermission(OrgResource.MEMBER, ExtendedAction.CHANGE_ROLE),
  MEMBER_MANAGE: buildPermission(OrgResource.MEMBER, Action.MANAGE),
  // Role management
  ROLE_LIST: buildPermission(OrgResource.ROLE, Action.LIST),
  ROLE_READ: buildPermission(OrgResource.ROLE, Action.READ),
  ROLE_CREATE: buildPermission(OrgResource.ROLE, Action.CREATE),
  ROLE_UPDATE: buildPermission(OrgResource.ROLE, Action.UPDATE),
  ROLE_DELETE: buildPermission(OrgResource.ROLE, Action.DELETE),
  ROLE_MANAGE: buildPermission(OrgResource.ROLE, Action.MANAGE),
  // Connection management
  CONNECTION_LIST: buildPermission(OrgResource.CONNECTION, Action.LIST),
  CONNECTION_READ: buildPermission(OrgResource.CONNECTION, Action.READ),
  CONNECTION_CREATE: buildPermission(OrgResource.CONNECTION, Action.CREATE),
  CONNECTION_UPDATE: buildPermission(OrgResource.CONNECTION, Action.UPDATE),
  CONNECTION_DELETE: buildPermission(OrgResource.CONNECTION, Action.DELETE),
  CONNECTION_MANAGE: buildPermission(OrgResource.CONNECTION, Action.MANAGE),
  // Product management
  PRODUCT_LIST: buildPermission(OrgResource.PRODUCT, Action.LIST),
  PRODUCT_READ: buildPermission(OrgResource.PRODUCT, Action.READ),
  PRODUCT_CREATE: buildPermission(OrgResource.PRODUCT, Action.CREATE),
  PRODUCT_UPDATE: buildPermission(OrgResource.PRODUCT, Action.UPDATE),
  PRODUCT_DELETE: buildPermission(OrgResource.PRODUCT, Action.DELETE),
  PRODUCT_MANAGE: buildPermission(OrgResource.PRODUCT, Action.MANAGE),
  // Order management
  ORDER_LIST: buildPermission(OrgResource.ORDER, Action.LIST),
  ORDER_READ: buildPermission(OrgResource.ORDER, Action.READ),
  ORDER_CREATE: buildPermission(OrgResource.ORDER, Action.CREATE),
  ORDER_UPDATE: buildPermission(OrgResource.ORDER, Action.UPDATE),
  ORDER_CANCEL: buildPermission(OrgResource.ORDER, ExtendedAction.CANCEL),
  ORDER_EXPORT: buildPermission(OrgResource.ORDER, ExtendedAction.EXPORT),
  ORDER_MANAGE: buildPermission(OrgResource.ORDER, Action.MANAGE),
  // Design management
  DESIGN_LIST: buildPermission(OrgResource.DESIGN, Action.LIST),
  DESIGN_READ: buildPermission(OrgResource.DESIGN, Action.READ),
  DESIGN_CREATE: buildPermission(OrgResource.DESIGN, Action.CREATE),
  DESIGN_UPDATE: buildPermission(OrgResource.DESIGN, Action.UPDATE),
  DESIGN_DELETE: buildPermission(OrgResource.DESIGN, Action.DELETE),
  DESIGN_MANAGE: buildPermission(OrgResource.DESIGN, Action.MANAGE),
  // Wallet management
  WALLET_READ: buildPermission(OrgResource.WALLET, Action.READ),
  WALLET_TOP_UP: buildPermission(OrgResource.WALLET, ExtendedAction.TOP_UP),
  WALLET_MANAGE: buildPermission(OrgResource.WALLET, Action.MANAGE),
  // Invoice management
  INVOICE_LIST: buildPermission(OrgResource.INVOICE, Action.LIST),
  INVOICE_READ: buildPermission(OrgResource.INVOICE, Action.READ),
  INVOICE_MANAGE: buildPermission(OrgResource.INVOICE, Action.MANAGE),
  // Support tickets
  TICKET_LIST: buildPermission(OrgResource.TICKET, Action.LIST),
  TICKET_READ: buildPermission(OrgResource.TICKET, Action.READ),
  TICKET_CREATE: buildPermission(OrgResource.TICKET, Action.CREATE),
  TICKET_UPDATE: buildPermission(OrgResource.TICKET, Action.UPDATE),
  TICKET_MANAGE: buildPermission(OrgResource.TICKET, Action.MANAGE),
  // Settings
  SETTINGS_READ: buildPermission(OrgResource.SETTINGS, Action.READ),
  SETTINGS_UPDATE: buildPermission(OrgResource.SETTINGS, Action.UPDATE),
  SETTINGS_MANAGE: buildPermission(OrgResource.SETTINGS, Action.MANAGE),
  // Analytics
  ANALYTICS_READ: buildPermission(OrgResource.ANALYTICS, Action.READ),
  // Notifications
  NOTIFICATION_READ: buildPermission(OrgResource.NOTIFICATION, Action.READ),
  NOTIFICATION_MANAGE: buildPermission(OrgResource.NOTIFICATION, Action.MANAGE)
};
var AdminPermissions = {
  // Admin user management
  ADMIN_USER_LIST: buildPermission(AdminResource.ADMIN_USER, Action.LIST),
  ADMIN_USER_READ: buildPermission(AdminResource.ADMIN_USER, Action.READ),
  ADMIN_USER_CREATE: buildPermission(AdminResource.ADMIN_USER, Action.CREATE),
  ADMIN_USER_UPDATE: buildPermission(AdminResource.ADMIN_USER, Action.UPDATE),
  ADMIN_USER_DELETE: buildPermission(AdminResource.ADMIN_USER, Action.DELETE),
  ADMIN_USER_MANAGE: buildPermission(AdminResource.ADMIN_USER, Action.MANAGE),
  // Admin role management
  ADMIN_ROLE_LIST: buildPermission(AdminResource.ADMIN_ROLE, Action.LIST),
  ADMIN_ROLE_READ: buildPermission(AdminResource.ADMIN_ROLE, Action.READ),
  ADMIN_ROLE_CREATE: buildPermission(AdminResource.ADMIN_ROLE, Action.CREATE),
  ADMIN_ROLE_UPDATE: buildPermission(AdminResource.ADMIN_ROLE, Action.UPDATE),
  ADMIN_ROLE_DELETE: buildPermission(AdminResource.ADMIN_ROLE, Action.DELETE),
  ADMIN_ROLE_MANAGE: buildPermission(AdminResource.ADMIN_ROLE, Action.MANAGE),
  // Organization management (admin side)
  ORG_LIST: buildPermission(AdminResource.ORGANIZATION, Action.LIST),
  ORG_READ: buildPermission(AdminResource.ORGANIZATION, Action.READ),
  ORG_UPDATE: buildPermission(AdminResource.ORGANIZATION, Action.UPDATE),
  ORG_SUSPEND: buildPermission(AdminResource.ORGANIZATION, ExtendedAction.SUSPEND),
  ORG_ACTIVATE: buildPermission(AdminResource.ORGANIZATION, ExtendedAction.ACTIVATE),
  ORG_MANAGE: buildPermission(AdminResource.ORGANIZATION, Action.MANAGE),
  // User management (admin side)
  USER_LIST: buildPermission(AdminResource.USER, Action.LIST),
  USER_READ: buildPermission(AdminResource.USER, Action.READ),
  USER_UPDATE: buildPermission(AdminResource.USER, Action.UPDATE),
  USER_SUSPEND: buildPermission(AdminResource.USER, ExtendedAction.SUSPEND),
  USER_IMPERSONATE: buildPermission(AdminResource.USER, ExtendedAction.IMPERSONATE),
  USER_MANAGE: buildPermission(AdminResource.USER, Action.MANAGE),
  // Order management (admin side)
  ORDER_LIST: buildPermission(AdminResource.ORDER, Action.LIST),
  ORDER_READ: buildPermission(AdminResource.ORDER, Action.READ),
  ORDER_UPDATE: buildPermission(AdminResource.ORDER, Action.UPDATE),
  ORDER_CANCEL: buildPermission(AdminResource.ORDER, ExtendedAction.CANCEL),
  ORDER_HOLD: buildPermission(AdminResource.ORDER, ExtendedAction.HOLD),
  ORDER_RELEASE_HOLD: buildPermission(AdminResource.ORDER, ExtendedAction.RELEASE_HOLD),
  ORDER_ASSIGN_PROVIDER: buildPermission(AdminResource.ORDER, ExtendedAction.ASSIGN_PROVIDER),
  ORDER_ROUTING_OVERRIDE: buildPermission(AdminResource.ORDER, ExtendedAction.ROUTING_OVERRIDE),
  ORDER_MANAGE: buildPermission(AdminResource.ORDER, Action.MANAGE),
  // Product template management
  PRODUCT_TEMPLATE_LIST: buildPermission(AdminResource.PRODUCT_TEMPLATE, Action.LIST),
  PRODUCT_TEMPLATE_READ: buildPermission(AdminResource.PRODUCT_TEMPLATE, Action.READ),
  PRODUCT_TEMPLATE_CREATE: buildPermission(AdminResource.PRODUCT_TEMPLATE, Action.CREATE),
  PRODUCT_TEMPLATE_UPDATE: buildPermission(AdminResource.PRODUCT_TEMPLATE, Action.UPDATE),
  PRODUCT_TEMPLATE_DELETE: buildPermission(AdminResource.PRODUCT_TEMPLATE, Action.DELETE),
  PRODUCT_TEMPLATE_MANAGE: buildPermission(AdminResource.PRODUCT_TEMPLATE, Action.MANAGE),
  // Pricing management
  PRICING_READ: buildPermission(AdminResource.PRICING, Action.READ),
  PRICING_UPDATE: buildPermission(AdminResource.PRICING, Action.UPDATE),
  PRICING_MANAGE: buildPermission(AdminResource.PRICING, Action.MANAGE),
  // Provider management
  PROVIDER_LIST: buildPermission(AdminResource.PROVIDER, Action.LIST),
  PROVIDER_READ: buildPermission(AdminResource.PROVIDER, Action.READ),
  PROVIDER_CREATE: buildPermission(AdminResource.PROVIDER, Action.CREATE),
  PROVIDER_UPDATE: buildPermission(AdminResource.PROVIDER, Action.UPDATE),
  PROVIDER_DELETE: buildPermission(AdminResource.PROVIDER, Action.DELETE),
  PROVIDER_HARD_DELETE: buildPermission(AdminResource.PROVIDER, ExtendedAction.HARD_DELETE),
  PROVIDER_MANAGE: buildPermission(AdminResource.PROVIDER, Action.MANAGE),
  // Warehouse management
  WAREHOUSE_LIST: buildPermission(AdminResource.WAREHOUSE, Action.LIST),
  WAREHOUSE_READ: buildPermission(AdminResource.WAREHOUSE, Action.READ),
  WAREHOUSE_CREATE: buildPermission(AdminResource.WAREHOUSE, Action.CREATE),
  WAREHOUSE_UPDATE: buildPermission(AdminResource.WAREHOUSE, Action.UPDATE),
  WAREHOUSE_DELETE: buildPermission(AdminResource.WAREHOUSE, Action.DELETE),
  WAREHOUSE_MANAGE: buildPermission(AdminResource.WAREHOUSE, Action.MANAGE),
  // Shipping management
  SHIPPING_LIST: buildPermission(AdminResource.SHIPPING, Action.LIST),
  SHIPPING_READ: buildPermission(AdminResource.SHIPPING, Action.READ),
  SHIPPING_CREATE: buildPermission(AdminResource.SHIPPING, Action.CREATE),
  SHIPPING_UPDATE: buildPermission(AdminResource.SHIPPING, Action.UPDATE),
  SHIPPING_MANAGE: buildPermission(AdminResource.SHIPPING, Action.MANAGE),
  // Webhook management
  WEBHOOK_LIST: buildPermission(AdminResource.WEBHOOK, Action.LIST),
  WEBHOOK_READ: buildPermission(AdminResource.WEBHOOK, Action.READ),
  WEBHOOK_MANAGE: buildPermission(AdminResource.WEBHOOK, Action.MANAGE),
  // Job management
  JOB_LIST: buildPermission(AdminResource.JOB, Action.LIST),
  JOB_READ: buildPermission(AdminResource.JOB, Action.READ),
  JOB_MANAGE: buildPermission(AdminResource.JOB, Action.MANAGE),
  // Ops-health anomaly center
  ANOMALY_LIST: buildPermission(AdminResource.ANOMALY, Action.LIST),
  ANOMALY_MANAGE: buildPermission(AdminResource.ANOMALY, Action.MANAGE),
  // Audit log
  AUDIT_LOG_LIST: buildPermission(AdminResource.AUDIT_LOG, Action.LIST),
  AUDIT_LOG_READ: buildPermission(AdminResource.AUDIT_LOG, Action.READ),
  // Settings
  SETTINGS_READ: buildPermission(AdminResource.SETTINGS, Action.READ),
  SETTINGS_UPDATE: buildPermission(AdminResource.SETTINGS, Action.UPDATE),
  SETTINGS_MANAGE: buildPermission(AdminResource.SETTINGS, Action.MANAGE),
  // Analytics
  ANALYTICS_READ: buildPermission(AdminResource.ANALYTICS, Action.READ),
  // Support tickets
  SUPPORT_TICKET_LIST: buildPermission(AdminResource.SUPPORT_TICKET, Action.LIST),
  SUPPORT_TICKET_READ: buildPermission(AdminResource.SUPPORT_TICKET, Action.READ),
  SUPPORT_TICKET_UPDATE: buildPermission(AdminResource.SUPPORT_TICKET, Action.UPDATE),
  SUPPORT_TICKET_MANAGE: buildPermission(AdminResource.SUPPORT_TICKET, Action.MANAGE),
  // Wallet management (admin side)
  WALLET_REFUND: buildPermission("wallet", ExtendedAction.REFUND),
  WALLET_ADJUST: buildPermission("wallet", ExtendedAction.ADJUST),
  // Option type management (catalog redesign)
  OPTION_TYPE_LIST: buildPermission(AdminResource.OPTION_TYPE, Action.LIST),
  OPTION_TYPE_READ: buildPermission(AdminResource.OPTION_TYPE, Action.READ),
  OPTION_TYPE_CREATE: buildPermission(AdminResource.OPTION_TYPE, Action.CREATE),
  OPTION_TYPE_UPDATE: buildPermission(AdminResource.OPTION_TYPE, Action.UPDATE),
  OPTION_TYPE_DELETE: buildPermission(AdminResource.OPTION_TYPE, Action.DELETE),
  OPTION_TYPE_MANAGE: buildPermission(AdminResource.OPTION_TYPE, Action.MANAGE),
  // Provider variant mapping management
  PROVIDER_VARIANT_LIST: buildPermission(AdminResource.PROVIDER_VARIANT, Action.LIST),
  PROVIDER_VARIANT_READ: buildPermission(AdminResource.PROVIDER_VARIANT, Action.READ),
  PROVIDER_VARIANT_MANAGE: buildPermission(AdminResource.PROVIDER_VARIANT, Action.MANAGE),
  // Order status updates (provider-scoped)
  ORDER_UPDATE_STATUS: buildPermission(AdminResource.ORDER, ExtendedAction.UPDATE_STATUS),
  // Notification system (broadcasts, automations, branding)
  NOTIFICATION_LIST: buildPermission(AdminResource.NOTIFICATION, Action.LIST),
  NOTIFICATION_READ: buildPermission(AdminResource.NOTIFICATION, Action.READ),
  NOTIFICATION_MANAGE: buildPermission(AdminResource.NOTIFICATION, Action.MANAGE),
  // Design Library (central asset library)
  LIBRARY_READ: buildPermission(AdminResource.LIBRARY, Action.READ),
  LIBRARY_WRITE: buildPermission(AdminResource.LIBRARY, ExtendedAction.WRITE),
  LIBRARY_ADMIN: buildPermission(AdminResource.LIBRARY, ExtendedAction.ADMIN),
  // API key management (public library API access)
  API_KEY_MANAGE: buildPermission(AdminResource.API_KEY, Action.MANAGE)
};

// src/constants/roles.ts
var ORG_ROLE_OWNER = {
  slug: "owner",
  name: "Owner",
  description: "Full unrestricted access to all organization resources.",
  isSystemRole: true,
  permissions: [
    OrgPermissions.ORGANIZATION_MANAGE,
    OrgPermissions.MEMBER_MANAGE,
    OrgPermissions.ROLE_MANAGE,
    OrgPermissions.CONNECTION_MANAGE,
    OrgPermissions.PRODUCT_MANAGE,
    OrgPermissions.ORDER_MANAGE,
    OrgPermissions.DESIGN_MANAGE,
    OrgPermissions.WALLET_MANAGE,
    OrgPermissions.INVOICE_MANAGE,
    OrgPermissions.TICKET_MANAGE,
    OrgPermissions.SETTINGS_MANAGE,
    OrgPermissions.ANALYTICS_READ,
    OrgPermissions.NOTIFICATION_MANAGE
  ]
};
var ORG_ROLE_ADMIN = {
  slug: "admin",
  name: "Admin",
  description: "Full access to stores, dashboard, and member management. Cannot modify Owner.",
  isSystemRole: true,
  permissions: [
    OrgPermissions.ORGANIZATION_READ,
    OrgPermissions.ORGANIZATION_UPDATE,
    OrgPermissions.MEMBER_LIST,
    OrgPermissions.MEMBER_READ,
    OrgPermissions.MEMBER_INVITE,
    OrgPermissions.MEMBER_REMOVE,
    OrgPermissions.MEMBER_CHANGE_ROLE,
    OrgPermissions.CONNECTION_MANAGE,
    OrgPermissions.PRODUCT_MANAGE,
    OrgPermissions.ORDER_MANAGE,
    OrgPermissions.DESIGN_MANAGE,
    OrgPermissions.WALLET_READ,
    OrgPermissions.WALLET_TOP_UP,
    OrgPermissions.INVOICE_LIST,
    OrgPermissions.INVOICE_READ,
    OrgPermissions.TICKET_MANAGE,
    OrgPermissions.SETTINGS_MANAGE,
    OrgPermissions.ANALYTICS_READ,
    OrgPermissions.NOTIFICATION_MANAGE
  ]
};
var ORG_ROLE_MANAGER = {
  slug: "manager",
  name: "Manager",
  description: "Manage products, view orders. No billing or analytics access.",
  isSystemRole: true,
  permissions: [
    OrgPermissions.ORGANIZATION_READ,
    OrgPermissions.MEMBER_LIST,
    OrgPermissions.MEMBER_READ,
    OrgPermissions.CONNECTION_LIST,
    OrgPermissions.CONNECTION_READ,
    OrgPermissions.PRODUCT_MANAGE,
    OrgPermissions.ORDER_LIST,
    OrgPermissions.ORDER_READ,
    OrgPermissions.ORDER_CREATE,
    OrgPermissions.ORDER_UPDATE,
    OrgPermissions.DESIGN_LIST,
    OrgPermissions.DESIGN_READ,
    OrgPermissions.TICKET_LIST,
    OrgPermissions.TICKET_READ,
    OrgPermissions.TICKET_CREATE,
    OrgPermissions.TICKET_UPDATE,
    OrgPermissions.NOTIFICATION_READ
  ]
};
var ORG_ROLE_DESIGNER = {
  slug: "designer",
  name: "Designer",
  description: "Full access to product templates, designs, and file library. Limited store access.",
  isSystemRole: true,
  permissions: [
    OrgPermissions.ORGANIZATION_READ,
    OrgPermissions.CONNECTION_LIST,
    OrgPermissions.CONNECTION_READ,
    OrgPermissions.PRODUCT_MANAGE,
    OrgPermissions.DESIGN_MANAGE,
    OrgPermissions.NOTIFICATION_READ
  ]
};
var ORG_SYSTEM_ROLES = [
  ORG_ROLE_OWNER,
  ORG_ROLE_ADMIN,
  ORG_ROLE_MANAGER,
  ORG_ROLE_DESIGNER
];
var ADMIN_ROLE_SUPER_ADMIN = {
  slug: "super_admin",
  name: "Super Admin",
  description: "Full access to all platform resources including user impersonation.",
  isSystemRole: true,
  permissions: Object.values(AdminPermissions)
};
var ADMIN_ROLE_OPS_MANAGER = {
  slug: "ops_manager",
  name: "Operations Manager",
  description: "Manages orders, production, providers, and shipping operations.",
  isSystemRole: true,
  permissions: [
    // Organizations (read)
    AdminPermissions.ORG_LIST,
    AdminPermissions.ORG_READ,
    // Users (read)
    AdminPermissions.USER_LIST,
    AdminPermissions.USER_READ,
    // Orders (full management)
    AdminPermissions.ORDER_MANAGE,
    // Product templates (read)
    AdminPermissions.PRODUCT_TEMPLATE_LIST,
    AdminPermissions.PRODUCT_TEMPLATE_READ,
    // Providers
    AdminPermissions.PROVIDER_MANAGE,
    // Warehouses
    AdminPermissions.WAREHOUSE_MANAGE,
    // Shipping
    AdminPermissions.SHIPPING_MANAGE,
    // Jobs
    AdminPermissions.JOB_LIST,
    AdminPermissions.JOB_READ,
    // Ops-health anomaly center
    AdminPermissions.ANOMALY_MANAGE,
    // Analytics
    AdminPermissions.ANALYTICS_READ,
    // Support tickets
    AdminPermissions.SUPPORT_TICKET_MANAGE
  ]
};
var ADMIN_ROLE_CATALOG_MANAGER = {
  slug: "catalog_manager",
  name: "Catalog Manager",
  description: "Manages product templates, pricing rules, and catalog structure.",
  isSystemRole: true,
  permissions: [
    // Product templates
    AdminPermissions.PRODUCT_TEMPLATE_MANAGE,
    // Pricing
    AdminPermissions.PRICING_MANAGE,
    // Organizations (read only)
    AdminPermissions.ORG_LIST,
    AdminPermissions.ORG_READ,
    // Analytics
    AdminPermissions.ANALYTICS_READ
  ]
};
var ADMIN_ROLE_SUPPORT_AGENT = {
  slug: "support_agent",
  name: "Support Agent",
  description: "Handles customer support tickets. Read-only access to orders and users.",
  isSystemRole: true,
  permissions: [
    // Organizations (read)
    AdminPermissions.ORG_LIST,
    AdminPermissions.ORG_READ,
    // Users (read)
    AdminPermissions.USER_LIST,
    AdminPermissions.USER_READ,
    // Orders (read)
    AdminPermissions.ORDER_LIST,
    AdminPermissions.ORDER_READ,
    // Support tickets (full)
    AdminPermissions.SUPPORT_TICKET_MANAGE,
    // Audit log (read)
    AdminPermissions.AUDIT_LOG_LIST,
    AdminPermissions.AUDIT_LOG_READ
  ]
};
var ADMIN_SYSTEM_ROLES = [
  ADMIN_ROLE_SUPER_ADMIN,
  ADMIN_ROLE_OPS_MANAGER,
  ADMIN_ROLE_CATALOG_MANAGER,
  ADMIN_ROLE_SUPPORT_AGENT
];

// src/constants/config.ts
var AUTH_CONFIG = {
  /** Access token TTL (in seconds) — 8 hours */
  ACCESS_TOKEN_TTL: 8 * 60 * 60,
  /** Refresh token TTL (in seconds) — 7 days */
  REFRESH_TOKEN_TTL: 7 * 24 * 60 * 60,
  /** CSRF token TTL (in seconds) — 1 hour */
  CSRF_TOKEN_TTL: 60 * 60,
  /** Designer token TTL (in seconds) — 30 minutes */
  DESIGNER_TOKEN_TTL: 30 * 60,
  /** Default bcrypt rounds */
  BCRYPT_ROUNDS: 12,
  /** Maximum sessions per user */
  MAX_SESSIONS_PER_USER: 5,
  /** Webhook timestamp tolerance (in seconds) — 5 minutes */
  WEBHOOK_TIMESTAMP_TOLERANCE: 5 * 60
};
var COOKIE_NAMES = {
  ACCESS_TOKEN: "__access",
  REFRESH_TOKEN: "__refresh",
  CSRF_TOKEN: "__csrf"
};
var HEADER_NAMES = {
  CSRF_TOKEN: "x-csrf-token",
  CORRELATION_ID: "x-correlation-id",
  REQUEST_ID: "x-request-id",
  DESIGNER_TOKEN: "authorization",
  /** Shopify HMAC header */
  SHOPIFY_HMAC: "x-shopify-hmac-sha256",
  SHOPIFY_TOPIC: "x-shopify-topic",
  SHOPIFY_SHOP_DOMAIN: "x-shopify-shop-domain",
  SHOPIFY_WEBHOOK_ID: "x-shopify-webhook-id",
  SHOPIFY_API_VERSION: "x-shopify-api-version"
};
var PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
  MIN_LIMIT: 1
};
var RATE_LIMITS = {
  /** Public endpoints: 30 requests per minute */
  PUBLIC: { limit: 30, windowMs: 6e4 },
  /** Authenticated endpoints: 100 requests per minute */
  AUTH: { limit: 100, windowMs: 6e4 },
  /** Login attempts: 5 per 15 minutes */
  LOGIN: { limit: 5, windowMs: 15 * 6e4 },
  /** Password reset: 3 per hour */
  PASSWORD_RESET: { limit: 3, windowMs: 60 * 6e4 },
  /** Webhook endpoints: 200 per minute */
  WEBHOOK: { limit: 200, windowMs: 6e4 },
  /** File upload: 10 per minute */
  UPLOAD: { limit: 10, windowMs: 6e4 }
};
var UPLOAD_LIMITS = {
  /** Maximum design file size (50 MB) */
  MAX_DESIGN_FILE_SIZE: 50 * 1024 * 1024,
  /** Maximum image file size (10 MB) */
  MAX_IMAGE_FILE_SIZE: 10 * 1024 * 1024,
  /** Allowed design file MIME types */
  ALLOWED_DESIGN_TYPES: [
    "image/png",
    "image/jpeg",
    "image/tiff",
    "image/svg+xml",
    "application/pdf"
  ],
  /** Allowed image file MIME types */
  ALLOWED_IMAGE_TYPES: [
    "image/png",
    "image/jpeg",
    "image/webp",
    "image/gif"
  ]
};
var PRODUCT_LIMITS = {
  /** TK cap on variants per product (creation + publish + UI dialogs). */
  MAX_VARIANTS_PER_PRODUCT: 2048,
  /** Shopify hard ceiling on variants per product (default plan). */
  SHOPIFY_MAX_VARIANTS: 2048,
  /** Shopify hard ceiling on media nodes per product. */
  SHOPIFY_MAX_MEDIA_PER_PRODUCT: 250,
  /** Shopify hard ceiling on option axes per product (`OPTIONS_OVER_LIMIT`). */
  SHOPIFY_MAX_PRODUCT_OPTIONS: 3,
  /**
   * `productSet(synchronous: true)` is only safe below this variant count.
   * Shopify recommends async + `productOperation` poll above ~150.
   */
  PRODUCT_SET_SYNC_MAX_VARIANTS: 150
};
var SHOPIFY_PRODUCT_PUBLISH_LOCK_MS = 15 * 60 * 1e3;
var SHOPIFY_MEDIA_SYNC_LOCK_MS = SHOPIFY_PRODUCT_PUBLISH_LOCK_MS;
var SUBDOMAINS = {
  PORTAL: "app",
  ADMIN: "admin",
  API: "api",
  DESIGNER: "designer",
  SHOPIFY: "pod"
};

// src/constants/stripe.ts
var STRIPE_API_VERSION = "2026-03-25.dahlia";
var STRIPE_WEBHOOK_TOLERANCE_SECONDS = 300;
var STRIPE_REQUEST_DEFAULTS = {
  /** Network timeout for synchronous calls (ms) */
  TIMEOUT_MS: 3e4,
  /** Idempotent retry attempts on transient failures */
  MAX_NETWORK_RETRIES: 2
};
var STRIPE_METADATA_KEYS = {
  ORGANIZATION_ID: "tk_organization_id",
  WALLET_ID: "tk_wallet_id",
  ORDER_ID: "tk_order_id",
  CORRELATION_ID: "tk_correlation_id",
  WALLET_TRANSACTION_ID: "tk_wallet_transaction_id",
  SUBSCRIPTION_ID: "tk_subscription_id",
  PLAN_ID: "tk_plan_id",
  INTENT_PURPOSE: "tk_intent_purpose"
};
var STRIPE_INTENT_PURPOSES = {
  WALLET_TOP_UP: "wallet_top_up",
  ORDER_FULFILLMENT: "order_fulfillment",
  AUTO_RECHARGE: "auto_recharge",
  SUBSCRIPTION: "subscription",
  // Hybrid wallet→card settlement: an off-session PaymentIntent raised by
  // OrderChargeService when the wallet is short for an order's wholesale
  // cost. The webhook handler treats it as a pure reconciler (the synchronous
  // charge path already credited+debited the wallet under one idempotency key).
  ORDER_CHARGE: "order_charge"
};
var STRIPE_MINIMUM_CHARGE_MINOR_UNITS = {
  USD: 50,
  EUR: 50,
  GBP: 30,
  CAD: 50,
  AUD: 50,
  NZD: 50,
  CHF: 50,
  SGD: 50,
  HKD: 400,
  JPY: 50,
  DKK: 250,
  NOK: 300,
  SEK: 300,
  MXN: 1e3,
  AED: 200
};
var STRIPE_DEFAULT_MINIMUM_CHARGE_MINOR_UNITS = 50;
function stripeMinimumChargeCents(currency) {
  const code = currency.toUpperCase();
  const min = STRIPE_MINIMUM_CHARGE_MINOR_UNITS[code] ?? STRIPE_DEFAULT_MINIMUM_CHARGE_MINOR_UNITS;
  return BigInt(min);
}
var STRIPE_WEBHOOK_EVENTS = {
  // Wallet / one-time charge flow
  PAYMENT_INTENT_SUCCEEDED: "payment_intent.succeeded",
  PAYMENT_INTENT_PAYMENT_FAILED: "payment_intent.payment_failed",
  PAYMENT_INTENT_REQUIRES_ACTION: "payment_intent.requires_action",
  PAYMENT_INTENT_CANCELED: "payment_intent.canceled",
  // Saved payment methods
  SETUP_INTENT_SUCCEEDED: "setup_intent.succeeded",
  SETUP_INTENT_SETUP_FAILED: "setup_intent.setup_failed",
  PAYMENT_METHOD_DETACHED: "payment_method.detached",
  // Checkout (wallet top-up via hosted checkout + subscription start)
  CHECKOUT_SESSION_COMPLETED: "checkout.session.completed",
  CHECKOUT_SESSION_EXPIRED: "checkout.session.expired",
  CHECKOUT_SESSION_ASYNC_PAYMENT_SUCCEEDED: "checkout.session.async_payment_succeeded",
  CHECKOUT_SESSION_ASYNC_PAYMENT_FAILED: "checkout.session.async_payment_failed",
  // Refunds & disputes
  CHARGE_REFUNDED: "charge.refunded",
  CHARGE_REFUND_UPDATED: "charge.refund.updated",
  CHARGE_DISPUTE_CREATED: "charge.dispute.created",
  CHARGE_DISPUTE_CLOSED: "charge.dispute.closed",
  CHARGE_DISPUTE_FUNDS_WITHDRAWN: "charge.dispute.funds_withdrawn",
  CHARGE_DISPUTE_FUNDS_REINSTATED: "charge.dispute.funds_reinstated",
  // Subscription lifecycle (Stripe path only)
  CUSTOMER_SUBSCRIPTION_CREATED: "customer.subscription.created",
  CUSTOMER_SUBSCRIPTION_UPDATED: "customer.subscription.updated",
  CUSTOMER_SUBSCRIPTION_DELETED: "customer.subscription.deleted",
  CUSTOMER_SUBSCRIPTION_TRIAL_WILL_END: "customer.subscription.trial_will_end",
  INVOICE_PAYMENT_SUCCEEDED: "invoice.payment_succeeded",
  INVOICE_PAYMENT_FAILED: "invoice.payment_failed",
  INVOICE_FINALIZED: "invoice.finalized",
  // Customer cleanup
  CUSTOMER_DELETED: "customer.deleted"
};
var STRIPE_WEBHOOK_EVENT_LIST = Object.values(STRIPE_WEBHOOK_EVENTS);

// src/constants/queues.ts
var QUEUE_NAMES = {
  ORDER_INGEST: "order-ingest",
  /** Legacy generic render queue — reserved, currently no registered worker. */
  RENDER: "render",
  EXPORT: "export",
  /** Apparel render pipeline (print-export + variant-preview jobs). */
  APPAREL_RENDER: "apparel-render",
  /** "My Designs" library thumbnails — low priority, never gates publish. */
  APPAREL_LIBRARY_PREVIEW: "apparel-library-preview",
  AUTO_PACK: "auto-pack",
  ZIP: "zip",
  SYNC: "sync",
  CLEANUP: "cleanup",
  TEST_ECHO: "test-echo",
  SHOPIFY_SETUP: "shopify-setup",
  SHOPIFY_BACKFILL: "shopify-backfill",
  /** Design-first background media reconcile (bridge to sync-media endpoint). */
  SHOPIFY_MEDIA_SYNC: "shopify-media-sync",
  /** Queued product publish (bridge to execute-publish endpoint). */
  SHOPIFY_PRODUCT_PUBLISH: "shopify-product-publish",
  /** Wholesale-cost → Shopify COGS mirror (bridge to cost-sync endpoint). */
  SHOPIFY_COST_SYNC: "shopify-cost-sync",
  /** Per-product fulfillment provider transitions (delivery profiles). */
  SHOPIFY_FULFILLMENT_SYNC: "shopify-fulfillment-sync",
  /** tk_pod.config metafield backfill on designer launch-config changes. */
  SHOPIFY_LAUNCH_CONFIG_BACKFILL: "shopify-launch-config-backfill",
  // Billing maintenance ticks (repeat-only; bridge to internal endpoints).
  BILLING_AUTO_RECHARGE: "billing-auto-recharge",
  BILLING_DUNNING: "billing-dunning",
  BILLING_RECONCILE: "billing-reconcile",
  /** Stuck-export recovery tick (bridge to /internal/exports/reconcile). */
  EXPORT_RECONCILE: "export-reconcile",
  /** Missed-webhook order ingest safety net (Shopify Admin REST pull). */
  SHOPIFY_ORDER_RECONCILE: "shopify-order-reconcile",
  /** Negative-balance wallet freeze sweep. */
  BILLING_WALLET_FREEZE: "billing-wallet-freeze",
  /** Order health sweep — SH-238897 anomaly detectors + orphan matcher. */
  ORDER_HEALTH_RECONCILE: "order-health-reconcile",
  /** Webhook retry & retention sweep (bridge to /internal/webhooks/reconcile). */
  WEBHOOK_RECONCILE: "webhook-reconcile",
  /** AWAITING_FULFILLMENT_REQUEST reminder tick. */
  FULFILLMENT_APPROVAL_REMINDER: "fulfillment-approval-reminder",
  /** Fulfillment drift reconcile (delivery-profile membership vs intent). */
  FULFILLMENT_DRIFT_RECONCILE: "fulfillment-drift-reconcile",
  /** Designer uploads-library 30-day retention sweep. */
  DESIGNER_UPLOADS_CLEANUP: "designer-uploads-cleanup",
  /** Storefront designer-branding metafield sync. */
  SHOPIFY_BRANDING_SYNC: "shopify-branding-sync",
  /** Versioned order summary PDF render. */
  ORDER_SUMMARY_PDF: "order-summary-pdf",
  /** Notification dispatch (email send / broadcast fan-out bridge). */
  NOTIFICATION_DISPATCH: "notification-dispatch",
  /** Central Design Library per-asset processing. */
  LIBRARY_ASSET_PROCESS: "library-asset-process",
  /** Central Design Library lifecycle sweep (retention / purge). */
  LIBRARY_LIFECYCLE_CLEANUP: "library-lifecycle-cleanup",
  /** Inkteo outbound order submission (bridge to internal submit endpoint). */
  INKTEO_SUBMIT: "inkteo-submit",
  /** Image Tools — AI upscale / background removal pipeline. */
  IMAGE_TOOLS: "image-tools",
  /** Image Tools stuck-job sweep. */
  IMAGE_TOOLS_RECONCILE: "image-tools-reconcile",
  /** Custom product options: validate + process a customer upload. */
  OPTION_UPLOAD_PROCESS: "option-upload-process",
  /** Custom product options: RIP PNG for a chosen print size (pHYs only, no resample). */
  OPTION_PRINT_RENDER: "option-print-render",
  /** Custom product options: abort abandoned multipart uploads, expire draft
   *  submissions, delete non-ordered uploads past retention. */
  OPTION_UPLOAD_SWEEP: "option-upload-sweep",
  /** One-off repair of option lines saved before upload files were snapshotted. */
  OPTION_FILE_BACKFILL: "option-file-backfill"
};
var QUEUE_DEFINITIONS = [
  { name: QUEUE_NAMES.ORDER_INGEST, kind: "EVENT", description: "Shopify order ingest jobs" },
  { name: QUEUE_NAMES.RENDER, kind: "EVENT", description: "Legacy generic render (reserved, no worker)" },
  { name: QUEUE_NAMES.EXPORT, kind: "EVENT", description: "Order print-file exports (gangsheet/DTF lane)" },
  { name: QUEUE_NAMES.APPAREL_RENDER, kind: "EVENT", description: "Apparel print-export + variant-preview renders" },
  { name: QUEUE_NAMES.APPAREL_LIBRARY_PREVIEW, kind: "EVENT", description: "My Designs library thumbnails" },
  { name: QUEUE_NAMES.AUTO_PACK, kind: "EVENT", description: "Gangsheet auto-pack layout jobs" },
  { name: QUEUE_NAMES.ZIP, kind: "EVENT", description: "Order ZIP bundle assembly" },
  { name: QUEUE_NAMES.SYNC, kind: "EVENT", description: "Generic sync jobs" },
  { name: QUEUE_NAMES.CLEANUP, kind: "REPEATABLE", description: "Generic cleanup tick" },
  { name: QUEUE_NAMES.TEST_ECHO, kind: "EVENT", description: "Health-check echo queue" },
  { name: QUEUE_NAMES.SHOPIFY_SETUP, kind: "EVENT", description: "Shopify store provisioning after install" },
  { name: QUEUE_NAMES.SHOPIFY_BACKFILL, kind: "EVENT", description: "Shopify historical data backfill" },
  { name: QUEUE_NAMES.SHOPIFY_MEDIA_SYNC, kind: "EVENT", description: "Published product media reconcile" },
  { name: QUEUE_NAMES.SHOPIFY_PRODUCT_PUBLISH, kind: "EVENT", description: "Queued product publish to Shopify" },
  { name: QUEUE_NAMES.SHOPIFY_COST_SYNC, kind: "EVENT", description: "Wholesale cost \u2192 Shopify COGS mirror" },
  { name: QUEUE_NAMES.SHOPIFY_FULFILLMENT_SYNC, kind: "EVENT", description: "Per-product fulfillment provider transitions" },
  { name: QUEUE_NAMES.SHOPIFY_LAUNCH_CONFIG_BACKFILL, kind: "EVENT", description: "Designer launch-config metafield backfill" },
  { name: QUEUE_NAMES.BILLING_AUTO_RECHARGE, kind: "REPEATABLE", description: "Wallet auto-recharge tick" },
  { name: QUEUE_NAMES.BILLING_DUNNING, kind: "REPEATABLE", description: "Failed-payment dunning tick" },
  { name: QUEUE_NAMES.BILLING_RECONCILE, kind: "REPEATABLE", description: "Billing reconcile tick" },
  { name: QUEUE_NAMES.EXPORT_RECONCILE, kind: "REPEATABLE", description: "Stuck-export recovery tick" },
  { name: QUEUE_NAMES.SHOPIFY_ORDER_RECONCILE, kind: "REPEATABLE", description: "Missed-webhook order ingest safety net" },
  { name: QUEUE_NAMES.BILLING_WALLET_FREEZE, kind: "REPEATABLE", description: "Negative-balance wallet freeze sweep" },
  { name: QUEUE_NAMES.ORDER_HEALTH_RECONCILE, kind: "REPEATABLE", description: "Order-health anomaly sweep (SH-238897)" },
  { name: QUEUE_NAMES.WEBHOOK_RECONCILE, kind: "REPEATABLE", description: "Webhook retry & retention sweep" },
  { name: QUEUE_NAMES.FULFILLMENT_APPROVAL_REMINDER, kind: "REPEATABLE", description: "Awaiting-approval reminder tick" },
  { name: QUEUE_NAMES.FULFILLMENT_DRIFT_RECONCILE, kind: "REPEATABLE", description: "Fulfillment drift reconcile tick" },
  { name: QUEUE_NAMES.DESIGNER_UPLOADS_CLEANUP, kind: "REPEATABLE", description: "Designer uploads 30-day retention sweep" },
  { name: QUEUE_NAMES.SHOPIFY_BRANDING_SYNC, kind: "EVENT", description: "Designer branding metafield sync" },
  { name: QUEUE_NAMES.ORDER_SUMMARY_PDF, kind: "EVENT", description: "Order summary PDF renders" },
  { name: QUEUE_NAMES.NOTIFICATION_DISPATCH, kind: "EVENT", description: "Notification email dispatch / fan-out" },
  { name: QUEUE_NAMES.LIBRARY_ASSET_PROCESS, kind: "EVENT", description: "Design Library asset processing" },
  { name: QUEUE_NAMES.LIBRARY_LIFECYCLE_CLEANUP, kind: "REPEATABLE", description: "Design Library lifecycle sweep" },
  { name: QUEUE_NAMES.INKTEO_SUBMIT, kind: "EVENT", description: "Inkteo outbound order submissions" },
  { name: QUEUE_NAMES.IMAGE_TOOLS, kind: "EVENT", description: "Image Tools AI processing (upscale / bg removal)" },
  { name: QUEUE_NAMES.IMAGE_TOOLS_RECONCILE, kind: "REPEATABLE", description: "Image Tools stuck-job sweep" },
  { name: QUEUE_NAMES.OPTION_UPLOAD_PROCESS, kind: "EVENT", description: "Custom product option upload processing" },
  { name: QUEUE_NAMES.OPTION_PRINT_RENDER, kind: "EVENT", description: "Sized-option RIP print file (pHYs density)" },
  { name: QUEUE_NAMES.OPTION_UPLOAD_SWEEP, kind: "REPEATABLE", description: "Option upload retention / expiry sweep" },
  { name: QUEUE_NAMES.OPTION_FILE_BACKFILL, kind: "EVENT", description: "One-off option-file snapshot backfill" }
];
function isKnownQueueName(name) {
  return QUEUE_DEFINITIONS.some((q) => q.name === name);
}

// src/utils/validation.ts
import { z as z4 } from "zod";
var cuidSchema = z4.string().cuid();
var emailSchema = z4.string().email("Invalid email address").max(255, "Email must be 255 characters or fewer").transform((v) => v.toLowerCase().trim());
var passwordSchema = z4.string().min(8, "Password must be at least 8 characters").max(128, "Password must be 128 characters or fewer").regex(/[A-Z]/, "Password must contain at least one uppercase letter").regex(/[a-z]/, "Password must contain at least one lowercase letter").regex(/[0-9]/, "Password must contain at least one number");
var nameSchema = z4.string().min(1, "Name is required").max(100, "Name must be 100 characters or fewer").trim();
var optionalNameSchema = z4.string().max(100, "Name must be 100 characters or fewer").trim().optional();
var phoneSchema = z4.string().min(7, "Phone number is too short").max(20, "Phone number is too long").regex(/^[+]?[\d\s()-]+$/, "Invalid phone number format").optional();
var urlSchema = z4.string().url("Invalid URL").max(2048, "URL is too long");
var slugSchema = z4.string().min(2, "Slug must be at least 2 characters").max(63, "Slug must be 63 characters or fewer").regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Slug must be lowercase alphanumeric with hyphens");
var positiveDecimalSchema = z4.string().regex(/^\d+(\.\d{1,4})?$/, "Must be a valid positive decimal (up to 4 decimal places)");
var pageSchema = z4.coerce.number().int().min(1).default(1);
var limitSchema = z4.coerce.number().int().min(1).max(100).default(20);
var sortDirSchema = z4.enum(["asc", "desc"]).default("desc");
var isoDateSchema = z4.string().datetime({ message: "Must be a valid ISO 8601 date" });
var registerSchema = z4.object({
  email: emailSchema,
  password: passwordSchema,
  firstName: nameSchema,
  lastName: nameSchema
});
var loginSchema = z4.object({
  email: emailSchema,
  password: z4.string().min(1, "Password is required")
});
var forgotPasswordSchema = z4.object({
  email: emailSchema
});
var resetPasswordSchema = z4.object({
  token: z4.string().min(1, "Token is required"),
  newPassword: passwordSchema
});
var changePasswordSchema = z4.object({
  currentPassword: z4.string().min(1, "Current password is required"),
  newPassword: passwordSchema
});
var updateProfileSchema = z4.object({
  firstName: optionalNameSchema,
  lastName: optionalNameSchema,
  avatar: urlSchema.optional(),
  phone: phoneSchema
});
var createOrganizationSchema = z4.object({
  name: nameSchema.optional().default("My Organization"),
  companyName: optionalNameSchema,
  companyEmail: emailSchema.optional(),
  companyPhone: phoneSchema
});
var updateOrganizationSchema = z4.object({
  name: optionalNameSchema,
  companyName: optionalNameSchema,
  companyEmail: emailSchema.optional(),
  companyPhone: phoneSchema,
  taxId: z4.string().max(50).optional(),
  vatNumber: z4.string().max(50).optional(),
  billingAddress: z4.string().max(500).optional(),
  shippingAddress: z4.string().max(500).optional(),
  defaultMeasurementUnit: z4.enum(["INCH", "CM"]).optional(),
  // Sender ("from") name printed on shipping labels. Empty string clears the
  // org default (labels then fall back to the fulfillment provider's name).
  labelSenderName: z4.string().max(100).optional()
});
var inviteMemberSchema = z4.object({
  email: emailSchema,
  roleSlug: z4.enum(["admin", "manager", "designer"], {
    error: "Role must be one of: admin, manager, designer"
  })
});
var paginationSchema = z4.object({
  page: pageSchema,
  limit: limitSchema
});
var listQuerySchema = z4.object({
  page: pageSchema,
  limit: limitSchema,
  sortBy: z4.string().max(50).optional(),
  sortDir: sortDirSchema,
  search: z4.string().max(200).trim().optional()
});
var dateRangeSchema = z4.object({
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional()
});
var orderAddressSchema = z4.object({
  firstName: nameSchema,
  lastName: nameSchema,
  company: z4.string().max(200).optional(),
  address1: z4.string().min(1, "Address is required").max(500),
  address2: z4.string().max(500).optional(),
  city: z4.string().min(1, "City is required").max(100),
  state: z4.string().max(100).optional(),
  zip: z4.string().min(1, "ZIP code is required").max(20),
  country: z4.string().min(1, "Country is required").max(100),
  countryCode: z4.string().length(2, "Country code must be 2 characters"),
  phone: phoneSchema
});
var createShopifyConnectionSchema = z4.object({
  shopDomain: z4.string().min(1, "Shop domain is required").max(255).regex(
    /^[a-zA-Z0-9][a-zA-Z0-9-]*\.myshopify\.com$/,
    "Must be a valid .myshopify.com domain"
  )
});
var triggerSyncSchema = z4.object({
  entities: z4.array(z4.enum(["products", "orders", "inventory"])).min(1, "At least one entity required"),
  fullSync: z4.boolean().optional().default(false)
});
var topUpWalletSchema = z4.object({
  amount: positiveDecimalSchema.refine(
    (v) => parseFloat(v) >= 5,
    "Minimum top-up amount is $5.00"
  ),
  paymentMethodId: z4.string().min(1, "Payment method is required")
});

// src/utils/helpers.ts
function generateCorrelationId() {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 10);
  return `${timestamp}-${random}`;
}
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
async function retryWithBackoff(fn, maxRetries = 3, baseDelayMs = 1e3) {
  let lastError;
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (attempt < maxRetries) {
        const delay = baseDelayMs * Math.pow(2, attempt);
        const jitter = Math.random() * baseDelayMs;
        await sleep(delay + jitter);
      }
    }
  }
  throw lastError;
}
function safeJsonParse(input) {
  try {
    return JSON.parse(input);
  } catch {
    return null;
  }
}
function maskSensitive(value, type = "token") {
  if (type === "email") {
    const [local, domain] = value.split("@");
    if (!local || !domain) return "***";
    const visible = local.substring(0, Math.min(2, local.length));
    return `${visible}***@${domain}`;
  }
  if (value.length <= 11) return "***";
  return `${value.substring(0, 8)}***${value.substring(value.length - 3)}`;
}
function truncate(str, maxLength) {
  if (str.length <= maxLength) return str;
  return str.substring(0, maxLength - 3) + "...";
}
function centsToDollars(cents) {
  return (cents / 100).toFixed(2);
}
function dollarsToCents(dollars) {
  return Math.round(parseFloat(dollars) * 100);
}
function isNonEmptyString(value) {
  return typeof value === "string" && value.trim().length > 0;
}
function pick(obj, keys) {
  const result = {};
  for (const key of keys) {
    if (key in obj) {
      result[key] = obj[key];
    }
  }
  return result;
}
function omit(obj, keys) {
  const result = { ...obj };
  for (const key of keys) {
    delete result[key];
  }
  return result;
}

// src/utils/design-urls.ts
var PART_KEY_REGEX = /^[A-Za-z0-9][A-Za-z0-9_\-.]{0,63}$/;
function isValidPartKey(value) {
  return typeof value === "string" && PART_KEY_REGEX.test(value);
}
var COMPOSITE_PART_KEY = "composite";
var VARIANT_COMPOSITE_PART_KEY_PREFIX = "composite__pv_";
var VARIANT_COMPOSITE_PREFIX = VARIANT_COMPOSITE_PART_KEY_PREFIX;
function variantCompositePartKey(blankVariantId) {
  return `${VARIANT_COMPOSITE_PREFIX}${blankVariantId}`;
}
function parseVariantCompositePartKey(partKey) {
  return partKey.startsWith(VARIANT_COMPOSITE_PREFIX) ? partKey.slice(VARIANT_COMPOSITE_PREFIX.length) : null;
}
function isCompositePartKey(value) {
  const key = value.toLowerCase();
  return key === COMPOSITE_PART_KEY || key.startsWith(VARIANT_COMPOSITE_PREFIX);
}
var PER_VARIANT_PART_KEY_INFIX = "__pv_";
function sideMockupPartKey(sideSlug, blankVariantId) {
  return `${sideSlug}${PER_VARIANT_PART_KEY_INFIX}${blankVariantId}`;
}
function parseSideMockupPartKey(partKey) {
  const idx = partKey.indexOf(PER_VARIANT_PART_KEY_INFIX);
  if (idx <= 0) return null;
  const sideSlug = partKey.slice(0, idx);
  const variantId = partKey.slice(idx + PER_VARIANT_PART_KEY_INFIX.length);
  if (!sideSlug || !variantId) return null;
  if (sideSlug.toLowerCase() === COMPOSITE_PART_KEY) return null;
  return { sideSlug, variantId };
}
function isPerVariantPartKey(partKey) {
  return partKey.includes(PER_VARIANT_PART_KEY_INFIX);
}
var DIMS_PART_KEY_INFIX = "__dims_";
function dimsPartKey(sideSlug, dimsKey) {
  return `${sideSlug}${DIMS_PART_KEY_INFIX}${dimsKey}`;
}
function isDimsPartKey(partKey) {
  return partKey.includes(DIMS_PART_KEY_INFIX);
}
function parseDimsPartKey(partKey) {
  const idx = partKey.indexOf(DIMS_PART_KEY_INFIX);
  if (idx <= 0) return null;
  const sideSlug = partKey.slice(0, idx);
  const dimsKey = partKey.slice(idx + DIMS_PART_KEY_INFIX.length);
  if (!sideSlug || !dimsKey) return null;
  return { sideSlug, dimsKey };
}
function isSatellitePartKey(partKey) {
  return isPerVariantPartKey(partKey) || isDimsPartKey(partKey);
}
function buildOrderExportZipUrl(apiBaseUrl, token) {
  const base = apiBaseUrl.replace(/\/+$/, "");
  return `${base}/api/v1/public/orders/exports/${token}.zip`;
}
function readDesignSelectionVariantId(designJson) {
  const sel = designJson?.selections?.variantId;
  return typeof sel === "string" && sel.length > 0 ? sel : null;
}
function resolveOrderItemBlankVariantId(item, designJson) {
  if (item.blankVariantId) return item.blankVariantId;
  if (item.partKey) {
    const fromPartKey = parseVariantCompositePartKey(item.partKey);
    if (fromPartKey) return fromPartKey;
  }
  return readDesignSelectionVariantId(designJson);
}
function resolveSheetPartKey(sheet, index) {
  const id = sheet?.id;
  if (typeof id === "string" && isValidPartKey(id)) return id;
  return `sheet-${index + 1}`;
}
function resolveOrderItemSheetPartKey(item, designJson) {
  if (item.partKey && isValidPartKey(item.partKey)) return item.partKey;
  if (typeof item.sheetIndex === "number" && item.sheetIndex >= 0) {
    const sheets = designJson?.sheets;
    if (Array.isArray(sheets) && sheets[item.sheetIndex]) {
      return resolveSheetPartKey(sheets[item.sheetIndex], item.sheetIndex);
    }
  }
  return null;
}
function listEmptySheetNumbers(designJson) {
  if (!designJson || typeof designJson !== "object") return [];
  const sheets = designJson.sheets;
  if (!Array.isArray(sheets)) return [];
  const empty = [];
  for (let i = 0; i < sheets.length; i++) {
    const sheet = sheets[i];
    const objects = sheet && typeof sheet === "object" ? sheet["objects"] : void 0;
    if (!Array.isArray(objects) || objects.length === 0) empty.push(i + 1);
  }
  return empty;
}
function designObjectHasInk(obj) {
  if (!obj || typeof obj !== "object") return false;
  const o = obj;
  if (o["visible"] === false) return false;
  if (typeof o["opacity"] === "number" && o["opacity"] <= 0) return false;
  if (o["type"] === "text") {
    const text = o["text"];
    return typeof text === "string" && text.trim().length > 0;
  }
  return true;
}
function extractEmptySideKeys(designJson) {
  const empty = /* @__PURE__ */ new Set();
  if (!designJson || typeof designJson !== "object") return empty;
  const sides = designJson.sides;
  if (!Array.isArray(sides)) return empty;
  for (const s of sides) {
    if (!s || typeof s !== "object") continue;
    const side = s;
    const objects = side["objects"];
    if (Array.isArray(objects) && objects.some(designObjectHasInk)) continue;
    const slug = side["printAreaSlug"];
    const paId = side["printAreaId"];
    if (typeof slug === "string" && slug) empty.add(slug);
    if (typeof paId === "string" && paId) empty.add(paId);
  }
  return empty;
}
function canonicalSideSlugFromPartKey(partKey) {
  const dims = parseDimsPartKey(partKey);
  if (dims) return dims.sideSlug;
  const pv = parseSideMockupPartKey(partKey);
  if (pv) return pv.sideSlug;
  return partKey;
}
function apparelSideIsEmpty(emptyKeys, side) {
  if (emptyKeys.size === 0) return false;
  if (side.partKey) {
    if (emptyKeys.has(side.partKey)) return true;
    const canonical = canonicalSideSlugFromPartKey(side.partKey);
    if (canonical !== side.partKey && emptyKeys.has(canonical)) return true;
  }
  if (side.printAreaId && emptyKeys.has(side.printAreaId)) return true;
  if (side.printAreaSlug && emptyKeys.has(side.printAreaSlug)) return true;
  return false;
}
function filterDesignedPrintAreas(printAreas, designJson) {
  const empty = extractEmptySideKeys(designJson);
  if (empty.size === 0) return [...printAreas];
  return printAreas.filter(
    (pa) => !empty.has(pa.id) && !empty.has(pa.slug)
  );
}
function resolveSheetIndexByPartKey(partKey, designJson) {
  if (!partKey || !isValidPartKey(partKey)) return null;
  const sheets = designJson?.sheets;
  if (!Array.isArray(sheets)) return null;
  for (let i = 0; i < sheets.length; i++) {
    if (resolveSheetPartKey(sheets[i], i) === partKey) return i;
  }
  return null;
}
function resolveSheetNumber(meta) {
  if (typeof meta.sheetIndex === "number" && meta.sheetIndex >= 0) {
    return meta.sheetIndex + 1;
  }
  const m = typeof meta.partKey === "string" ? /^sheet-(\d+)$/.exec(meta.partKey) : null;
  return m ? Number(m[1]) : null;
}
function buildOrderLineLabel(meta) {
  if (meta.isSheetLine) {
    const n = resolveSheetNumber(meta);
    return n != null ? `Sheet ${n}` : meta.partKey ?? null;
  }
  return meta.variantTitle ?? null;
}
function stripTrailingSlash(value) {
  return value.replace(/\/+$/, "");
}
function buildDesignerLaunchUrl(designerBaseUrl) {
  const base = stripTrailingSlash(designerBaseUrl.trim());
  if (!base) throw new Error("designerBaseUrl is required");
  return base.endsWith("/designer") ? base : `${base}/designer`;
}
function buildDesignAssetUrl(options) {
  const { apiBaseUrl, designRefId, partKey, kind, version } = options;
  if (!apiBaseUrl) throw new Error("apiBaseUrl is required");
  if (!isValidDesignRefId(designRefId)) throw new Error(`Invalid designRefId: ${designRefId}`);
  if (!isValidPartKey(partKey)) throw new Error(`Invalid partKey: ${partKey}`);
  if (kind !== "preview" && kind !== "export" && kind !== "mockup") {
    throw new Error(`Invalid asset kind: ${String(kind)}`);
  }
  const base = stripTrailingSlash(apiBaseUrl);
  const ext = kind === "mockup" ? "jpg" : "png";
  const url = `${base}/api/v1/public/previews/${designRefId}/${partKey}/${kind}.${ext}`;
  if (version !== void 0 && version !== null) {
    const v = typeof version === "number" ? version : Number(version);
    if (Number.isFinite(v) && v > 0) {
      return `${url}?v=${Math.floor(v)}`;
    }
  }
  return url;
}
function buildDesignerEditUrl(options) {
  const {
    shopDomain,
    designRefId,
    partKey,
    returnPath,
    proxySubpath = "tk-pod"
  } = options;
  if (!shopDomain) throw new Error("shopDomain is required");
  if (!isValidDesignRefId(designRefId)) throw new Error(`Invalid designRefId: ${designRefId}`);
  const origin = shopDomain.startsWith("http") ? shopDomain : `https://${shopDomain}`;
  const base = stripTrailingSlash(origin);
  const path = `/apps/${encodeURIComponent(proxySubpath)}/designer/edit/${designRefId}`;
  const params = new URLSearchParams();
  if (partKey) {
    params.set("part", partKey);
  }
  if (returnPath) {
    if (!returnPath.startsWith("/")) {
      throw new Error('returnPath must be a same-origin absolute path (leading "/")');
    }
    params.set("return", returnPath);
  }
  const query = params.toString();
  return query ? `${base}${path}?${query}` : `${base}${path}`;
}
function buildDesignerAdminEditUrl(options) {
  const { shopDomain, appHandle, designRefId, partKey } = options;
  if (!shopDomain) return null;
  if (!isValidDesignRefId(designRefId)) return null;
  const handle = appHandle?.trim();
  if (!handle) return null;
  const match = shopDomain.trim().toLowerCase().match(/^([a-z0-9-]+)\.myshopify\.com$/);
  const storeHandle = match?.[1] ?? null;
  if (!storeHandle) return null;
  const base = `https://admin.shopify.com/store/${storeHandle}/apps/${encodeURIComponent(
    handle
  )}/app/orders/by-design/${designRefId}`;
  if (partKey && isValidPartKey(partKey)) {
    const params = new URLSearchParams();
    params.set("part", partKey);
    return `${base}?${params.toString()}`;
  }
  return base;
}

// src/utils/shopify-cart-properties.ts
var TK_CART_PROPERTIES = {
  /** Internal Design cuid — legacy, still emitted for backward compat. */
  DESIGN_ID: "_tk_design_id",
  /** Public designRefId token — preferred, used by all new flows. */
  DESIGN_REF: "_tk_design_ref",
  /** Which DesignPart this line item represents (sheet id / side key / "composite"). */
  PART_KEY: "_tk_part_key",
  /** TK internal Product cuid the customer was viewing. */
  PRODUCT_REF: "_tk_product_ref",
  /** ProductPreset cuid for this variant. */
  PRESET_ID: "_tk_preset_id",
  /** Designer mode: GANGSHEET | DTF_BY_SIZE | APPAREL | PRODUCT_MOCKUP. */
  DESIGNER_MODE: "_tk_mode",
  /** Stable preview PNG URL (placeholder until job completes). */
  PREVIEW_URL: "_tk_preview_url",
  /** Stable full-export PNG URL (used by fulfillment). */
  EXPORT_URL: "_tk_export_url",
  /**
   * Customer-facing edit URL (Shopify App Proxy → designer). Renamed from
   * `_tk_edit_url` to make the audience explicit next to
   * `_tk_admin_edit_url`. Historical orders may still carry the old key; no
   * consumer reads either key verbatim (the cart block and the admin order
   * block both REBUILD the href from the validated designRef), so no
   * backward-compat alias is required.
   */
  CUSTOMER_EDIT_URL: "_tk_customer_edit_url",
  /**
   * Staff-only admin edit URL — an absolute admin.shopify.com deep link into
   * the embedded app's by-design landing route. Server-built and injected at
   * cart-bridge time (never client-set); the underscore prefix hides it from
   * the storefront cart UI while the admin order detail renders it as a native
   * staff-only link. See buildDesignerAdminEditUrl in design-urls.ts.
   */
  ADMIN_EDIT_URL: "_tk_admin_edit_url",
  /** Total sheet count in the order (gangsheet mode, for display/analytics). */
  SHEET_COUNT: "_tk_sheet_count",
  /** JSON array describing per-sheet breakdown (legacy gangsheet path). */
  ITEMS: "_tk_items",
  /** DesignRevision revisionNo pinned at add-to-cart time. */
  REVISION: "_tk_revision",
  /**
   * Order-summary token ("OS_" + 14 chars) minted per cart LINE at
   * add-to-cart time. The orders/create webhook maps it to the created
   * order via OrderSummaryLink; resolution is token → order → latest
   * revision PDF, so the link survives every edit flow.
   */
  SUMMARY_REF: "_tk_summary_ref",
  /**
   * Clickable order-summary PDF URL shown under the line item in the
   * Shopify admin (same pattern as _tk_preview_url). Stable forever:
   * `{PUBLIC_API}/public/orders/summary/{token}.pdf` — serves a
   * "being prepared" placeholder until the PDF exists, then always
   * streams the LATEST revision's summary.
   */
  SUMMARY_PDF_URL: "_tk_summary_pdf",
  /**
   * ProductOptionSubmission token ("OPS_" + base62). The orders/create webhook
   * resolves it tenant-scoped; visible option labels travel as separate
   * non-underscore properties built by the option engine.
   */
  OPTIONS_REF: "_tk_options_ref",
  /**
   * Reserved for the pricing phase (SHOPIFY_ADDON_LINE): links a hidden
   * "customization fee" cart line back to the parent submission. The webhook
   * ignores it until a Shopify surcharge mode is enabled.
   */
  ADDON_FOR: "_tk_addon_for"
};

// src/utils/order-initial-status.ts
function computeInitialOrderStatus(items) {
  if (items.length === 0) {
    return OrderStatus.NEW;
  }
  const allGangsheetWithDesign = items.every(
    (i) => i.uptType === ProductType.GANGSHEET && i.hasDesign
  );
  if (allGangsheetWithDesign) {
    return OrderStatus.EXPORTED;
  }
  const hasAnyDesign = items.some((i) => i.hasDesign);
  return hasAnyDesign ? OrderStatus.EXPORT_QUEUED : OrderStatus.NEW;
}

// src/utils/fulfillment-resolution.ts
var FulfillmentLane = {
  CUSTOM: "CUSTOM",
  POD: "POD"
};
function getFulfillmentLane(designContext, designerMode) {
  if (designContext === DesignContext.STOREFRONT || designerMode === DesignerMode.NONE) {
    return FulfillmentLane.CUSTOM;
  }
  return FulfillmentLane.POD;
}
function resolveFulfillmentSettings(lane, defaults, overrides) {
  if (lane === FulfillmentLane.POD) {
    const method2 = overrides.fulfillmentMethodOverride ?? defaults.podDefaultMethod;
    return {
      provider: FulfillmentProvider.TK_POD,
      method: method2,
      providerSource: "LOCKED",
      methodSource: overrides.fulfillmentMethodOverride ? "OVERRIDE" : "DEFAULT"
    };
  }
  const provider = overrides.fulfillmentProviderOverride ?? defaults.customDefaultProvider;
  if (provider === FulfillmentProvider.SELF) {
    return {
      provider,
      method: null,
      providerSource: overrides.fulfillmentProviderOverride ? "OVERRIDE" : "DEFAULT",
      methodSource: null
    };
  }
  const method = overrides.fulfillmentMethodOverride ?? defaults.customDefaultMethod;
  return {
    provider,
    method,
    providerSource: overrides.fulfillmentProviderOverride ? "OVERRIDE" : "DEFAULT",
    methodSource: overrides.fulfillmentMethodOverride ? "OVERRIDE" : "DEFAULT"
  };
}
var OrderFulfillmentMix = {
  /** Every line is fulfilled by Transfer Kingdom. */
  ALL_TK_POD: "ALL_TK_POD",
  /** Every line is self-fulfilled — no billing, no production/shipping actions. */
  ALL_SELF: "ALL_SELF",
  /** Both TK and SELF lines — actions/billing apply to TK lines only. */
  MIXED: "MIXED"
};
function getOrderFulfillmentMix(items) {
  if (items.length === 0) return OrderFulfillmentMix.ALL_TK_POD;
  const hasTk = items.some((i) => i.fulfillmentProvider === FulfillmentProvider.TK_POD);
  const hasSelf = items.some((i) => i.fulfillmentProvider === FulfillmentProvider.SELF);
  if (hasTk && hasSelf) return OrderFulfillmentMix.MIXED;
  return hasSelf ? OrderFulfillmentMix.ALL_SELF : OrderFulfillmentMix.ALL_TK_POD;
}
function orderRequiresFulfillmentRequest(items) {
  return items.some(
    (i) => i.fulfillmentProvider === FulfillmentProvider.TK_POD && i.fulfillmentMethod === FulfillmentMethod.MANUAL
  );
}
var FULFILLMENT_PROVIDER_LABELS = {
  TK_POD: "Transfer Kingdom",
  SELF: "Self-fulfill"
};
var FULFILLMENT_PROVIDER_LABELS_LONG = {
  TK_POD: "Fulfilled by Transfer Kingdom",
  SELF: "Self-fulfill"
};
var FULFILLMENT_METHOD_LABELS = {
  AUTO: "Auto",
  MANUAL: "Manual"
};
var FULFILLMENT_PROVIDER_DESCRIPTIONS = {
  TK_POD: "Transfer Kingdom prints and ships orders for this product. Orders are charged the wholesale production + shipping cost.",
  SELF: "You print and ship orders for this product yourself. These orders are never charged."
};
var FULFILLMENT_METHOD_DESCRIPTIONS = {
  AUTO: "Orders go to production automatically as soon as they are received.",
  MANUAL: 'Orders wait until you click "Request fulfillment" in your Shopify admin.'
};
var SELF_FULFILL_CONFIRMATION_MESSAGE = "This product will be removed from the Transfer Kingdom shipping profile and location. You'll handle printing and shipping yourself. You will not be charged for these orders. Existing orders are not affected.";

// src/utils/provider-submission.ts
var PROVIDER_SUBMISSION_PRODUCTION_STATUSES = [
  "IN_PRODUCTION",
  "PRODUCED",
  "SHIPPED",
  "CANCEL_REQUESTED"
];
var PRODUCTION_STATUS_SET = new Set(
  PROVIDER_SUBMISSION_PRODUCTION_STATUSES
);
function isProviderSubmissionInProduction(status) {
  return PRODUCTION_STATUS_SET.has(status);
}
function lineIsInProduction(submissions) {
  return submissions.some(
    (submission) => isProviderSubmissionInProduction(submission.status)
  );
}
function earliestSubmissionAt(submissions) {
  let earliest = null;
  for (const submission of submissions) {
    if (!submission.submittedAt) continue;
    if (!earliest || submission.submittedAt < earliest) {
      earliest = submission.submittedAt;
    }
  }
  return earliest;
}

// src/utils/design-edit-permission.ts
var PRODUCTION_OR_LATER = /* @__PURE__ */ new Set([
  "IN_PRODUCTION",
  "PRODUCTION_DONE",
  "READY_TO_SHIP",
  "SHIPPED",
  "CANCEL_REQUESTED"
]);
var EXPORT_IN_PROGRESS = /* @__PURE__ */ new Set(["EXPORT_QUEUED", "EXPORT_PROCESSING"]);
function allow() {
  return { canEdit: true, reason: null, message: null };
}
function deny(reason, message) {
  return { canEdit: false, reason, message };
}
function resolveDesignEditPermission(ctx) {
  if (ORDER_TERMINAL_STATUSES.has(ctx.orderStatus)) {
    return deny(
      "TERMINAL",
      "This order is finalized, so its design can no longer be edited."
    );
  }
  if (ctx.designContext !== DesignContext.STOREFRONT) {
    return deny(
      "PRODUCT_CONTEXT_ORDER",
      "This is a catalog product order. Edit the product design from My Products instead."
    );
  }
  if (EXPORT_IN_PROGRESS.has(ctx.orderStatus) || ctx.renderInFlight) {
    return deny(
      "EXPORT_IN_PROGRESS",
      "Print files are being generated. You can edit the design once export finishes."
    );
  }
  if (ctx.fulfillmentProvider === FulfillmentProvider.SELF) {
    if (ctx.surface === "ADMIN") {
      return deny(
        "SELF_ADMIN_READONLY",
        "This line is self-fulfilled by the merchant. Admin is read-only; the merchant edits it from their portal."
      );
    }
    return allow();
  }
  const inProduction = ctx.itemInProduction || PRODUCTION_OR_LATER.has(ctx.orderStatus);
  if (inProduction) {
    return deny(
      "IN_PRODUCTION",
      "This line is already in production and can no longer be edited."
    );
  }
  return allow();
}
function canEditDesign(ctx) {
  return resolveDesignEditPermission(ctx).canEdit;
}
function resolveOptionUploadEditPermission(ctx) {
  return resolveDesignEditPermission({
    ...ctx,
    designContext: DesignContext.STOREFRONT
  });
}

// src/utils/variant-key.ts
function normalizeOptionValue(value) {
  if (value === null || value === void 0) return "";
  const trimmed2 = String(value).trim();
  if (!trimmed2) return "";
  return trimmed2.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
}
function normalizeVariantKey(options, optionOrder) {
  if (!options) return "";
  const lowerKeyed = /* @__PURE__ */ new Map();
  for (const [k, v] of Object.entries(options)) {
    lowerKeyed.set(k.toLowerCase(), v);
  }
  const orderedKeys = (() => {
    if (optionOrder && optionOrder.length > 0) {
      const seen = /* @__PURE__ */ new Set();
      const ordered = [];
      for (const name of optionOrder) {
        const lk = name.toLowerCase();
        if (lowerKeyed.has(lk) && !seen.has(lk)) {
          ordered.push(lk);
          seen.add(lk);
        }
      }
      const tail = [...lowerKeyed.keys()].filter((k) => !seen.has(k)).sort();
      return [...ordered, ...tail];
    }
    return [...lowerKeyed.keys()].sort();
  })();
  const segments = [];
  for (const key of orderedKeys) {
    const segment = normalizeOptionValue(lowerKeyed.get(key));
    if (segment) segments.push(segment);
  }
  return segments.join("_");
}
function buildVariantFingerprint(options, optionOrder) {
  if (!options) return null;
  const variantKey = normalizeVariantKey(options, optionOrder);
  if (!variantKey) return null;
  const canonicalOptions = {};
  for (const [k, v] of Object.entries(options)) {
    const value = normalizeOptionValue(v);
    if (value) canonicalOptions[k.toLowerCase()] = value;
  }
  return { variantKey, canonicalOptions };
}

// src/utils/storage-keys.ts
var CUID_PATTERN = /^c[a-z0-9]{6,}$/i;
function assertCuid(name, value) {
  if (typeof value !== "string" || !CUID_PATTERN.test(value)) {
    throw new TypeError(
      `storage-keys: ${name} must be a cuid (got: ${JSON.stringify(value)}).`
    );
  }
}
function designSidePrintExportKey(designId, printAreaId) {
  assertCuid("designId", designId);
  assertCuid("printAreaId", printAreaId);
  return `designs/${designId}/sides/${printAreaId}/print_300dpi.png`;
}
function designSidePrintCanvasKey(designId, printAreaId) {
  assertCuid("designId", designId);
  assertCuid("printAreaId", printAreaId);
  return `designs/${designId}/sides/${printAreaId}/print_canvas_300dpi.png`;
}
var DIMS_KEY_PATTERN = /^\d+(\.\d+)?x\d+(\.\d+)?$/;
function assertDimsKey(value) {
  if (typeof value !== "string" || !DIMS_KEY_PATTERN.test(value)) {
    throw new TypeError(
      `storage-keys: dimsKey must match \`{w}x{h}\` (got: ${JSON.stringify(value)}).`
    );
  }
}
function designSideDimsPrintExportKey(designId, printAreaId, dimsKey) {
  assertCuid("designId", designId);
  assertCuid("printAreaId", printAreaId);
  assertDimsKey(dimsKey);
  return `designs/${designId}/sides/${printAreaId}/print_300dpi_${dimsKey}.png`;
}
function designSideDimsPrintCanvasKey(designId, printAreaId, dimsKey) {
  assertCuid("designId", designId);
  assertCuid("printAreaId", printAreaId);
  assertDimsKey(dimsKey);
  return `designs/${designId}/sides/${printAreaId}/print_canvas_300dpi_${dimsKey}.png`;
}
function designVariantSidePreviewKey(designId, productVariantId, printAreaId) {
  assertCuid("designId", designId);
  assertCuid("productVariantId", productVariantId);
  assertCuid("printAreaId", printAreaId);
  return `designs/${designId}/variants/${productVariantId}/sides/${printAreaId}/preview.jpg`;
}
function designVariantCompositeKey(designId, productVariantId) {
  assertCuid("designId", designId);
  assertCuid("productVariantId", productVariantId);
  return `designs/${designId}/variants/${productVariantId}/composite_preview.jpg`;
}
function designStoragePrefix(designId) {
  assertCuid("designId", designId);
  return `designs/${designId}/`;
}
function designLibraryPreviewKey(libraryDesignId) {
  assertCuid("libraryDesignId", libraryDesignId);
  return `designs/${libraryDesignId}/library_preview.jpg`;
}
var PREVIEW_CONTENT_HASH_RE = /^[a-f0-9]{8,64}$/i;
function appendPreviewVersion(url, version) {
  const hashIdx = url.indexOf("#");
  const fragment = hashIdx >= 0 ? url.slice(hashIdx) : "";
  const withoutFragment = hashIdx >= 0 ? url.slice(0, hashIdx) : url;
  const qIdx = withoutFragment.indexOf("?");
  const path = qIdx >= 0 ? withoutFragment.slice(0, qIdx) : withoutFragment;
  return `${path}?v=${version}${fragment}`;
}
function withPreviewContentHash(url, contentHash) {
  if (!PREVIEW_CONTENT_HASH_RE.test(contentHash)) {
    throw new TypeError(
      `withPreviewContentHash: contentHash must be hex (got ${JSON.stringify(contentHash)})`
    );
  }
  return appendPreviewVersion(url, contentHash.toLowerCase());
}
function versionedSidePreviewUrl(storageUrl, contentHash, updatedAt) {
  if (contentHash && PREVIEW_CONTENT_HASH_RE.test(contentHash)) {
    return withPreviewContentHash(storageUrl, contentHash);
  }
  const epochMs = updatedAt instanceof Date ? updatedAt.getTime() : Number.NaN;
  if (!Number.isFinite(epochMs)) return storageUrl;
  const epoch = Math.floor(epochMs / 1e3);
  if (epoch < 0) return storageUrl;
  return appendPreviewVersion(storageUrl, String(epoch));
}
function canonicalPreviewStorageKey(url) {
  const trimmed2 = url.trim();
  const hashIdx = trimmed2.indexOf("#");
  const withoutFragment = hashIdx >= 0 ? trimmed2.slice(0, hashIdx) : trimmed2;
  const marker = "designs/";
  const idx = withoutFragment.indexOf(marker);
  if (idx < 0) return withoutFragment;
  const raw = withoutFragment.slice(idx);
  const qIdx = raw.indexOf("?");
  if (qIdx < 0) return raw;
  const path = raw.slice(0, qIdx);
  const version = new URLSearchParams(raw.slice(qIdx + 1)).get("v");
  return version ? `${path}?v=${version}` : path;
}
function stripUrlQueryAndFragment(urlOrKey) {
  const hashIdx = urlOrKey.indexOf("#");
  const withoutHash = hashIdx >= 0 ? urlOrKey.slice(0, hashIdx) : urlOrKey;
  const qIdx = withoutHash.indexOf("?");
  return qIdx >= 0 ? withoutHash.slice(0, qIdx) : withoutHash;
}

// src/utils/print-area-geometry.ts
var APPAREL_MIN_PRINT_AREA_IN = 1;
var APPAREL_MAX_PRINT_AREA_IN = 50;
var MIN_REL_DIM = 0.1;
var MIN_REL_DIM_STRICT = 0.05;
var SNAP_GUIDE_TOLERANCE = 0.04;
var SNAP_HARD_TOLERANCE = 8e-3;
function clamp(value, min, max) {
  if (Number.isNaN(value)) return min;
  return Math.max(min, Math.min(max, value));
}
function clampRect(rect) {
  const width = clamp(rect.width, MIN_REL_DIM_STRICT, 1);
  const height = clamp(rect.height, MIN_REL_DIM_STRICT, 1);
  const x = clamp(rect.x, 0, 1 - width);
  const y = clamp(rect.y, 0, 1 - height);
  return { x, y, width, height };
}
function moveRect(rect, dx, dy) {
  return clampRect({
    x: rect.x + dx,
    y: rect.y + dy,
    width: rect.width,
    height: rect.height
  });
}
function resizeRectAspectLocked(rect, cursorX, cursorY, ratio) {
  const safeRatio = ratio > 0 ? ratio : 1;
  const maxWidthByCursor = clamp(cursorX - rect.x, 0, 1 - rect.x);
  const maxHeightByCursor = clamp(cursorY - rect.y, 0, 1 - rect.y);
  let nextWidth = Math.max(MIN_REL_DIM, maxWidthByCursor);
  let nextHeight = nextWidth / safeRatio;
  if (nextHeight > 1 - rect.y) {
    nextHeight = Math.max(MIN_REL_DIM, maxHeightByCursor);
    nextWidth = nextHeight * safeRatio;
  }
  if (nextWidth < MIN_REL_DIM || nextHeight < MIN_REL_DIM) {
    nextWidth = MIN_REL_DIM;
    nextHeight = MIN_REL_DIM / safeRatio;
  }
  return clampRect({
    x: rect.x,
    y: rect.y,
    width: nextWidth,
    height: nextHeight
  });
}
function resizeRectFree(rect, cursorX, cursorY) {
  const nextWidth = clamp(cursorX - rect.x, MIN_REL_DIM, 1 - rect.x);
  const nextHeight = clamp(cursorY - rect.y, MIN_REL_DIM, 1 - rect.y);
  return clampRect({
    x: rect.x,
    y: rect.y,
    width: nextWidth,
    height: nextHeight
  });
}
function deriveInchFromFrame(rect, anchor, value, min, max, decimals = 2) {
  const factor = 10 ** decimals;
  const round = (v) => Math.round(v * factor) / factor;
  const frameRatio = rect.width > 0 && rect.height > 0 ? rect.width / rect.height : 1;
  const anchorValue = clamp(value, min, max);
  if (anchor === "width") {
    return {
      widthIn: round(anchorValue),
      heightIn: round(clamp(anchorValue / frameRatio, min, max))
    };
  }
  return {
    widthIn: round(clamp(anchorValue * frameRatio, min, max)),
    heightIn: round(anchorValue)
  };
}
function scaleFromMeasure(relLength, realInches) {
  if (!(realInches > 0) || !(relLength > 0)) return 0;
  return relLength / realInches;
}
function printRectFromInchesAtScale(widthIn, heightIn, scale, anchor) {
  const width = widthIn * scale;
  const height = heightIn * scale;
  const overflow = width > 1 || height > 1;
  const x = clamp(anchor.cx - width / 2, 0, Math.max(0, 1 - width));
  const y = clamp(anchor.cy - height / 2, 0, Math.max(0, 1 - height));
  return { rect: { x, y, width, height }, overflow };
}
function scaleConsistency(scaleX, scaleY) {
  const avg = (scaleX + scaleY) / 2;
  if (!(avg > 0)) return 0;
  return Math.abs(scaleX - scaleY) / avg;
}
function clampRectWithin(rect, bounds) {
  const width = Math.min(rect.width, bounds.width);
  const height = Math.min(rect.height, bounds.height);
  const x = clamp(rect.x, bounds.x, bounds.x + bounds.width - width);
  const y = clamp(rect.y, bounds.y, bounds.y + bounds.height - height);
  return { x, y, width, height };
}
function printRectInBounds(widthIn, heightIn, scale, center, bounds) {
  const width = widthIn * scale;
  const height = heightIn * scale;
  const EPS = 1e-6;
  const overflow = width > bounds.width + EPS || height > bounds.height + EPS;
  const fitW = Math.min(width, bounds.width);
  const fitH = Math.min(height, bounds.height);
  const x = clamp(center.cx - width / 2, bounds.x, bounds.x + bounds.width - fitW);
  const y = clamp(center.cy - height / 2, bounds.y, bounds.y + bounds.height - fitH);
  return { rect: { x, y, width, height }, overflow };
}
function snapRectToCenter(rect, guideTolerance = SNAP_GUIDE_TOLERANCE, hardTolerance = SNAP_HARD_TOLERANCE) {
  const centerX = rect.x + rect.width / 2;
  const centerY = rect.y + rect.height / 2;
  const distX = Math.abs(centerX - 0.5);
  const distY = Math.abs(centerY - 0.5);
  let nextX = rect.x;
  let nextY = rect.y;
  if (distX < hardTolerance) {
    nextX = 0.5 - rect.width / 2;
  }
  if (distY < hardTolerance) {
    nextY = 0.5 - rect.height / 2;
  }
  return {
    rect: clampRect({ x: nextX, y: nextY, width: rect.width, height: rect.height }),
    guides: {
      vertical: distX < guideTolerance,
      horizontal: distY < guideTolerance
    }
  };
}
function recenterForRatio(prev, ratio) {
  const safeRatio = ratio > 0 ? ratio : 1;
  const diagonal = Math.sqrt(prev.width ** 2 + prev.height ** 2) || 0.5;
  let height = diagonal / Math.sqrt(safeRatio ** 2 + 1);
  let width = height * safeRatio;
  const min = 0.15;
  const maxAxis = 0.9;
  if (width < min) {
    width = min;
    height = width / safeRatio;
  }
  if (height < min) {
    height = min;
    width = height * safeRatio;
  }
  if (width > maxAxis) {
    width = maxAxis;
    height = width / safeRatio;
  }
  if (height > maxAxis) {
    height = maxAxis;
    width = height * safeRatio;
  }
  return clampRect({
    x: (1 - width) / 2,
    y: (1 - height) / 2,
    width,
    height
  });
}
function alignRectToRatio(rect, ratio) {
  const safeRatio = ratio > 0 ? ratio : 1;
  const currentRatio = rect.width / rect.height;
  if (Math.abs(currentRatio - safeRatio) < 0.01) return rect;
  let height = rect.width / safeRatio;
  let width = rect.width;
  if (rect.y + height > 1) {
    height = 1 - rect.y;
    width = height * safeRatio;
  }
  return clampRect({ x: rect.x, y: rect.y, width, height });
}
function calcContentSizeIn(constraintAspect, maxPrintWidthIn, maxPrintHeightIn) {
  const aspect = constraintAspect > 0 && Number.isFinite(constraintAspect) ? constraintAspect : 1;
  const sheetW = maxPrintWidthIn > 0 ? maxPrintWidthIn : 1;
  const sheetH = maxPrintHeightIn > 0 ? maxPrintHeightIn : 1;
  const sheetAspect = sheetH > 0 ? sheetW / sheetH : 1;
  if (aspect >= sheetAspect) {
    return { widthIn: sheetW, heightIn: sheetW / aspect };
  }
  return { widthIn: sheetH * aspect, heightIn: sheetH };
}
function resolveEffectivePrintSizeIn(pa) {
  if (pa.sizingMode !== "FREE") {
    return { widthIn: pa.width, heightIn: pa.height };
  }
  const rw = pa.printAreaRelative?.width;
  const rh = pa.printAreaRelative?.height;
  const aspect = typeof rw === "number" && typeof rh === "number" && Number.isFinite(rw) && Number.isFinite(rh) && rw > 0 && rh > 0 ? rw / rh : 1;
  return calcContentSizeIn(aspect, pa.width, pa.height);
}
function resolveVariantEffectivePrintSizeIn(pa, override) {
  let widthIn = pa.width;
  let heightIn = pa.height;
  const wOv = override?.printAreaWidthInOverride;
  const hOv = override?.printAreaHeightInOverride;
  if (typeof wOv === "number" && Number.isFinite(wOv) && wOv > 0) {
    widthIn = wOv;
  }
  if (typeof hOv === "number" && Number.isFinite(hOv) && hOv > 0) {
    heightIn = hOv;
  }
  if (pa.sizingMode !== "FREE") {
    return { widthIn, heightIn };
  }
  const rect = pickValidRect(override?.printAreaOverride) ?? pickValidRect(pa.printAreaRelative);
  const aspect = rect ? rect.width / rect.height : 1;
  return calcContentSizeIn(aspect, widthIn, heightIn);
}
function pickValidRect(rect) {
  const w = rect?.width;
  const h = rect?.height;
  if (typeof w === "number" && typeof h === "number" && Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
    return { width: w, height: h };
  }
  return null;
}
function printDimsKey(widthIn, heightIn) {
  return `${formatDim(widthIn)}x${formatDim(heightIn)}`;
}
function formatDim(v) {
  const rounded = Math.round(v * 100) / 100;
  return rounded.toFixed(2).replace(/\.?0+$/, "");
}
function containRectForAspect(rect, targetAspect) {
  const safeAspect = targetAspect > 0 && Number.isFinite(targetAspect) ? targetAspect : 1;
  const frameAspect = rect.width > 0 && rect.height > 0 ? rect.width / rect.height : 1;
  if (Math.abs(frameAspect - safeAspect) < 0.01) return rect;
  if (frameAspect < safeAspect) {
    const height = rect.width / safeAspect;
    return {
      x: rect.x,
      y: rect.y + (rect.height - height) / 2,
      width: rect.width,
      height
    };
  }
  const width = rect.height * safeAspect;
  return {
    x: rect.x + (rect.width - width) / 2,
    y: rect.y,
    width,
    height: rect.height
  };
}
function roundRect(rect, decimals = 4) {
  const factor = 10 ** decimals;
  return {
    x: Math.round(rect.x * factor) / factor,
    y: Math.round(rect.y * factor) / factor,
    width: Math.round(rect.width * factor) / factor,
    height: Math.round(rect.height * factor) / factor
  };
}

// src/utils/mockup-geometry.ts
function parseHexFill(hex) {
  if (!hex) return null;
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  const h = m[1];
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
    alpha: 1
  };
}
function coerceRelRect(value) {
  if (!value || typeof value !== "object") return null;
  const v = value;
  const x = Number(v["x"]);
  const y = Number(v["y"]);
  const width = Number(v["width"]);
  const height = Number(v["height"]);
  if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(width) || !Number.isFinite(height)) {
    return null;
  }
  return {
    x: clamp01(x),
    y: clamp01(y),
    width: clamp01(width),
    height: clamp01(height)
  };
}
function legacyRectFromPrintArea(p) {
  const w = 0.4;
  const h = 0.4;
  const cx = (p.positionX ?? 50) / 100;
  const cy = (p.positionY ?? 50) / 100;
  return {
    x: Math.max(0, cx - w / 2),
    y: Math.max(0, cy - h / 2),
    width: w,
    height: h
  };
}
function clamp01(n) {
  if (n < 0) return 0;
  if (n > 1) return 1;
  return n;
}

// src/utils/color-name-to-hex.ts
var COLOR_MAP = Object.freeze({
  black: "#000000",
  white: "#FFFFFF",
  red: "#CC0000",
  green: "#008000",
  blue: "#0000FF",
  yellow: "#FFD700",
  orange: "#FF6600",
  purple: "#800080",
  pink: "#FFC0CB",
  brown: "#8B4513",
  gray: "#808080",
  grey: "#808080",
  cyan: "#00FFFF",
  magenta: "#FF00FF",
  silver: "#C0C0C0",
  gold: "#FFD700",
  ivory: "#FFFFF0",
  beige: "#F5F5DC",
  coral: "#FF7F50",
  salmon: "#FA8072",
  teal: "#008080",
  turquoise: "#40E0D0",
  indigo: "#4B0082",
  violet: "#EE82EE",
  maroon: "#800000",
  olive: "#808000",
  tan: "#D2B48C",
  khaki: "#C3B091",
  lavender: "#E6E6FA",
  plum: "#DDA0DD",
  peach: "#FFDAB9",
  mint: "#98FF98",
  aqua: "#00FFFF",
  lime: "#00FF00",
  crimson: "#DC143C",
  scarlet: "#FF2400",
  burgundy: "#800020",
  mauve: "#E0B0FF",
  fuchsia: "#FF00FF",
  chartreuse: "#7FFF00",
  periwinkle: "#CCCCFF",
  orchid: "#DA70D6",
  navy: "#1B2A4A",
  "navy blue": "#000080",
  "dark navy": "#0D1B3E",
  "royal blue": "#4169E1",
  royal: "#4169E1",
  "sky blue": "#87CEEB",
  "light blue": "#ADD8E6",
  "baby blue": "#89CFF0",
  "powder blue": "#B0E0E6",
  "steel blue": "#4682B4",
  "slate blue": "#6A5ACD",
  cobalt: "#0047AB",
  "cobalt blue": "#0047AB",
  "electric blue": "#7DF9FF",
  "ocean blue": "#0077BE",
  denim: "#1560BD",
  midnight: "#191970",
  "midnight blue": "#191970",
  "dark red": "#8B0000",
  wine: "#722F37",
  "wine red": "#722F37",
  cardinal: "#C41E3A",
  cherry: "#DE3163",
  "cherry red": "#DE3163",
  "brick red": "#CB4154",
  rust: "#B7410E",
  tomato: "#FF6347",
  "hot pink": "#FF69B4",
  "deep pink": "#FF1493",
  rose: "#FF007F",
  "rose pink": "#FF66CC",
  "dusty rose": "#DCAE96",
  blush: "#DE5D83",
  berry: "#8E4585",
  "dark green": "#006400",
  "forest green": "#228B22",
  forest: "#228B22",
  "hunter green": "#355E3B",
  "olive green": "#6B8E23",
  "army green": "#4B5320",
  "military green": "#4B5320",
  sage: "#BCB88A",
  "sage green": "#BCB88A",
  moss: "#8A9A5B",
  "moss green": "#8A9A5B",
  emerald: "#50C878",
  "emerald green": "#50C878",
  "kelly green": "#4CBB17",
  "lime green": "#32CD32",
  "mint green": "#98FB98",
  seafoam: "#93E9BE",
  "seafoam green": "#93E9BE",
  charcoal: "#36454F",
  "dark charcoal": "#333333",
  "dark grey": "#A9A9A9",
  "dark gray": "#A9A9A9",
  "light grey": "#D3D3D3",
  "light gray": "#D3D3D3",
  slate: "#708090",
  "slate grey": "#708090",
  "slate gray": "#708090",
  graphite: "#383838",
  ash: "#B2BEB5",
  "ash grey": "#B2BEB5",
  "ash gray": "#B2BEB5",
  "heather grey": "#9AA297",
  "heather gray": "#9AA297",
  heather: "#9AA297",
  "dark heather": "#4A4A4A",
  "sport grey": "#90908E",
  "sport gray": "#90908E",
  "off white": "#FAF9F6",
  "off-white": "#FAF9F6",
  cream: "#FFFDD0",
  eggshell: "#F0EAD6",
  natural: "#F5F0E1",
  oatmeal: "#D4C5A9",
  vanilla: "#F3E5AB",
  pearl: "#F0EAD6",
  snow: "#FFFAFA",
  linen: "#FAF0E6",
  "antique white": "#FAEBD7",
  sand: "#C2B280",
  "dark brown": "#654321",
  chocolate: "#7B3F00",
  coffee: "#6F4E37",
  mocha: "#967969",
  camel: "#C19A6B",
  caramel: "#FFD59A",
  cinnamon: "#D2691E",
  walnut: "#773F1A",
  chestnut: "#954535",
  sienna: "#A0522D",
  espresso: "#3C1414",
  taupe: "#483C32",
  "bright yellow": "#FFEA00",
  "golden yellow": "#FFDF00",
  mustard: "#FFDB58",
  amber: "#FFBF00",
  sunflower: "#FFDA03",
  marigold: "#EAA221",
  "bright orange": "#FF6103",
  "burnt orange": "#CC5500",
  tangerine: "#FF9966",
  apricot: "#FBCEB1",
  "neon orange": "#FF6700",
  "safety orange": "#FF7900",
  "dark purple": "#301934",
  "deep purple": "#36013F",
  "royal purple": "#7851A9",
  grape: "#6F2DA8",
  eggplant: "#614051",
  amethyst: "#9966CC",
  lilac: "#C8A2C8",
  wisteria: "#BDB5D5",
  "neon green": "#39FF14",
  "neon yellow": "#DFFF00",
  "neon pink": "#FF6EC7",
  "electric green": "#00FF00",
  fluorescent: "#CCFF00",
  "irish green": "#009A44",
  sapphire: "#0F52BA",
  heliconia: "#E36F8A",
  azalea: "#F19CBB",
  "galapagos blue": "#006D6F",
  "antique cherry red": "#6E1C34",
  "tropical blue": "#C0DDE6",
  "independence red": "#9E1B32",
  military: "#4B5320",
  "turf green": "#3E8948",
  kiwi: "#8EE53F",
  "prairie dust": "#A1887F",
  sunset: "#FAD6A5",
  tweed: "#8D7B6A",
  stone: "#928E85",
  "ice blue": "#99CCFF",
  "light pink": "#FFB6C1",
  daisy: "#FFD12A",
  "heather sapphire": "#5B86A8",
  "heather navy": "#3D4F5F",
  "heather red": "#A0474F",
  "heather green": "#5A7A5B",
  "heather blue": "#576F8A"
});
var HEX_6 = /^#[0-9a-f]{6}$/i;
var HEX_3 = /^#[0-9a-f]{3}$/i;
function normalizeColorName(input) {
  return input.trim().toLowerCase().replace(/\s+/g, " ");
}
function resolveColorNameToHex(input) {
  if (!input) return null;
  const normalized = normalizeColorName(input);
  if (!normalized) return null;
  if (HEX_6.test(normalized)) {
    return normalized.toUpperCase();
  }
  if (HEX_3.test(normalized)) {
    const [, r, g, b] = normalized.split("");
    return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
  }
  return COLOR_MAP[normalized] ?? null;
}
function isValidHex6(input) {
  return typeof input === "string" && HEX_6.test(input);
}

// src/utils/oklab.ts
var SRGB_TO_LINEAR = new Float64Array(256);
for (let i = 0; i < 256; i += 1) {
  const c = i / 255;
  SRGB_TO_LINEAR[i] = c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
}
function linearToSrgbChannel(c) {
  const clamped = c <= 0 ? 0 : c >= 1 ? 1 : c;
  const srgb = clamped <= 31308e-7 ? clamped * 12.92 : 1.055 * Math.pow(clamped, 1 / 2.4) - 0.055;
  return Math.round(srgb * 255);
}
function srgbToOklab(r, g, b, out) {
  const lr = SRGB_TO_LINEAR[r & 255];
  const lg = SRGB_TO_LINEAR[g & 255];
  const lb = SRGB_TO_LINEAR[b & 255];
  const l = Math.cbrt(0.4122214708 * lr + 0.5363325363 * lg + 0.0514459929 * lb);
  const m = Math.cbrt(0.2119034982 * lr + 0.6806995451 * lg + 0.1073969566 * lb);
  const s = Math.cbrt(0.0883024619 * lr + 0.2817188376 * lg + 0.6299787005 * lb);
  const target2 = out ?? [0, 0, 0];
  target2[0] = 0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s;
  target2[1] = 1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s;
  target2[2] = 0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s;
  return target2;
}
function oklabToSrgb(lab) {
  const l = lab[0] + 0.3963377774 * lab[1] + 0.2158037573 * lab[2];
  const m = lab[0] - 0.1055613458 * lab[1] - 0.0638541728 * lab[2];
  const s = lab[0] - 0.0894841775 * lab[1] - 1.291485548 * lab[2];
  const l3 = l * l * l;
  const m3 = m * m * m;
  const s3 = s * s * s;
  return {
    r: linearToSrgbChannel(4.0767416621 * l3 - 3.3077115913 * m3 + 0.2309699292 * s3),
    g: linearToSrgbChannel(-1.2684380046 * l3 + 2.6097574011 * m3 - 0.3413193965 * s3),
    b: linearToSrgbChannel(-0.0041960863 * l3 - 0.7034186147 * m3 + 1.707614701 * s3)
  };
}
var TOE_K1 = 0.206;
var TOE_K2 = 0.03;
var TOE_K3 = (1 + TOE_K1) / (1 + TOE_K2);
function applyLightnessToe(l) {
  const k3l = TOE_K3 * l;
  return 0.5 * (k3l - TOE_K1 + Math.sqrt((k3l - TOE_K1) * (k3l - TOE_K1) + 4 * TOE_K2 * k3l));
}
function removeLightnessToe(lr) {
  return (lr * lr + TOE_K1 * lr) / (TOE_K3 * (lr + TOE_K2));
}
function srgbToOklabLr(r, g, b, out) {
  const lab = srgbToOklab(r, g, b, out);
  lab[0] = applyLightnessToe(lab[0]);
  return lab;
}
function oklabDistance(a, b) {
  const dl = a[0] - b[0];
  const da = a[1] - b[1];
  const db = a[2] - b[2];
  return Math.sqrt(dl * dl + da * da + db * db);
}
function toleranceToOklabDistance(tolerance) {
  const t = Math.min(100, Math.max(0, tolerance)) / 100;
  return 0.02 + Math.pow(t, 1.4) * 0.38;
}

// src/utils/export-naming.ts
var MAX_FILENAME_LENGTH = 100;
var MAX_VARIANT_SLUG_LENGTH = 15;
function sanitizeFileToken(text, maxLength = 50) {
  if (!text) return "";
  return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "_").replace(/_+/g, "_").replace(/^_+|_+$/g, "").slice(0, maxLength);
}
function extractOrderDigits(orderNumber) {
  return (orderNumber || "").replace(/\D/g, "");
}
function fnv1a32Hex(input) {
  let hash = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = hash + ((hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24)) >>> 0;
  }
  return hash.toString(16).padStart(8, "0");
}
function buildVariantSlug(variantSku, variantTitle, variantId) {
  const base = variantSku || variantTitle || "";
  if (!base) return "";
  const sanitized = sanitizeFileToken(base, MAX_VARIANT_SLUG_LENGTH);
  const hashInput = variantId || variantSku || "";
  const suffix = hashInput ? fnv1a32Hex(hashInput) : "";
  if (!sanitized) return suffix;
  return suffix ? `${sanitized}_${suffix}` : sanitized;
}
function formatSizeInches(value) {
  return String(Number(value.toFixed(2)));
}
function buildExportBaseName(ctx) {
  const parts = [
    `item${String(Math.max(1, Math.trunc(ctx.itemNo))).padStart(2, "0")}`,
    extractOrderDigits(ctx.orderNumber) || "order",
    sanitizeFileToken(ctx.source, 12) || "portal",
    `r${Math.max(1, Math.trunc(ctx.revision))}`,
    sanitizeFileToken(ctx.sideKey, 48) || "part"
  ];
  const variantSlug = buildVariantSlug(
    ctx.variantSku,
    ctx.variantTitle,
    ctx.variantId
  );
  if (variantSlug) parts.push(variantSlug);
  if (typeof ctx.widthIn === "number" && ctx.widthIn > 0 && typeof ctx.heightIn === "number" && ctx.heightIn > 0) {
    parts.push(
      `${formatSizeInches(ctx.widthIn)}x${formatSizeInches(ctx.heightIn)}in`
    );
  }
  return parts.join("_");
}
function buildExportFileName(ctx, type) {
  const baseName = buildExportBaseName(ctx);
  const extension = type === "mockup" ? "jpg" : "png";
  const suffix = `_${type}.${extension}`;
  if (baseName.length + suffix.length > MAX_FILENAME_LENGTH) {
    return `${baseName.slice(0, MAX_FILENAME_LENGTH - suffix.length)}${suffix}`;
  }
  return `${baseName}${suffix}`;
}

// src/utils/sheet-dimensions.ts
var MIN_SHEET_HEIGHT_IN = 1;
function num(value, fallback) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}
function rotatedBottom(y, width, height, degrees) {
  if (!degrees || Math.abs(degrees) < 0.5) return y + height;
  const rad = degrees * Math.PI / 180;
  const sin = Math.sin(rad);
  const cos = Math.cos(rad);
  const c0 = y;
  const c1 = y + width * sin;
  const c2 = y + height * cos;
  const c3 = y + width * sin + height * cos;
  return Math.max(c0, c1, c2, c3);
}
function computeSheetContentHeightIn(objects, options = {}) {
  const marginIn = Math.max(0, num(options.marginIn, 0));
  const stored = Math.max(0, num(options.storedActualHeightIn, 0));
  const minHeightIn = Math.max(0, num(options.minHeightIn, MIN_SHEET_HEIGHT_IN));
  const presetMax = Math.max(0, num(options.presetMaxHeightIn, 0));
  let contentBottom = 0;
  for (const obj of objects ?? []) {
    if (!obj) continue;
    if (obj.type !== void 0 && obj.type !== "image") continue;
    const width = num(obj.width, 0);
    const height = num(obj.height, 0);
    if (width <= 0 || height <= 0) continue;
    const bottom = rotatedBottom(
      num(obj.y, 0),
      width,
      height,
      num(obj.rotation, 0)
    );
    if (bottom > contentBottom) contentBottom = bottom;
  }
  const fromContent = contentBottom > 0 ? Math.ceil((contentBottom + marginIn) * 100) / 100 : 0;
  let result = Math.max(stored, fromContent, minHeightIn);
  if (presetMax > 0) {
    result = Math.min(result, presetMax);
    if (fromContent > result) result = fromContent;
  }
  return result;
}

// src/utils/print-size.ts
function round2(value) {
  return Math.round(value * 100) / 100;
}
function formatActualPrintSize(widthIn, heightIn) {
  if (typeof widthIn !== "number" || typeof heightIn !== "number" || !Number.isFinite(widthIn) || !Number.isFinite(heightIn) || widthIn <= 0 || heightIn <= 0) {
    return null;
  }
  const fmt = (v) => String(round2(v));
  return `${fmt(widthIn)}x${fmt(heightIn)}`;
}
function resolveActualPrintSize(widthIn, heightIn) {
  const label = formatActualPrintSize(widthIn, heightIn);
  if (!label) {
    return {
      actualPrintSize: null,
      actualPrintWidthIn: null,
      actualPrintHeightIn: null
    };
  }
  return {
    actualPrintSize: label,
    actualPrintWidthIn: round2(widthIn),
    actualPrintHeightIn: round2(heightIn)
  };
}
function resolveManifestFileActualPrintSize(part, measured, designJson) {
  const fromMeasured = resolveActualPrintSize(
    measured?.widthIn,
    measured?.heightIn
  );
  if (fromMeasured.actualPrintSize) return fromMeasured;
  if (part.kind === "SHEET") {
    const trim = extractSheetTrimSizeByPartKey(designJson, part.partKey);
    const fromTrim = resolveActualPrintSize(trim.widthIn, trim.heightIn);
    if (fromTrim.actualPrintSize) return fromTrim;
    return resolveActualPrintSize(part.widthIn, part.heightIn);
  }
  return fromMeasured;
}
function extractSheetTrimSizeByPartKey(designJson, partKey) {
  const empty = { widthIn: null, heightIn: null };
  const idx = resolveSheetIndexByPartKey(partKey, designJson);
  if (idx === null) return empty;
  const sheets = designJson.sheets;
  const sheet = sheets[idx];
  if (!sheet || typeof sheet !== "object") return empty;
  const w = sheet.actualWidthIn;
  const h = sheet.actualHeightIn;
  return {
    widthIn: typeof w === "number" && Number.isFinite(w) && w > 0 ? w : null,
    heightIn: typeof h === "number" && Number.isFinite(h) && h > 0 ? h : null
  };
}

// src/utils/pricing-math.ts
function roundMoney(value) {
  if (!Number.isFinite(value)) return 0;
  return Math.round((value + Number.EPSILON) * 100) / 100;
}
function formatMoneyValue(value) {
  return roundMoney(value).toFixed(2);
}
function parseMoneyInput(input) {
  if (typeof input !== "string") return null;
  const normalized = input.replace(/[^0-9.]/g, "");
  if (normalized.length === 0) return null;
  const parsed = Number.parseFloat(normalized);
  if (!Number.isFinite(parsed) || parsed < 0) return null;
  return roundMoney(parsed);
}
function applyPercentToPrice(currentPrice, percent) {
  if (!Number.isFinite(currentPrice) || !Number.isFinite(percent)) {
    return roundMoney(currentPrice);
  }
  const next = currentPrice * (1 + percent / 100);
  return roundMoney(Math.max(0, next));
}
function priceFromCostMargin(cost, marginPercent) {
  if (cost == null || !Number.isFinite(cost)) return null;
  if (!Number.isFinite(marginPercent)) return roundMoney(cost);
  return roundMoney(Math.max(0, cost * (1 + marginPercent / 100)));
}
function computeProfit(price, cost) {
  if (cost == null || !Number.isFinite(cost)) return null;
  if (!Number.isFinite(price)) return null;
  return roundMoney(price - cost);
}
function adjustPrice(base, op, unit, value, cost) {
  if (!Number.isFinite(value)) return null;
  const magnitude = Math.abs(value);
  switch (op) {
    case "set":
      return roundMoney(Math.max(0, magnitude));
    case "margin":
      return priceFromCostMargin(cost, magnitude);
    case "increase":
      if (unit === "percent") return applyPercentToPrice(base, magnitude);
      return roundMoney(Math.max(0, base + magnitude));
    case "decrease":
      if (unit === "percent") return applyPercentToPrice(base, -magnitude);
      return roundMoney(Math.max(0, base - magnitude));
    default:
      return null;
  }
}
function isBelowCost(price, cost) {
  if (cost == null || !Number.isFinite(cost)) return false;
  if (!Number.isFinite(price)) return false;
  return roundMoney(price) < roundMoney(cost);
}

// src/utils/account-email.ts
var SYNTHETIC_STAFF_EMAIL_PREFIX = "shopify-staff+";
function buildSyntheticStaffEmail(shopifyUserId, shopDomain) {
  return `${SYNTHETIC_STAFF_EMAIL_PREFIX}${shopifyUserId || "auto"}@${shopDomain}`;
}
function isSyntheticStaffEmail(email) {
  if (!email) return false;
  return email.toLowerCase().startsWith(SYNTHETIC_STAFF_EMAIL_PREFIX);
}
function normalizeEmail(email) {
  if (typeof email !== "string") return null;
  const normalized = email.trim().toLowerCase();
  return normalized.length > 0 ? normalized : null;
}

// src/utils/order-tags.ts
var SHOPIFY_MAX_TAG_LENGTH = 40;
var SHOPIFY_MAX_TAGS_PER_ORDER = 250;
function normalizeOrderTag(raw) {
  return raw.trim().replace(/\s+/g, " ");
}
function validateOrderTag(tag) {
  if (tag.length === 0) return "Tag cannot be empty";
  if (tag.length > SHOPIFY_MAX_TAG_LENGTH) {
    return `Tag cannot exceed ${SHOPIFY_MAX_TAG_LENGTH} characters`;
  }
  if (tag.includes(",")) {
    return "Tag cannot contain commas";
  }
  if (/[\u0000-\u001f\u007f]/.test(tag)) {
    return "Tag contains invalid control characters";
  }
  return null;
}
function parseShopifyTagsString(tags) {
  if (!tags) return [];
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const part of tags.split(",")) {
    const tag = normalizeOrderTag(part);
    if (tag.length === 0) continue;
    const key = tag.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(tag);
  }
  return out;
}
function orderTagSetsEqual(a, b) {
  if (a.length !== b.length) return false;
  const setA = new Set(a.map((t) => t.toLowerCase()));
  for (const t of b) {
    if (!setA.has(t.toLowerCase())) return false;
  }
  return true;
}
function orderTagsInclude(tags, tag) {
  const key = tag.toLowerCase();
  return tags.some((t) => t.toLowerCase() === key);
}
var RUSH_PRODUCTION_TAG = "rush-production";
function hasRushProductionTag(tags) {
  const key = RUSH_PRODUCTION_TAG.toLowerCase();
  return tags.some((tag) => tag.trim().toLowerCase() === key);
}

// src/utils/production-type.ts
function resolveProductionTypeFromTags(tags) {
  return hasRushProductionTag(tags) ? ProductionType.RUSH : ProductionType.REGULAR;
}
function productionTypeSourceForTags(type) {
  return type === ProductionType.RUSH ? ProductionTypeSource.SHOPIFY_TAG : ProductionTypeSource.DEFAULT;
}
function productionTypeUpdateFromTags(input) {
  if (input.source === ProductionTypeSource.ADMIN) return null;
  if (input.handedOff) return null;
  const productionType = resolveProductionTypeFromTags(input.tags);
  const productionTypeSource = productionTypeSourceForTags(productionType);
  if (productionType === input.currentType && productionTypeSource === input.source) {
    return null;
  }
  return { productionType, productionTypeSource };
}
function productionTypeForPayload(value) {
  return value === ProductionType.RUSH ? ProductionType.RUSH : ProductionType.REGULAR;
}

// src/utils/library-text.ts
var TURKISH_MAP = {
  \u00E7: "c",
  \u00C7: "c",
  \u011F: "g",
  \u011E: "g",
  \u0131: "i",
  \u0130: "i",
  \u00F6: "o",
  \u00D6: "o",
  \u015F: "s",
  \u015E: "s",
  \u00FC: "u",
  \u00DC: "u"
};
function stripExtension(name) {
  const idx = name.lastIndexOf(".");
  return idx > 0 ? name.slice(0, idx) : name;
}
function slugifyLibraryText(input) {
  const transliterated = input.replace(/[çÇğĞıİöÖşŞüÜ]/g, (ch) => TURKISH_MAP[ch] ?? ch);
  return transliterated.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}
function deriveLibrarySku(fileName, fallbackId) {
  const slug = slugifyLibraryText(stripExtension(fileName));
  return slug || `asset-${fallbackId}`;
}
function parseLibraryVariantSuffix(sku) {
  const m = /^(.{2,})-([a-z]{1,4})$/.exec(sku);
  if (!m) return null;
  return { baseSku: m[1], label: m[2] };
}
function normalizeLibraryKeyword(keyword) {
  return keyword.trim().toLowerCase();
}
function escapeRegExp(input) {
  return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function parseNegativePhrases(raw) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const part of raw.split(",")) {
    const phrase = part.trim().toLowerCase().replace(/\s+/g, " ");
    if (phrase && !seen.has(phrase)) {
      seen.add(phrase);
      out.push(phrase);
    }
  }
  return out;
}
function stripNegativePhrases(text, phrases) {
  let result = text;
  const ordered = [...phrases].map((p) => p.trim()).filter((p) => p.length > 0).sort((a, b) => b.length - a.length);
  for (const phrase of ordered) {
    const pattern = escapeRegExp(phrase).replace(/\s+/g, "\\s+");
    const re = new RegExp(`(?<![a-z0-9])${pattern}(?![a-z0-9])`, "gi");
    result = result.replace(re, " ");
  }
  return result.replace(/\s+/g, " ").replace(/(?:\s*[-–—|:,]){2,}\s*/g, " - ").replace(/^[\s\-–—|:,]+|[\s\-–—|:,]+$/g, "").trim();
}
function suggestTrailingPhrases(titles, minCount = 3) {
  const counts = /* @__PURE__ */ new Map();
  for (const title of titles) {
    const parts = title.split(/\s+[-–—|]\s+/);
    if (parts.length < 2) continue;
    const tail = parts[parts.length - 1].trim();
    if (tail.length < 2 || tail.length > 80) continue;
    if (/^\d+$/.test(tail)) continue;
    const key = tail.toLowerCase().replace(/\s+/g, " ");
    const entry = counts.get(key);
    if (entry) {
      entry.count += 1;
    } else {
      counts.set(key, { sample: tail, count: 1 });
    }
  }
  const threshold = Math.max(minCount, Math.ceil(titles.length * 0.05));
  return [...counts.values()].filter((e) => e.count >= threshold).sort((a, b) => b.count - a.count).slice(0, 5).map((e) => ({ phrase: e.sample, count: e.count }));
}
function normalizeHeader(header) {
  return header.trim().toLowerCase().replace(/[\s_-]+/g, " ");
}
function detectImportColumns(headers) {
  const normalized = headers.map(normalizeHeader);
  const findExact = (names) => {
    for (const name of names) {
      const idx = normalized.indexOf(name);
      if (idx !== -1) return idx;
    }
    return null;
  };
  const findContains = (fragment) => {
    const idx = normalized.findIndex((h) => h.includes(fragment));
    return idx === -1 ? null : idx;
  };
  const skuColumn = findExact(["variant sku", "sku"]) ?? findContains("sku");
  let titleColumn = findExact(["product title", "title", "product name", "name"]) ?? findContains("title");
  if (titleColumn !== null && titleColumn === skuColumn) titleColumn = null;
  return { skuColumn, titleColumn };
}
function normalizeLibraryKeywords(keywords) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const raw of keywords) {
    const k = normalizeLibraryKeyword(raw);
    if (k && !seen.has(k)) {
      seen.add(k);
      out.push(k);
    }
  }
  return out;
}

// src/utils/designer-object-limits.ts
var GANGSHEET_DEFAULT_MAX_IMAGES = 300;
var GANGSHEET_DEFAULT_MAX_LAYERS = 300;
var DEFAULT_MAX_IMAGES = 20;
var DEFAULT_MAX_LAYERS = 50;
function readPositiveInt(value) {
  if (typeof value === "number" && Number.isFinite(value) && value >= 1) {
    return Math.floor(value);
  }
  if (typeof value === "string" && /^\d+$/.test(value.trim())) {
    const n = Number(value);
    if (n >= 1) return n;
  }
  return void 0;
}
function asConstraintRecord(constraints) {
  if (constraints && typeof constraints === "object" && !Array.isArray(constraints)) {
    return constraints;
  }
  return {};
}
function resolveDesignerObjectLimits(designerMode, constraints) {
  const c = asConstraintRecord(constraints);
  const isGangsheet = designerMode === "GANGSHEET";
  return {
    maxImages: readPositiveInt(c.maxImages) ?? (isGangsheet ? GANGSHEET_DEFAULT_MAX_IMAGES : DEFAULT_MAX_IMAGES),
    maxLayers: readPositiveInt(c.maxLayers) ?? (isGangsheet ? GANGSHEET_DEFAULT_MAX_LAYERS : DEFAULT_MAX_LAYERS)
  };
}

// src/utils/shopify-delivery-method.ts
var ShopifyDeliveryMethod = {
  SHIPPING: "SHIPPING",
  PICK_UP: "PICK_UP",
  PICKUP_POINT: "PICKUP_POINT",
  LOCAL: "LOCAL",
  RETAIL: "RETAIL",
  NONE: "NONE"
};
var LOCAL_PICKUP_CODES = /* @__PURE__ */ new Set([
  "shopify pickup",
  "shopify_pickup",
  "shopify-pickup",
  "pick_up",
  "pick-up"
]);
var LOCAL_PICKUP_TITLES = /* @__PURE__ */ new Set([
  "pickup in store",
  "pick up in store",
  "pick-up in store",
  "in-store pickup",
  "in store pickup",
  "in-store pick up",
  "in store pick up"
]);
function normalize(value) {
  return (value ?? "").trim().toLowerCase();
}
function mapShopifyShippingLinesToDeliveryMethod(lines) {
  if (!lines || lines.length === 0) return null;
  const first = lines[0];
  const code = normalize(first.code);
  const source = normalize(first.source);
  const title = normalize(first.title);
  if (LOCAL_PICKUP_CODES.has(code)) {
    return ShopifyDeliveryMethod.PICK_UP;
  }
  if (source === "shopify" && /pick[\s_-]?up/.test(code) && !/point/.test(code)) {
    return ShopifyDeliveryMethod.PICK_UP;
  }
  if (LOCAL_PICKUP_TITLES.has(title)) {
    return ShopifyDeliveryMethod.PICK_UP;
  }
  return ShopifyDeliveryMethod.SHIPPING;
}
function inkteoFulfillmentTypeFromShopifyDelivery(method, shippingMethodTitle) {
  if (method === ShopifyDeliveryMethod.PICK_UP) {
    return InkteoFulfillmentType.PICKUP;
  }
  if (!method && shippingMethodTitle) {
    const inferred = mapShopifyShippingLinesToDeliveryMethod([
      { title: shippingMethodTitle }
    ]);
    if (inferred === ShopifyDeliveryMethod.PICK_UP) {
      return InkteoFulfillmentType.PICKUP;
    }
  }
  return InkteoFulfillmentType.SHIPPING;
}
function resolveClaimFulfillmentType(opts) {
  if (opts.requested === InkteoFulfillmentType.PICKUP || opts.requested === InkteoFulfillmentType.SHIPPING) {
    return opts.requested;
  }
  return inkteoFulfillmentTypeFromShopifyDelivery(
    opts.shopifyDeliveryMethod,
    opts.shippingMethod
  );
}
function checkoutFulfillmentDisplay(opts) {
  const type = inkteoFulfillmentTypeFromShopifyDelivery(
    opts.shopifyDeliveryMethod,
    opts.shippingMethod
  );
  const title = opts.shippingMethod?.trim();
  if (type === InkteoFulfillmentType.PICKUP) {
    return { type, label: title || "Pickup in store" };
  }
  return { type, label: title || "Shipping" };
}

// src/utils/upt-duplicate-context.ts
function isUptDesignContext(value) {
  return value === DesignContext.STOREFRONT || value === DesignContext.PRODUCT;
}
function suggestedDuplicateDesignContext(source) {
  if (source === DesignContext.STOREFRONT) return DesignContext.PRODUCT;
  if (source === DesignContext.PRODUCT) return DesignContext.PRODUCT;
  return DesignContext.PRODUCT;
}

// src/utils/variant-option-grouping.ts
var SIZE_AXIS_HINTS = ["size"];
var COLOR_AXIS_HINTS = ["color", "colour"];
function optionValueByAxisHints(options, hints) {
  if (!options || typeof options !== "object" || Array.isArray(options)) {
    return null;
  }
  const entries = Object.entries(options);
  const hintSet = new Set(hints.map((h) => h.toLowerCase()));
  for (const [key, value] of entries) {
    if (!hintSet.has(key.toLowerCase())) continue;
    if (typeof value !== "string" || value.trim().length === 0) continue;
    return value;
  }
  return null;
}
function groupBySize(items, getOptions) {
  const groups = /* @__PURE__ */ new Map();
  const order = [];
  for (const item of items) {
    const sizeLabel = optionValueByAxisHints(getOptions(item), SIZE_AXIS_HINTS);
    const sizeKey = sizeLabel ? sizeLabel.toLowerCase() : "";
    let group = groups.get(sizeKey);
    if (!group) {
      group = { sizeKey, sizeLabel: sizeLabel ?? "Ungrouped", items: [] };
      groups.set(sizeKey, group);
      order.push(sizeKey);
    }
    group.items.push(item);
  }
  return order.map((key) => groups.get(key));
}
function countOptionAxes(variants) {
  const names = /* @__PURE__ */ new Set();
  for (const variant of variants) {
    const options = variant.options;
    if (!options || typeof options !== "object" || Array.isArray(options)) {
      continue;
    }
    for (const key of Object.keys(options)) {
      if (key.trim().length > 0) names.add(key);
    }
  }
  return names.size;
}
function selectableGroupIds(groupChildIds, filteredIds) {
  return groupChildIds.filter((id) => filteredIds.has(id));
}
function toggleIdsInSelection(current, ids, checked) {
  const next = new Set(current);
  for (const id of ids) {
    if (checked) next.add(id);
    else next.delete(id);
  }
  return next;
}
function groupCheckboxState(selectableIds, selectedIds) {
  if (selectableIds.length === 0) return "unchecked";
  const selectedCount = selectableIds.filter((id) => selectedIds.has(id)).length;
  if (selectedCount === 0) return "unchecked";
  if (selectedCount === selectableIds.length) return "checked";
  return "indeterminate";
}
function variantRowLabel(opts) {
  const color = optionValueByAxisHints(opts.options, COLOR_AXIS_HINTS);
  if (color) return color;
  const size = optionValueByAxisHints(opts.options, SIZE_AXIS_HINTS);
  if (opts.options && typeof opts.options === "object" && !Array.isArray(opts.options)) {
    const rest = Object.entries(opts.options).filter(([key, value]) => {
      if (typeof value !== "string" || value.trim().length === 0) return false;
      if (key.toLowerCase() === "size") return false;
      if (size && value === size) return false;
      return true;
    }).map(([, value]) => value);
    if (rest.length > 0) return rest.join(" / ");
  }
  const title = opts.title?.trim();
  return title && title.length > 0 ? title : "Default";
}
function initialCollapsedSizeKeys(groups) {
  if (groups.length <= 1) return [];
  return groups.slice(1).map((group) => group.sizeKey);
}

// src/utils/print-side-composite.ts
var FRONT_BACK_RE = /\b(front|back)\b/;
var EXTRA_SIDE_RE = /\b(sleeve|hood|pocket|neck|leg|collar|cuff|yoke)\b/;
var LINING_RE = /\b(inner|outer)\b/;
function sideToken(side) {
  return `${side.slug ?? ""} ${side.displayName ?? ""}`.trim().toLowerCase();
}
function isSleeveClassExtra(token) {
  if (EXTRA_SIDE_RE.test(token)) return true;
  if (LINING_RE.test(token) && !FRONT_BACK_RE.test(token)) return true;
  return false;
}
function isFrontBackCompositeSide(side) {
  const token = sideToken(side);
  if (token.length === 0) return Boolean(side.isPrimary);
  if (isSleeveClassExtra(token)) return false;
  if (FRONT_BACK_RE.test(token)) return true;
  return Boolean(side.isPrimary);
}
function compositeSideRank(side) {
  const token = sideToken(side);
  if (/\bfront\b/.test(token)) return 0;
  if (side.isPrimary) return 1;
  if (/\bback\b/.test(token)) return 2;
  return 3;
}
function isNamedFrontSide(side) {
  const token = sideToken(side);
  if (isSleeveClassExtra(token)) return false;
  return /\bfront\b/.test(token);
}
function isNamedBackSide(side) {
  const token = sideToken(side);
  if (isSleeveClassExtra(token)) return false;
  return /\bback\b/.test(token);
}
function resolveVariantHeroPlan(sides) {
  const namedFront = sides.find((s) => isNamedFrontSide(s));
  const namedBack = sides.find((s) => isNamedBackSide(s));
  const primaryStandIn = sides.find(
    (s) => Boolean(s.isPrimary) && !isNamedBackSide(s) && !isSleeveClassExtra(sideToken(s))
  );
  const front = namedFront ?? primaryStandIn;
  if (front && namedBack && front !== namedBack) {
    return { kind: "stitch", front, back: namedBack };
  }
  if (front) return { kind: "single", side: front };
  if (namedBack) return { kind: "single", side: namedBack };
  return { kind: "none" };
}
function partitionPrintSides(sides) {
  const plan = resolveVariantHeroPlan(sides);
  const compositeSides = plan.kind === "stitch" ? [plan.front, plan.back] : plan.kind === "single" ? [plan.side] : [];
  const chosen = new Set(compositeSides);
  const extraSides = sides.filter((s) => !chosen.has(s));
  return { compositeSides, extraSides };
}
var COMPOSITE_PREVIEW_TAB_ID = "composite";
var CSS_HEX_RE = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
var HASHLESS_HEX_RE = /^[0-9a-fA-F]{3}(?:[0-9a-fA-F]{3}(?:[0-9a-fA-F]{2})?)?$/;
function sanitizeCssHex(value) {
  if (typeof value !== "string") return null;
  let trimmed2 = value.trim();
  if (!trimmed2.startsWith("#") && HASHLESS_HEX_RE.test(trimmed2)) {
    trimmed2 = `#${trimmed2}`;
  }
  return CSS_HEX_RE.test(trimmed2) ? trimmed2 : null;
}
function resolveSwatchHex(input) {
  const fromHex = sanitizeCssHex(input.hex);
  if (fromHex) return fromHex;
  const name = input.colorName?.trim();
  if (name) {
    const named = input.namedHexByNormalizedName?.get(normalizeColorName(name));
    const fromUpt = sanitizeCssHex(named);
    if (fromUpt) return fromUpt;
  }
  return resolveColorNameToHex(name);
}
function indexHexByColorName(rows) {
  const map = /* @__PURE__ */ new Map();
  for (const row of rows) {
    const hex = sanitizeCssHex(row.hexCode) ?? resolveColorNameToHex(row.hexCode);
    if (!hex || !row.name.trim()) continue;
    const key = normalizeColorName(row.name);
    if (!map.has(key)) map.set(key, hex);
  }
  return map;
}
function buildVariantPreviewTabs(printSides) {
  const seen = /* @__PURE__ */ new Set();
  const sideTabs = [];
  for (const side of printSides) {
    if (!side.printAreaId || seen.has(side.printAreaId)) continue;
    seen.add(side.printAreaId);
    sideTabs.push({ id: side.printAreaId, label: side.displayName });
  }
  return [{ id: COMPOSITE_PREVIEW_TAB_ID, label: "Composite" }, ...sideTabs];
}
function resolveTableHeroPreview(variant) {
  if (variant.imageUrl) {
    return { url: variant.imageUrl, status: variant.previewJobStatus ?? null };
  }
  const ready = (variant.sides ?? []).filter(
    (side) => Boolean(side.previewUrl) && side.previewStatus === "READY"
  );
  const pick2 = ready.find((side) => isNamedFrontSide(side)) ?? ready.find((side) => isNamedBackSide(side)) ?? ready[0];
  if (pick2?.previewUrl) {
    return { url: pick2.previewUrl, status: pick2.previewStatus ?? null };
  }
  return { url: null, status: variant.previewJobStatus ?? null };
}
function resolveGalleryStagePreview(tabId, variant) {
  if (tabId === COMPOSITE_PREVIEW_TAB_ID) {
    return {
      url: variant.imageUrl ?? null,
      status: variant.previewJobStatus ?? null
    };
  }
  const side = (variant.sides ?? []).find((s) => s.printAreaId === tabId);
  return {
    url: side?.previewUrl ?? null,
    status: side?.previewStatus ?? null
  };
}
function groupColorWaySwatches(variants, get) {
  const groups = /* @__PURE__ */ new Map();
  const order = [];
  for (const item of variants) {
    const meta = get(item);
    const colorLabel = optionValueByAxisHints(meta.options, COLOR_AXIS_HINTS) ?? "Default";
    const colorKey = colorLabel.toLowerCase();
    let group = groups.get(colorKey);
    if (!group) {
      group = {
        colorKey,
        colorLabel,
        colorHex: resolveSwatchHex({
          hex: meta.colorHex,
          colorName: colorLabel
        }),
        representative: item,
        items: []
      };
      groups.set(colorKey, group);
      order.push(colorKey);
    }
    group.items.push(item);
    if (!group.colorHex) {
      group.colorHex = resolveSwatchHex({
        hex: meta.colorHex,
        colorName: colorLabel
      });
    }
    const currentStatus = get(group.representative).previewJobStatus;
    const nextStatus = meta.previewJobStatus;
    if (currentStatus !== "DONE" && nextStatus === "DONE") {
      group.representative = item;
    }
  }
  return order.map((key) => groups.get(key));
}

// src/utils/catalog-product-name.ts
function trimmed(value) {
  if (typeof value !== "string") return null;
  const text = value.trim();
  return text.length > 0 ? text : null;
}
function catalogProductName(input) {
  if (input.designContext !== "PRODUCT") return null;
  const blankName = trimmed(input.blankName);
  if (blankName) return blankName;
  const brandModel = [trimmed(input.brand), trimmed(input.model)].filter((part) => part != null).join(" ");
  if (brandModel) return brandModel;
  return trimmed(input.uptName);
}
function orderItemDisplayName(item) {
  return trimmed(item.catalogTitle) ?? item.title;
}
function orderItemStoreListingTitle(item) {
  const catalog = trimmed(item.catalogTitle);
  if (!catalog || catalog === item.title) return null;
  return item.title;
}

// src/utils/decimal-cents.ts
function decimalToCents(value) {
  const text = typeof value === "number" ? value.toString() : value.toString();
  const negative = text.startsWith("-");
  const [whole, frac = ""] = text.replace("-", "").split(".");
  const millis = Number(whole) * 1e4 + Number((frac + "0000").slice(0, 4));
  const cents = Math.round(millis / 100);
  return negative ? -cents : cents;
}

// src/utils/idempotency-conflict.ts
function isIdempotencyConflict(err) {
  if (!err || typeof err !== "object") return false;
  const candidate = err;
  if (candidate.code !== "P2002") return false;
  const target2 = candidate.meta?.target;
  const text = Array.isArray(target2) ? target2.join(",") : String(target2 ?? "");
  return text.includes("idempotencyKey");
}

// src/product-options/types.ts
import { z as z5 } from "zod";
var PRODUCT_OPTIONS_SCHEMA_VERSION = 1;
var PRODUCT_OPTION_CHOICE_KEY_PATTERN = /^[a-z0-9][a-z0-9_-]{0,63}$/;
var productOptionChoiceSchema = z5.object({
  key: z5.string().regex(PRODUCT_OPTION_CHOICE_KEY_PATTERN),
  label: z5.string().min(1).max(200),
  imageUrl: z5.string().max(2e3).nullable().optional(),
  iconUrl: z5.string().max(2e3).nullable().optional(),
  colorHex: z5.string().regex(/^#[0-9a-fA-F]{6}$/).nullable().optional(),
  sortOrder: z5.number().int().min(0).default(0),
  isDefault: z5.boolean().default(false),
  /** Per-choice surcharge in minor currency units (overrides option level). */
  priceDeltaCents: z5.number().int().min(0).max(1e8).nullable().optional()
});
var productOptionChoicesSchema = productOptionChoiceSchema.array().max(500).superRefine((choices, ctx) => {
  const seen = /* @__PURE__ */ new Map();
  choices.forEach((choice, index) => {
    const previous = seen.get(choice.key);
    if (previous != null) {
      ctx.addIssue({
        code: "custom",
        path: [index, "key"],
        message: `Choice key "${choice.key}" is already used.`
      });
      return;
    }
    seen.set(choice.key, index);
  });
});
var UPLOAD_SOURCES = ["DEVICE", "RECENT", "GALLERY", "PHONE", "AI"];
var SIZE_PRICE_MODES = ["AREA_RATE", "LONGEST_EDGE_RATE", "HEIGHT_RATE", "VARIANT_BAND"];
var DPI_SOURCES = ["ASSUMED", "EMBEDDED_IF_PLAUSIBLE"];
var TRIM_MODES = ["ALPHA", "ALPHA_OR_BACKGROUND", "NONE"];
var PRESET_PRICING = ["STANDARD", "VARIANT_BAND_ONLY"];
var sizePresetSchema = z5.object({
  id: z5.string().regex(PRODUCT_OPTION_CHOICE_KEY_PATTERN),
  label: z5.string().min(1).max(80),
  widthIn: z5.number().positive().max(1e3),
  pricing: z5.enum(PRESET_PRICING).default("STANDARD"),
  active: z5.boolean().default(true)
});
var uploadConfigSchema = z5.object({
  accept: z5.object({
    mimeTypes: z5.array(z5.string().min(1).max(100)).max(50),
    maxFileMb: z5.number().positive().max(2e3),
    maxFiles: z5.number().int().min(1).max(50)
  }),
  sources: z5.array(z5.enum(UPLOAD_SOURCES)).min(1),
  gallery: z5.object({
    categoryIds: z5.array(z5.string()).max(100).optional(),
    tagSlugs: z5.array(z5.string()).max(100).optional()
  }).optional(),
  imageTools: z5.object({
    bgRemoval: z5.enum(["OFF", "SUGGEST", "AUTO"]).default("OFF"),
    upscale: z5.enum(["OFF", "SUGGEST"]).default("OFF"),
    /** Rotate, flip and crop on the working copy. */
    editor: z5.enum(["OFF", "ON"]).default("OFF")
  }).optional(),
  sizing: z5.object({
    assumedDpi: z5.number().int().min(36).max(1200).default(300),
    /** False forces trim off, even when trimMode is set. */
    trim: z5.boolean().default(true),
    minDpiWarn: z5.number().int().min(1).max(1200).default(150),
    minSizeIn: z5.number().positive().max(1e3).default(0.1),
    maxWidthIn: z5.number().positive().max(1e3).default(22),
    maxHeightIn: z5.number().positive().max(1e3).default(240),
    stepIn: z5.number().positive().max(10).default(0.1),
    dpiSource: z5.enum(DPI_SOURCES).default("ASSUMED"),
    /** At or above this, the DPI chip is print-ready. */
    dpiGood: z5.number().int().min(1).max(1200).default(250),
    /** At or above this (and below dpiGood), the chip warns. */
    dpiFair: z5.number().int().min(1).max(1200).default(150),
    trimMode: z5.enum(TRIM_MODES).default("ALPHA"),
    trimAlphaThreshold: z5.number().int().min(0).max(255).default(8),
    /** Customer may change the detected size. Gang sheets turn this off. */
    allowResize: z5.boolean().default(true),
    /** Offer the post-trim size as a selectable size. */
    allowDetectedSize: z5.boolean().default(true),
    /**
     * Customer may unlock the proportions and set width and height
     * independently (the artwork is stretched to that size). Only the
     * min/max bounds apply while unlocked. Gang sheets keep this off.
     */
    allowStretch: z5.boolean().default(true),
    presets: z5.array(sizePresetSchema).max(50).default([])
  }).optional(),
  /**
   * How the chosen size is priced. Absent means the variant price (and any
   * existing custom-size area formula) is unchanged.
   */
  sizePricing: z5.object({
    mode: z5.enum(SIZE_PRICE_MODES).default("AREA_RATE"),
    /** Blank whose price is the per-square-inch or per-inch rate. */
    pricingVariantId: z5.string().min(1).max(200).nullable().optional()
  }).optional(),
  preview: z5.object({
    mode: z5.enum(["NONE", "IMAGE_ONLY", "IMAGE_ON_BG", "MASK_MOCKUP"]).default("NONE"),
    backgroundColorHex: z5.string().regex(/^#[0-9a-fA-F]{6}$/).nullable().optional(),
    allowCustomerBgColor: z5.boolean().default(false),
    printAreaId: z5.string().nullable().optional(),
    bindBgColorToOptionTypeId: z5.string().nullable().optional()
  }).optional(),
  variantBinding: z5.object({
    /** Empty until the admin binds a variant axis. Readiness requires it for band pricing. */
    optionTypeId: z5.string().max(200).default(""),
    defaultVariantRule: z5.enum([
      "LONGEST_EDGE_CEIL",
      "HEIGHT_CEIL",
      "WIDTH_CEIL",
      "AREA_CEIL",
      "BOTH_EDGES_CEIL"
    ]).default("LONGEST_EDGE_CEIL"),
    customerCanChangeVariant: z5.boolean().default(true),
    allowSmallerThanDetected: z5.boolean().default(false),
    fixedWidthIn: z5.number().positive().max(1e3).nullable().optional(),
    customSizeVariantId: z5.string().nullable().optional()
  }).optional(),
  printRender: z5.object({
    /** Always true: artwork is never distorted. */
    ratioLocked: z5.literal(true).default(true),
    fit: z5.enum(["CONTAIN"]).default("CONTAIN"),
    allowUpscale: z5.boolean().default(true),
    minEffectiveDpiWarn: z5.number().int().min(1).max(1200).default(150),
    minEffectiveDpiBlock: z5.number().int().min(1).max(1200).nullable().optional()
  }).optional(),
  /** Gang sheet width check. Absent on DTF-by-size uploads. */
  gangsheet: z5.object({
    /** Detected width may exceed the sheet maximum by this many inches. */
    widthToleranceIn: z5.number().min(0).max(10).default(0.25)
  }).optional()
}).superRefine((config, ctx) => {
  const presets = config.sizing?.presets ?? [];
  const seen = /* @__PURE__ */ new Set();
  const maxWidth = config.sizing?.maxWidthIn;
  presets.forEach((preset, index) => {
    if (seen.has(preset.id)) {
      ctx.addIssue({
        code: "custom",
        path: ["sizing", "presets", index, "id"],
        message: `Preset id "${preset.id}" is already used.`
      });
    }
    seen.add(preset.id);
    if (maxWidth != null && preset.widthIn > maxWidth) {
      ctx.addIssue({
        code: "custom",
        path: ["sizing", "presets", index, "widthIn"],
        message: `Preset width must be at most ${maxWidth} in.`
      });
    }
  });
});
var optionUploadDraftSchema = z5.object({
  schemaVersion: z5.literal(1).default(1),
  widthIn: z5.number().positive().max(1e3).optional(),
  heightIn: z5.number().positive().max(1e3).optional(),
  /** `detected`, `custom`, or a preset id. */
  presetId: z5.string().max(64).nullable().optional(),
  quantity: z5.number().int().min(1).max(1e4).default(1),
  bgColorHex: z5.string().regex(/^#[0-9a-fA-F]{6}$/).nullable().optional(),
  /** Closed lock keeps the trimmed ratio. An open lock is bounds only. */
  ratioLocked: z5.boolean().default(true)
}).superRefine((draft, ctx) => {
  if (draft.widthIn != null !== (draft.heightIn != null)) {
    ctx.addIssue({
      code: "custom",
      path: [draft.widthIn == null ? "widthIn" : "heightIn"],
      message: "Width and height are saved together."
    });
  }
});
var TEXT_TRANSFORMS = ["NONE", "UPPERCASE", "LOWERCASE", "CAPITALIZE"];
var textConfigSchema = z5.object({
  minLength: z5.number().int().min(0).max(1e5).default(0),
  maxLength: z5.number().int().min(1).max(1e5).default(500),
  /** Customer input is validated against this; stored definitions are admin-authored. */
  pattern: z5.string().max(500).nullable().optional(),
  showCounter: z5.boolean().default(false),
  /** Applied to the stored value before length and pattern checks. */
  textTransform: z5.enum(TEXT_TRANSFORMS).default("NONE")
});
var numberConfigSchema = z5.object({
  min: z5.number().nullable().optional(),
  max: z5.number().nullable().optional(),
  step: z5.number().positive().default(1)
});
var isoDateSchema2 = z5.string().regex(/^\d{4}-\d{2}-\d{2}$/);
var DATE_DISPLAY_FORMATS = ["LOCALE", "YYYY-MM-DD", "DD/MM/YYYY", "MM/DD/YYYY"];
var dateConfigSchema = z5.object({
  minDate: isoDateSchema2.nullable().optional(),
  maxDate: isoDateSchema2.nullable().optional(),
  /** ISO dates (YYYY-MM-DD) the customer cannot pick. */
  blackoutDates: z5.array(isoDateSchema2).max(400).default([]),
  /** How the chosen ISO date is shown. Storage stays YYYY-MM-DD. */
  displayFormat: z5.enum(DATE_DISPLAY_FORMATS).default("LOCALE")
});
var checkboxConfigSchema = z5.object({
  label: z5.string().max(200).optional()
});
var SWATCH_SIZES = ["SMALL", "MEDIUM", "LARGE"];
var SWATCH_SIZE_PX = {
  SMALL: 40,
  MEDIUM: 64,
  LARGE: 96
};
var swatchConfigSchema = z5.object({
  swatchSize: z5.enum(SWATCH_SIZES).default("SMALL")
});
function swatchSizePx(config) {
  const source = config && typeof config === "object" ? config : {};
  const parsed = swatchConfigSchema.safeParse(source);
  return SWATCH_SIZE_PX[parsed.success ? parsed.data.swatchSize : "SMALL"];
}
var checkboxGroupConfigSchema = z5.object({
  minSelections: z5.number().int().min(0).max(500).default(0),
  maxSelections: z5.number().int().min(1).max(500).nullable().optional()
}).superRefine((value, ctx) => {
  if (value.maxSelections != null && value.maxSelections < value.minSelections) {
    ctx.addIssue({
      code: "custom",
      message: "Maximum selections must be at least the minimum.",
      path: ["maxSelections"]
    });
  }
});
var infoConfigSchema = z5.object({
  /** Plain text only in v1; rendered as text content, never as HTML. */
  body: z5.string().max(5e3)
});
var customSizeAxisSchema = z5.number().positive().max(1e4);
var customSizeAxisGroupSchema = z5.object({
  x: customSizeAxisSchema,
  y: customSizeAxisSchema,
  z: customSizeAxisSchema.optional()
});
var customSizeConfigSchema = z5.preprocess(
  (input) => {
    if (!input || typeof input !== "object" || Array.isArray(input)) return input;
    const raw = input;
    if ("min" in raw || "unit" in raw || "dimensions" in raw) return input;
    if (!("minWidthIn" in raw) && !("maxWidthIn" in raw)) return input;
    const step = typeof raw.stepIn === "number" ? raw.stepIn : 0.5;
    return {
      unit: "in",
      dimensions: 2,
      labels: { x: "Width", y: "Height" },
      min: { x: raw.minWidthIn, y: raw.minHeightIn },
      max: { x: raw.maxWidthIn, y: raw.maxHeightIn },
      step: { x: step, y: step },
      defaults: {}
    };
  },
  z5.object({
    unit: z5.enum(["in", "cm"]).default("in"),
    dimensions: z5.union([z5.literal(2), z5.literal(3)]).default(2),
    labels: z5.object({
      x: z5.string().min(1).max(40).default("Width"),
      y: z5.string().min(1).max(40).default("Height"),
      z: z5.string().min(1).max(40).optional()
    }).default({ x: "Width", y: "Height" }),
    min: customSizeAxisGroupSchema,
    max: customSizeAxisGroupSchema,
    step: customSizeAxisGroupSchema,
    defaults: z5.object({
      x: customSizeAxisSchema.nullable().optional(),
      y: customSizeAxisSchema.nullable().optional(),
      z: customSizeAxisSchema.nullable().optional()
    }).default({}),
    /**
     * Blank variant whose surface price is the formula rate.
     * Absent means the dimension is stored and not priced.
     */
    pricingVariantId: z5.string().min(1).max(64).nullable().optional()
  }).superRefine((value, ctx) => {
    const axes = value.dimensions === 3 ? ["x", "y", "z"] : ["x", "y"];
    for (const axis of axes) {
      const min = value.min[axis];
      const max = value.max[axis];
      const step = value.step[axis];
      if (min == null || max == null || step == null) {
        ctx.addIssue({
          code: "custom",
          message: `Set a minimum, maximum, and step for the ${axis} axis.`,
          path: ["min", axis]
        });
        continue;
      }
      if (max < min) {
        ctx.addIssue({
          code: "custom",
          message: "Maximum must be at least the minimum.",
          path: ["max", axis]
        });
      }
    }
  })
);
var displayRuleConditionSchema = z5.object({
  source: z5.enum(["OPTION", "VARIANT_AXIS", "QUANTITY"]),
  /** Option `key` or OptionType id, depending on source. */
  sourceKey: z5.string().min(1).max(200),
  operator: z5.enum(["EQ", "NEQ", "IN", "NOT_IN", "GTE", "LTE"]),
  /** Choice keys / axis value keys, or a single numeric quantity. */
  values: z5.array(z5.string().max(200)).max(100)
});
var displayRuleSchema = z5.object({
  action: z5.enum(["SHOW", "HIDE"]),
  combinator: z5.enum(["AND", "OR"]).default("AND"),
  conditions: z5.array(displayRuleConditionSchema).min(1).max(20)
});
var displayRulesSchema = z5.array(displayRuleSchema).max(20);
var optionSelectionSchema = z5.object({
  optionKey: z5.string().min(1).max(64),
  /** Choice keys for choice types; raw text/number/date otherwise. */
  values: z5.array(z5.string().max(1e5)).max(50),
  /** OptionUpload public tokens referenced by upload types. */
  uploadTokens: z5.array(z5.string().max(64)).max(50).optional()
});
var variantAxisSelectionSchema = z5.object({
  optionTypeId: z5.string().min(1).max(200),
  valueKey: z5.string().min(1).max(200)
});
var optionSubmissionPayloadSchema = z5.object({
  schemaVersion: z5.literal(PRODUCT_OPTIONS_SCHEMA_VERSION),
  uptId: z5.string().min(1),
  /** Shopify variant id or internal variant id, depending on surface. */
  variantRef: z5.string().min(1).nullable(),
  quantity: z5.number().int().min(1).max(1e4),
  selections: z5.array(optionSelectionSchema).max(100),
  variantAxes: z5.array(variantAxisSelectionSchema).max(20).optional()
});
var quantityTierSchema = z5.object({
  minQty: z5.number().int().min(1).max(1e4),
  discountPercent: z5.number().min(0).max(100)
});
var SINGLE_QUANTITY = { mode: "SINGLE", min: 1, max: 100, step: 1, tiers: [] };
var quantityConfigSchema = z5.preprocess(
  (input) => {
    if (!input || typeof input !== "object" || Array.isArray(input)) return SINGLE_QUANTITY;
    const raw = input;
    return { ...raw, mode: raw.mode === "BULK" ? "BULK" : "SINGLE" };
  },
  z5.object({
    mode: z5.enum(["SINGLE", "BULK"]).default("SINGLE"),
    min: z5.number().int().min(1).max(1e4).default(1),
    max: z5.number().int().min(1).max(1e4).default(100),
    step: z5.number().int().min(1).max(1e3).default(1),
    tiers: z5.array(quantityTierSchema).max(20).default([])
  }).superRefine((value, ctx) => {
    if (value.max < value.min) {
      ctx.addIssue({
        code: "custom",
        message: "Quantity max must be at least the minimum.",
        path: ["max"]
      });
    }
    if (value.mode === "SINGLE") {
      if (value.tiers.length > 0) {
        ctx.addIssue({
          code: "custom",
          message: "Single quantity does not use bulk tiers.",
          path: ["tiers"]
        });
      }
      return;
    }
    if (value.tiers.length === 0) {
      ctx.addIssue({
        code: "custom",
        message: "Add at least one bulk tier.",
        path: ["tiers"]
      });
      return;
    }
    let previous = 0;
    value.tiers.forEach((tier, index) => {
      if (index === 0 && tier.minQty !== value.min) {
        ctx.addIssue({
          code: "custom",
          message: "The first tier starts at the block minimum.",
          path: ["tiers", index, "minQty"]
        });
      }
      if (tier.minQty <= previous) {
        ctx.addIssue({
          code: "custom",
          message: "Tiers must be unique and sorted by quantity.",
          path: ["tiers", index, "minQty"]
        });
      }
      previous = tier.minQty;
      if (tier.minQty < value.min || tier.minQty > value.max) {
        ctx.addIssue({
          code: "custom",
          message: "Tier quantity must sit inside the block minimum and maximum.",
          path: ["tiers", index, "minQty"]
        });
      }
      if (value.step > 0 && (tier.minQty - value.min) % value.step !== 0) {
        ctx.addIssue({
          code: "custom",
          message: "Tier quantity must land on the step grid.",
          path: ["tiers", index, "minQty"]
        });
      }
    });
  })
);
var optionsBlockConfigSchema = z5.object({
  schemaVersion: z5.literal(PRODUCT_OPTIONS_SCHEMA_VERSION).default(PRODUCT_OPTIONS_SCHEMA_VERSION),
  quantity: quantityConfigSchema.default(SINGLE_QUANTITY),
  /**
   * Per-piece floor in shop-currency cents for sized products. Applied to
   * the size price before option charges and tiers. 0 means no floor.
   */
  minChargeCents: z5.number().int().min(0).max(1e7).default(0),
  hideNativeSelectors: z5.boolean().default(true),
  nativeSelectorCss: z5.string().max(2e3).default(""),
  showPrice: z5.boolean().default(true),
  addToCartLabel: z5.string().min(1).max(80).default("Add to cart"),
  uploadPanel: z5.object({
    sources: z5.array(z5.enum(UPLOAD_SOURCES)).min(1).max(5).default(["DEVICE", "RECENT"])
  }).default({ sources: ["DEVICE", "RECENT"] })
}).superRefine((value, ctx) => {
  if (value.quantity.max < value.quantity.min) {
    ctx.addIssue({
      code: "custom",
      message: "Quantity max must be at least the minimum.",
      path: ["quantity", "max"]
    });
  }
});
var VARIANT_MATCH_RULES = [
  "LONGEST_EDGE_CEIL",
  "HEIGHT_CEIL",
  "WIDTH_CEIL",
  "AREA_CEIL",
  "BOTH_EDGES_CEIL"
];
var OPTION_SUBMISSION_TOKEN_PATTERN = /^OPS_[A-Za-z0-9]{20,}$/;
var OPTION_UPLOAD_TOKEN_PATTERN = /^OU_[A-Za-z0-9]{20,}$/;

// src/product-options/choices.ts
var SINGLE_DEFAULT_TYPES = /* @__PURE__ */ new Set([
  "RADIO",
  "SELECT",
  "SWATCH",
  "BUTTON_GROUP"
]);
function isSingleSelectOptionType(optionType) {
  return SINGLE_DEFAULT_TYPES.has(optionType);
}
function blankToNull(value) {
  if (value == null) return null;
  const trimmed2 = value.trim();
  return trimmed2 === "" ? null : trimmed2;
}
function normalizeChoices(optionType, choices) {
  const singleDefault = isSingleSelectOptionType(optionType);
  let defaultKept = false;
  return choices.map((choice, index) => {
    const imageUrl = blankToNull(choice.imageUrl);
    let isDefault = choice.isDefault;
    if (singleDefault) {
      if (isDefault && defaultKept) isDefault = false;
      else if (isDefault) defaultKept = true;
    }
    return {
      ...choice,
      imageUrl,
      iconUrl: blankToNull(choice.iconUrl),
      colorHex: imageUrl ? null : choice.colorHex ?? null,
      isDefault,
      sortOrder: index
    };
  });
}

// src/product-options/size-math.ts
var SIZE_DISPLAY_DECIMALS = 2;
function roundDisplay(inches) {
  if (!Number.isFinite(inches)) return 0;
  const factor = 10 ** SIZE_DISPLAY_DECIMALS;
  return Math.round(inches * factor) / factor;
}
function formatInches(inches) {
  return String(roundDisplay(inches));
}
function physicalInches(px, dpi) {
  if (!Number.isFinite(px) || !Number.isFinite(dpi) || dpi <= 0 || px < 0) return 0;
  return px / dpi;
}
function resolveEffectiveDpi(input) {
  const assumed = input.assumedDpi > 0 ? input.assumedDpi : 300;
  if (input.dpiSource !== "EMBEDDED_IF_PLAUSIBLE") return assumed;
  const embedded = input.embeddedDpi;
  if (embedded == null || !Number.isFinite(embedded)) return assumed;
  if (embedded < 36 || embedded > 1200) return assumed;
  return embedded;
}
function detectedSizeIn(input) {
  return {
    widthIn: physicalInches(input.trimmed.widthPx, input.dpi),
    heightIn: physicalInches(input.trimmed.heightPx, input.dpi)
  };
}
function heightFromWidth(widthIn, trimmed2) {
  if (trimmed2.widthPx <= 0 || trimmed2.heightPx <= 0) return widthIn;
  return widthIn * (trimmed2.heightPx / trimmed2.widthPx);
}
function widthFromHeight(heightIn, trimmed2) {
  if (trimmed2.widthPx <= 0 || trimmed2.heightPx <= 0) return heightIn;
  return heightIn * (trimmed2.widthPx / trimmed2.heightPx);
}
function clamp2(value, min, max) {
  return Math.min(max, Math.max(min, value));
}
function fitSize(input) {
  const ratio = input.ratio > 0 && Number.isFinite(input.ratio) ? input.ratio : 1;
  const min = input.minSizeIn;
  const maxW = input.maxWidthIn;
  const maxH = input.maxHeightIn;
  let width = Number.isFinite(input.widthIn) && input.widthIn > 0 ? input.widthIn : min;
  let height = Number.isFinite(input.heightIn) && input.heightIn > 0 ? input.heightIn : min;
  const beforeW = width;
  const beforeH = height;
  if (input.ratioLocked) {
    if (input.edited === "height") {
      height = clamp2(height, min, maxH);
      width = height * ratio;
    } else {
      width = clamp2(width, min, maxW);
      height = width / ratio;
    }
    if (width > maxW) {
      width = maxW;
      height = width / ratio;
    }
    if (height > maxH) {
      height = maxH;
      width = height * ratio;
    }
    if (width < min) {
      width = min;
      height = width / ratio;
    }
    if (height < min) {
      height = min;
      width = height * ratio;
    }
    if (width > maxW) {
      width = maxW;
      height = width / ratio;
    }
  } else {
    width = clamp2(width, min, maxW);
    height = clamp2(height, min, maxH);
  }
  return {
    widthIn: width,
    heightIn: height,
    clamped: width !== beforeW || height !== beforeH
  };
}
function effectivePrintDpi(trimmedPx, inches) {
  if (!Number.isFinite(trimmedPx) || !Number.isFinite(inches) || inches <= 0) return 0;
  return trimmedPx / inches;
}
function dpiQuality(dpi, good, fair) {
  if (dpi >= good) return "good";
  if (dpi >= fair) return "fair";
  return "low";
}
function gangsheetVariantHeight(widthIn, heightIn) {
  if (typeof heightIn === "number" && Number.isFinite(heightIn) && heightIn > 0) return heightIn;
  if (typeof widthIn === "number" && Number.isFinite(widthIn) && widthIn > 0) return widthIn;
  return null;
}
function gangsheetFixedWidthIn(fixedWidthIn) {
  return typeof fixedWidthIn === "number" && Number.isFinite(fixedWidthIn) && fixedWidthIn > 0 ? fixedWidthIn : 22;
}
function sizeFormulaMode(mode) {
  switch (mode) {
    case "AREA_RATE":
      return "AREA";
    case "LONGEST_EDGE_RATE":
      return "LONGEST_EDGE";
    case "HEIGHT_RATE":
      return "HEIGHT";
    case "VARIANT_BAND":
      return null;
    default: {
      const unreachable = mode;
      return unreachable;
    }
  }
}
function sizeRateInches(mode, widthIn, heightIn) {
  switch (mode) {
    case "AREA":
      return widthIn * heightIn;
    case "LONGEST_EDGE":
      return Math.max(widthIn, heightIn);
    case "HEIGHT":
      return heightIn;
    default: {
      const unreachable = mode;
      return unreachable;
    }
  }
}
function priceForSize(input) {
  const formulaMode = sizeFormulaMode(input.mode);
  if (formulaMode == null) return null;
  if (!Number.isFinite(input.widthIn) || !Number.isFinite(input.heightIn) || !Number.isFinite(input.rateCents) || input.widthIn <= 0 || input.heightIn <= 0) {
    return null;
  }
  const raw = Math.round(sizeRateInches(formulaMode, input.widthIn, input.heightIn) * input.rateCents);
  const floor = input.minChargeCents != null && Number.isFinite(input.minChargeCents) ? Math.max(0, Math.round(input.minChargeCents)) : 0;
  return Math.max(raw, floor);
}
var SIZED_STRETCH_FLAG = "stretch";
function isStretchedSelection(values) {
  return values[3]?.trim() === SIZED_STRETCH_FLAG;
}
function validateSizedValues(input) {
  if (input.required && input.uploadCount === 0) return "Upload an image.";
  if (input.uploadCount > input.maxFiles) return `Up to ${input.maxFiles} files.`;
  if (input.uploadCount === 0) return null;
  if (input.values.length < 2) return "Choose a print size.";
  if (input.values.length > 4) return "Enter a valid print size.";
  const width = Number(input.values[0]);
  const height = Number(input.values[1]);
  const preset = input.values[2]?.trim() || "custom";
  const stretched = isStretchedSelection(input.values);
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return "Enter a valid print size.";
  }
  if (input.values[3] != null && input.values[3].trim() !== "" && !stretched) {
    return "Enter a valid print size.";
  }
  if (stretched && (!input.allowStretch || input.fixedWidthIn != null)) {
    return "This product keeps the image proportions.";
  }
  if (input.fixedWidthIn != null && width > input.fixedWidthIn + 1e-3) {
    return `Gang sheet width cannot exceed ${input.fixedWidthIn} in.`;
  }
  if (!input.allowResize && (preset !== "detected" || stretched)) {
    return "This product uses the detected size.";
  }
  const { minSizeIn, maxWidthIn, maxHeightIn } = input.bounds;
  if (width < minSizeIn || width > maxWidthIn) {
    return `Width must be between ${minSizeIn} and ${maxWidthIn} in.`;
  }
  if (height < minSizeIn || height > maxHeightIn) {
    return `Height must be between ${minSizeIn} and ${maxHeightIn} in.`;
  }
  return null;
}
function heightMatchesTrimmedRatio(widthIn, heightIn, trimmed2) {
  if (trimmed2.widthPx <= 0 || trimmed2.heightPx <= 0) return false;
  const expected = heightFromWidth(widthIn, trimmed2);
  if (expected <= 0) return false;
  const delta = Math.abs(heightIn - expected);
  return delta / expected <= 5e-3 || delta <= 5e-3;
}
function sizingBounds(config) {
  const sizing = config.sizing;
  return {
    minSizeIn: sizing?.minSizeIn ?? 0.1,
    maxWidthIn: sizing?.maxWidthIn ?? 22,
    maxHeightIn: sizing?.maxHeightIn ?? 240,
    stepIn: sizing?.stepIn ?? 0.1
  };
}
function sizedCheckoutDimension(input) {
  const min = input.gangSheet ? Math.min(input.minSizeIn, 0.01) : input.minSizeIn;
  const step = 1e-6;
  return {
    x: { min, max: input.maxWidthIn, step },
    y: { min, max: input.maxHeightIn, step }
  };
}
function measuredPrintInches(input) {
  if (input.trimmedWidthPx < 1 || input.trimmedHeightPx < 1) return null;
  if (!(input.nativeWidthIn > 0) || !(input.nativeHeightIn > 0)) return null;
  const cap = input.sheetMaxWidthIn;
  const bounds = cap != null && cap > 0 ? {
    ...input.bounds,
    maxWidthIn: Math.min(input.bounds.maxWidthIn, cap),
    minSizeIn: Math.min(input.bounds.minSizeIn, 0.01)
  } : input.bounds;
  const fitted = fitSize({
    ...bounds,
    widthIn: input.nativeWidthIn,
    heightIn: input.nativeHeightIn,
    ratio: input.trimmedWidthPx / input.trimmedHeightPx,
    ratioLocked: true,
    edited: "width"
  });
  if (!(fitted.widthIn > 0) || !(fitted.heightIn > 0)) return null;
  return { widthIn: roundDisplay(fitted.widthIn), heightIn: roundDisplay(fitted.heightIn) };
}
function uploadProgressPercent(stage, uploadRatio) {
  const ratio = Number.isFinite(uploadRatio) ? Math.min(1, Math.max(0, uploadRatio)) : 0;
  switch (stage) {
    case "queued":
      return 0;
    case "uploading":
      return Math.round(ratio * 85);
    case "scanning":
      return 88;
    case "detecting":
      return 94;
    case "preview":
      return 98;
    case "ready":
      return 100;
    case "failed":
      return Math.round(ratio * 85);
    default: {
      const unreachable = stage;
      return unreachable;
    }
  }
}
function monotonicProgress(previous, next) {
  if (!Number.isFinite(previous)) return next;
  return Math.max(previous, next);
}
function pixelsPerMeterForInches(px, inches) {
  if (!Number.isFinite(px) || !Number.isFinite(inches) || px <= 0 || inches <= 0) return 0;
  const meters = inches * 0.0254;
  return Math.max(1, Math.round(px / meters));
}

// src/product-options/display-value.ts
function applyTextTransform(value, transform) {
  switch (transform) {
    case "UPPERCASE":
      return value.toLocaleUpperCase("en-US");
    case "LOWERCASE":
      return value.toLocaleLowerCase("en-US");
    case "CAPITALIZE":
      return value.replace(/\S+/g, (word) => {
        const [first, ...rest] = [...word];
        if (!first) return word;
        return first.toLocaleUpperCase("en-US") + rest.join("").toLocaleLowerCase("en-US");
      });
    default:
      return value;
  }
}
function formatIsoDate(iso, format) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
  const [year, month, day] = iso.split("-");
  switch (format) {
    case "YYYY-MM-DD":
      return iso;
    case "DD/MM/YYYY":
      return `${day}/${month}/${year}`;
    case "MM/DD/YYYY":
      return `${month}/${day}/${year}`;
    default: {
      const date = /* @__PURE__ */ new Date(`${iso}T00:00:00Z`);
      if (Number.isNaN(date.getTime())) return iso;
      return new Intl.DateTimeFormat("en-US", {
        dateStyle: "medium",
        timeZone: "UTC"
      }).format(date);
    }
  }
}
function optionDisplayValue(input) {
  const { optionType, values } = input;
  if (optionType === "CHECKBOX" || optionType === "BOOLEAN") {
    return values[0] === "true" ? "Yes" : "No";
  }
  if ((input.uploadTokens?.length ?? 0) > 0 && values.every((value) => value.trim() === "")) {
    return "";
  }
  if (optionType === "DATE") {
    const raw = values[0]?.trim() ?? "";
    if (raw === "") return "";
    const parsed = dateConfigSchema.safeParse(input.config ?? {});
    const format = parsed.success ? parsed.data.displayFormat : "LOCALE";
    return formatIsoDate(raw, format);
  }
  if (optionType === "IMAGE_UPLOAD_SIZED" || optionType === "GANGSHEET_UPLOAD_SIZED") {
    return formatSizedUploadValue(values, input.config);
  }
  if (optionType === "CUSTOM_SIZE") {
    const parsed = customSizeConfigSchema.safeParse(input.config ?? {});
    const unit = parsed.success ? parsed.data.unit : "in";
    const shown = values.map((value) => value.trim()).filter((value) => value !== "");
    return shown.length === 0 ? "" : `${shown.join(" \xD7 ")} ${unit}`;
  }
  if (optionType === "TEXT" || optionType === "TEXTAREA" || optionType === "STRING") {
    const raw = values[0]?.trim() ?? "";
    if (raw === "") return "";
    const parsed = textConfigSchema.safeParse(input.config ?? {});
    const transform = parsed.success ? parsed.data.textTransform : "NONE";
    return applyTextTransform(raw, transform);
  }
  const labels = new Map((input.choices ?? []).map((choice) => [choice.key, choice.label]));
  return values.map((value) => labels.get(value) ?? value).filter((value) => value.trim() !== "").join(", ");
}
function formatSizedUploadValue(values, config) {
  const width = Number(values[0]);
  const height = Number(values[1]);
  if (!Number.isFinite(width) || !Number.isFinite(height)) return "";
  const stretched = values[3]?.trim() === "stretch" ? " (stretched)" : "";
  const size = `${formatInches(width)} \xD7 ${formatInches(height)} in${stretched}`;
  const presetId = (values[2] ?? "").trim();
  const label = presetLabel(config, presetId);
  if (label) return `${label}: ${size}`;
  if (presetId === "custom") return `Custom: ${size}`;
  if (presetId === "detected" || presetId === "") return `Detected: ${size}`;
  return size;
}
function presetLabel(config, presetId) {
  if (!presetId || !config || typeof config !== "object") return null;
  const sizing = config.sizing;
  if (!sizing || !Array.isArray(sizing.presets)) return null;
  for (const item of sizing.presets) {
    if (!item || typeof item !== "object") continue;
    const row = item;
    if (row.id === presetId && typeof row.label === "string" && row.label.trim()) {
      return row.label.trim();
    }
  }
  return null;
}

// src/product-options/defaults.ts
var CHOICE_TYPES = /* @__PURE__ */ new Set([
  "RADIO",
  "SELECT",
  "SWATCH",
  "BUTTON_GROUP",
  "CHECKBOX_GROUP"
]);
function initialSelection(option) {
  if (CHOICE_TYPES.has(option.optionType)) {
    const parsed = productOptionChoicesSchema.safeParse(option.values ?? []);
    if (!parsed.success) return [];
    const keys = parsed.data.filter((choice) => choice.isDefault).map((choice) => choice.key);
    return isSingleSelectOptionType(option.optionType) ? keys.slice(0, 1) : keys;
  }
  if (option.optionType === "CHECKBOX" || option.optionType === "BOOLEAN") {
    return option.defaultValue === "true" ? ["true"] : [];
  }
  if (option.optionType === "CUSTOM_SIZE") {
    const parsed = customSizeConfigSchema.safeParse(option.config ?? {});
    if (!parsed.success) return [];
    const defaults = parsed.data.defaults;
    if (defaults.x == null || defaults.y == null) return [];
    const selected = [String(defaults.x), String(defaults.y)];
    if (parsed.data.dimensions === 3) {
      if (defaults.z == null) return [];
      selected.push(String(defaults.z));
    }
    return selected;
  }
  const raw = option.defaultValue?.trim() ?? "";
  if (raw === "") return [];
  if (option.optionType === "TEXT" || option.optionType === "TEXTAREA" || option.optionType === "STRING") {
    const parsed = textConfigSchema.safeParse(option.config ?? {});
    const transform = parsed.success ? parsed.data.textTransform : "NONE";
    return [applyTextTransform(raw, transform)];
  }
  return [raw];
}

// src/product-options/eligibility.ts
var PRODUCT_OPTIONS_ELIGIBLE_DESIGNER_MODE = "NONE";
function isProductOptionsEligible(template) {
  return template.designerMode === PRODUCT_OPTIONS_ELIGIBLE_DESIGNER_MODE;
}
var SIZED_UPLOAD_PRODUCT_TYPES = {
  IMAGE_UPLOAD_SIZED: ["DTF_BY_SIZE"],
  GANGSHEET_UPLOAD_SIZED: ["DTF_BY_SIZE", "GANGSHEET"]
};
function isSizedUploadOptionType(optionType) {
  return Object.prototype.hasOwnProperty.call(SIZED_UPLOAD_PRODUCT_TYPES, optionType);
}
function sizedUploadEligibilityError(optionType, template) {
  const allowed = SIZED_UPLOAD_PRODUCT_TYPES[optionType];
  if (!allowed) return null;
  if (template.designerMode !== PRODUCT_OPTIONS_ELIGIBLE_DESIGNER_MODE) {
    return "Sized uploads are available only when the designer mode is None.";
  }
  if (!allowed.includes(template.type)) {
    return optionType === "GANGSHEET_UPLOAD_SIZED" ? "Gang sheet upload is available on DTF by Size and Gangsheet products only." : "DTF by Size upload is available on DTF by Size products only.";
  }
  return null;
}

// src/product-options/display-rules.ts
function conditionMatches(condition, context) {
  const actuals = condition.source === "OPTION" ? context.selections[condition.sourceKey] ?? [] : condition.source === "VARIANT_AXIS" ? context.variantAxes[condition.sourceKey] !== void 0 ? [context.variantAxes[condition.sourceKey]] : [] : [String(context.quantity)];
  const expected = condition.values;
  switch (condition.operator) {
    case "EQ":
      return actuals.length > 0 && actuals.every((v) => expected.includes(v));
    case "NEQ":
      return actuals.every((v) => !expected.includes(v));
    case "IN":
      return actuals.some((v) => expected.includes(v));
    case "NOT_IN":
      return actuals.every((v) => !expected.includes(v));
    case "GTE":
    case "LTE": {
      const threshold = Number(expected[0]);
      const value = Number(actuals[0]);
      if (!Number.isFinite(threshold) || !Number.isFinite(value)) return false;
      return condition.operator === "GTE" ? value >= threshold : value <= threshold;
    }
    default:
      return false;
  }
}
function ruleMatches(rule, context) {
  const results = rule.conditions.map((c) => conditionMatches(c, context));
  return rule.combinator === "OR" ? results.some(Boolean) : results.every(Boolean);
}
function isOptionVisible(rules, context) {
  const hasShow = rules.some((rule) => rule.action === "SHOW");
  for (const rule of rules) {
    if (ruleMatches(rule, context)) return rule.action === "SHOW";
  }
  return !hasShow;
}
function visibleInOrder(options, context, rulesFor) {
  const selections = {};
  const shown = [];
  for (const option of options) {
    const rules = rulesFor(option);
    const visible = rules == null ? true : isOptionVisible(rules, {
      selections,
      variantAxes: context.variantAxes,
      quantity: context.quantity
    });
    if (!visible) continue;
    shown.push(option);
    const selected = context.selections[option.key];
    if (selected?.some((value) => value.trim() !== "")) selections[option.key] = selected;
  }
  return shown;
}

// src/product-options/pricing-resolver.ts
function activeQuantityTier(tiers, quantity) {
  let active = null;
  for (const tier of tiers) {
    if (tier.minQty <= quantity && (active == null || tier.minQty > active.minQty)) {
      active = tier;
    }
  }
  return active;
}
function deltaForSelection(option, variantUnitPriceCents, selectedChoiceKeys) {
  if (option.priceDeltaMode === "NONE") return null;
  if (option.priceDeltaMode === "PERCENT_OF_VARIANT") {
    const percent = option.priceDeltaPercent ?? 0;
    return {
      cents: Math.round(variantUnitPriceCents * percent / 100),
      mode: "PERCENT_OF_VARIANT"
    };
  }
  const keys = selectedChoiceKeys.filter((key) => key !== "");
  let cents;
  if (keys.length === 0) {
    cents = option.priceDeltaCents ?? 0;
  } else if (keys.length === 1) {
    const delta = option.choiceDeltas[keys[0]];
    cents = delta !== void 0 ? delta : option.priceDeltaCents ?? 0;
  } else {
    const priced = keys.filter((key) => option.choiceDeltas[key] !== void 0);
    cents = priced.length === 0 ? option.priceDeltaCents ?? 0 : priced.reduce((sum, key) => sum + (option.choiceDeltas[key] ?? 0), 0);
  }
  return { cents, mode: option.priceDeltaMode };
}
function formulaRawCents(formula) {
  if (!Number.isFinite(formula.width) || !Number.isFinite(formula.height) || !Number.isFinite(formula.rateCents) || formula.width <= 0 || formula.height <= 0) {
    return null;
  }
  const measure2 = sizeRateInches(formula.mode ?? "AREA", formula.width, formula.height);
  return Math.round(measure2 * formula.rateCents);
}
function resolveOptionPrice(input) {
  const quantity = Math.max(1, Math.trunc(input.quantity));
  const tierQuantity = input.tierQuantity != null && Number.isFinite(input.tierQuantity) ? Math.max(1, Math.trunc(input.tierQuantity)) : quantity;
  const formula = input.formula;
  const rawFormulaCents = formula ? formulaRawCents(formula) : null;
  const floor = formula?.minChargeCents != null && Number.isFinite(formula.minChargeCents) ? Math.max(0, Math.round(formula.minChargeCents)) : 0;
  const formulaUnitCents = rawFormulaCents == null ? null : Math.max(rawFormulaCents, floor);
  const percentBase = formulaUnitCents ?? input.variantUnitPriceCents;
  const surcharges = [];
  let exactSurchargeCents = 0;
  for (const option of input.options) {
    if (!Object.prototype.hasOwnProperty.call(input.selections, option.key)) continue;
    const selected = input.selections[option.key] ?? [];
    const delta = deltaForSelection(option, percentBase, selected);
    if (!delta || delta.cents === 0) continue;
    const amountCentsPerUnit = delta.mode === "PER_LINE" ? Math.trunc(delta.cents / quantity) : delta.cents;
    exactSurchargeCents += delta.mode === "PER_LINE" ? delta.cents : delta.cents * quantity;
    const choiceKey = selected.length === 1 && selected[0] !== "" ? selected[0] : null;
    surcharges.push({
      optionKey: option.key,
      choiceKey,
      label: option.label,
      mode: delta.mode,
      amountCentsPerUnit
    });
  }
  const surchargePerUnitCents = surcharges.reduce(
    (sum, line) => sum + line.amountCentsPerUnit,
    0
  );
  const tier = formulaUnitCents == null && (input.tiers == null || input.tiers.length === 0) ? null : activeQuantityTier(input.tiers ?? [], tierQuantity);
  const discountPercent = tier?.discountPercent ?? 0;
  const unitBeforeDiscount = (formulaUnitCents ?? input.variantUnitPriceCents) + surchargePerUnitCents;
  if (formulaUnitCents == null && discountPercent === 0) {
    return {
      variantUnitPriceCents: input.variantUnitPriceCents,
      surcharges,
      surchargePerUnitCents,
      quantity,
      formulaUnitCents: null,
      discountPercent: 0,
      discountCents: 0,
      customerUnitCents: input.variantUnitPriceCents + surchargePerUnitCents,
      lineTotalCents: input.variantUnitPriceCents * quantity + exactSurchargeCents
    };
  }
  const discountCents = Math.round(unitBeforeDiscount * discountPercent / 100);
  const customerUnitCents = unitBeforeDiscount - discountCents;
  return {
    variantUnitPriceCents: input.variantUnitPriceCents,
    surcharges,
    surchargePerUnitCents,
    quantity,
    formulaUnitCents,
    discountPercent,
    discountCents,
    customerUnitCents,
    lineTotalCents: customerUnitCents * quantity
  };
}

// src/product-options/checkout-pricing.ts
var DELTA_MODES = /* @__PURE__ */ new Set(["PER_UNIT", "PER_LINE", "PERCENT_OF_VARIANT"]);
var SHOPIFY_VARIANT_GID_PREFIX = "gid://shopify/ProductVariant/";
function shopifyVariantNumericId(value) {
  if (value == null) return null;
  const text = value.trim();
  if (/^\d+$/.test(text)) return text;
  if (text.startsWith(SHOPIFY_VARIANT_GID_PREFIX)) {
    const id = text.slice(SHOPIFY_VARIANT_GID_PREFIX.length);
    return /^\d+$/.test(id) ? id : null;
  }
  return null;
}
function buildCheckoutPricingPayload(input) {
  const deltas = [];
  for (const option of input.options) {
    if (!option.key || !DELTA_MODES.has(option.priceDeltaMode)) continue;
    const choices = {};
    for (const choice of option.choices) {
      if (typeof choice.priceDeltaCents === "number") choices[choice.key] = choice.priceDeltaCents;
    }
    const percent = typeof option.priceDeltaPercent === "number" && Number.isFinite(option.priceDeltaPercent) ? option.priceDeltaPercent : null;
    deltas.push({
      key: option.key,
      mode: option.priceDeltaMode,
      cents: option.priceDeltaCents ?? 0,
      percent,
      choices
    });
  }
  const dimension = input.options.find((option) => option.priced === true && option.dimension)?.dimension ?? null;
  const requiresOptions = input.options.some(
    (option) => option.priced === true || option.required === true
  );
  const minCharge = input.minChargeCents != null && Number.isFinite(input.minChargeCents) ? Math.max(0, Math.round(input.minChargeCents)) : 0;
  const productId = input.productId?.trim();
  return {
    schemaVersion: 1,
    ...productId ? { productId } : {},
    rateCents: input.rateCents != null && Number.isFinite(input.rateCents) ? Math.round(input.rateCents) : null,
    minChargeCents: minCharge,
    dimension,
    dimensionVariantId: shopifyVariantNumericId(input.dimensionVariantId),
    requiresOptions,
    quantity: {
      mode: input.quantity.mode,
      min: input.quantity.min,
      max: input.quantity.max,
      step: input.quantity.step,
      tiers: input.quantity.mode === "BULK" ? input.quantity.tiers.map((tier) => ({ ...tier })) : []
    },
    deltas,
    sizePricing: checkoutSizePricing(input.sizePricing)
  };
}
function checkoutSizePricing(pricing) {
  if (!pricing) return null;
  const fixed = pricing.fixedWidthIn;
  const bands = (pricing.bands ?? []).flatMap((band) => {
    if (!band.variantId || !Number.isFinite(band.heightIn) || band.heightIn <= 0) return [];
    return [
      {
        variantId: band.variantId,
        heightIn: band.heightIn,
        priceCents: Number.isFinite(band.priceCents) ? Math.round(band.priceCents) : 0
      }
    ];
  });
  return {
    mode: pricing.mode,
    tierAcrossLines: pricing.tierAcrossLines === true,
    ...typeof fixed === "number" && Number.isFinite(fixed) && fixed > 0 ? { fixedWidthIn: fixed } : {},
    ...bands.length > 0 ? { bands, allowSmaller: pricing.allowSmaller === true } : {}
  };
}
function encodeCheckoutSelections(selections) {
  return selections.filter((selection) => selection.key !== "").map(
    (selection) => selection.choices.length > 0 ? `${selection.key}:${selection.choices.join("+")}` : selection.key
  ).join("|");
}
function decodeCheckoutSelections(raw) {
  if (!raw) return [];
  const selections = [];
  for (const part of raw.split("|")) {
    if (part === "") continue;
    const splitAt = part.indexOf(":");
    const key = splitAt === -1 ? part : part.slice(0, splitAt);
    const choicePart = splitAt === -1 ? "" : part.slice(splitAt + 1);
    if (key === "") continue;
    selections.push({
      key,
      choices: choicePart === "" ? [] : choicePart.split("+").filter((choice) => choice !== "")
    });
  }
  return selections;
}
function recomputeCheckoutUnitCents(input) {
  if (!Number.isFinite(input.variantUnitCents) || input.variantUnitCents < 0) return null;
  const selected = new Map(input.selected.map((item) => [item.key, item.choices]));
  const options = input.payload.deltas.map((delta) => ({
    key: delta.key,
    label: delta.key,
    priceDeltaMode: delta.mode,
    priceDeltaCents: delta.cents,
    priceDeltaPercent: delta.percent,
    choiceDeltas: delta.choices
  }));
  const selections = {};
  for (const delta of input.payload.deltas) {
    const choices = selected.get(delta.key);
    if (choices) selections[delta.key] = choices;
  }
  const width = input.width;
  const height = input.height;
  const rate = input.payload.rateCents;
  const mode = input.payload.sizePricing?.mode ?? "AREA_RATE";
  const formula = mode === "VARIANT_BAND" || width == null || height == null || rate == null || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0 ? null : {
    width,
    height,
    rateCents: rate,
    minChargeCents: input.payload.minChargeCents,
    mode: sizeFormulaMode(mode) ?? "AREA"
  };
  const resolved = resolveOptionPrice({
    variantUnitPriceCents: input.variantUnitCents,
    quantity: input.quantity,
    options,
    selections,
    formula,
    tiers: input.payload.quantity.mode === "BULK" ? input.payload.quantity.tiers : void 0,
    tierQuantity: input.tierQuantity
  });
  return resolved.customerUnitCents;
}
function checkoutQuantityError(quantity, quantityConfig) {
  if (!Number.isFinite(quantity) || quantity < quantityConfig.min || quantity > quantityConfig.max) {
    return `Quantity must be between ${quantityConfig.min} and ${quantityConfig.max}.`;
  }
  if ((quantity - quantityConfig.min) % quantityConfig.step !== 0) {
    return `Quantity must increase in steps of ${quantityConfig.step}.`;
  }
  return null;
}

// src/product-options/variant-match.ts
function measure(candidate, input) {
  switch (input.rule) {
    case "HEIGHT_CEIL":
      return candidate.heightIn;
    case "WIDTH_CEIL":
      return candidate.widthIn;
    case "AREA_CEIL":
      return candidate.widthIn * candidate.heightIn;
    case "LONGEST_EDGE_CEIL":
      return Math.max(candidate.widthIn, candidate.heightIn);
    case "BOTH_EDGES_CEIL":
      return 0;
  }
}
function target(input) {
  switch (input.rule) {
    case "HEIGHT_CEIL":
      return input.detectedHeightIn;
    case "WIDTH_CEIL":
      return input.detectedWidthIn;
    case "AREA_CEIL":
      return input.detectedWidthIn * input.detectedHeightIn;
    case "LONGEST_EDGE_CEIL":
      return Math.max(input.detectedWidthIn, input.detectedHeightIn);
    case "BOTH_EDGES_CEIL":
      return 0;
  }
}
function fitsBothEdges(candidate, input) {
  const fitsNormal = candidate.widthIn >= input.detectedWidthIn && candidate.heightIn >= input.detectedHeightIn;
  const fitsRotated = candidate.widthIn >= input.detectedHeightIn && candidate.heightIn >= input.detectedWidthIn;
  return fitsNormal || fitsRotated;
}
function matchVariantForSize(input) {
  if (input.candidates.length === 0) return null;
  if (input.rule === "BOTH_EDGES_CEIL") {
    const fitting2 = input.candidates.filter((c) => fitsBothEdges(c, input)).sort((a, b) => a.widthIn * a.heightIn - b.widthIn * b.heightIn);
    if (fitting2.length > 0) return { variantId: fitting2[0].variantId, downscaled: false };
    if (!input.allowSmallerThanDetected) return null;
    const largest = [...input.candidates].sort(
      (a, b) => b.widthIn * b.heightIn - a.widthIn * a.heightIn
    )[0];
    return { variantId: largest.variantId, downscaled: true };
  }
  const wanted = target(input);
  const sorted = [...input.candidates].sort((a, b) => measure(a, input) - measure(b, input));
  const fitting = sorted.find((c) => measure(c, input) >= wanted);
  if (fitting) return { variantId: fitting.variantId, downscaled: false };
  if (!input.allowSmallerThanDetected) return null;
  return { variantId: sorted[sorted.length - 1].variantId, downscaled: true };
}

// src/product-options/line-item-properties.ts
var MAX_PROPERTY_VALUE_LENGTH = 255;
function formatMoney2(cents) {
  const sign = cents < 0 ? "-" : "";
  const abs = Math.abs(cents);
  return `${sign}$${(abs / 100).toFixed(2)}`;
}
function withSurchargeSuffix(value, surchargeCents) {
  if (surchargeCents === null || surchargeCents === 0) return value;
  const suffix = ` (${surchargeCents > 0 ? "+" : ""}${formatMoney2(surchargeCents)})`;
  return `${value}${suffix}`.slice(0, MAX_PROPERTY_VALUE_LENGTH);
}
function buildLineItemProperties(options, submissionToken, summary) {
  const usedNames = /* @__PURE__ */ new Map();
  const visible = options.filter((option) => !option.hiddenInCart && option.displayValue.trim() !== "").map((option) => {
    const base = option.label.trim().slice(0, 100) || "Option";
    const seen = (usedNames.get(base) ?? 0) + 1;
    usedNames.set(base, seen);
    const suffix = seen > 1 ? ` (${seen})` : "";
    const name = `${base.slice(0, 100 - suffix.length)}${suffix}`;
    return {
      name,
      value: withSurchargeSuffix(option.displayValue.trim(), option.surchargeCents).slice(
        0,
        MAX_PROPERTY_VALUE_LENGTH
      )
    };
  });
  const hidden = [
    { name: TK_CART_PROPERTIES.OPTIONS_REF, value: submissionToken }
  ];
  if (summary && isSummaryLink(summary)) {
    hidden.push(
      { name: TK_CART_PROPERTIES.SUMMARY_REF, value: summary.ref },
      { name: TK_CART_PROPERTIES.SUMMARY_PDF_URL, value: summary.pdfUrl }
    );
  }
  return { visible, hidden };
}
function isSummaryLink(summary) {
  return isValidOrderSummaryToken(summary.ref) && summary.pdfUrl.startsWith("https://") && summary.pdfUrl.includes(`/public/orders/summary/${summary.ref}.pdf`) && summary.pdfUrl.length <= MAX_PROPERTY_VALUE_LENGTH;
}
var PUBLIC_UPLOAD_URL = /^https:\/\/[^\s]+\/public\/option-uploads\/[^/\s]+\/(?:original|preview)(?:\?|$)/;
function uploadLinkProperties(uploads, usedNames = /* @__PURE__ */ new Set()) {
  const used = new Set(usedNames);
  const visible = [];
  uploads.forEach((upload, index) => {
    const label = upload.label.trim().slice(0, 80) || "Upload";
    const suffix = uploads.length > 1 ? ` ${index + 1}` : "";
    pushLink(visible, used, `${label}${suffix}`, upload.originalUrl);
    if (upload.previewUrl) {
      pushLink(visible, used, `Preview${suffix}`, upload.previewUrl);
    }
  });
  return visible;
}
function pushLink(visible, used, label, url) {
  if (!PUBLIC_UPLOAD_URL.test(url) || url.length > MAX_PROPERTY_VALUE_LENGTH) return;
  let name = label;
  let sequence = 2;
  while (used.has(name)) {
    name = `${label} (${sequence})`;
    sequence += 1;
  }
  used.add(name);
  visible.push({ name, value: url });
}

// src/product-options/tokens.ts
var BASE62 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
var TOKEN_BODY_LENGTH = 22;
function randomBody(length) {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < length; i++) out += BASE62[bytes[i] % BASE62.length];
  return out;
}
function generateOptionSubmissionToken() {
  return `OPS_${randomBody(TOKEN_BODY_LENGTH)}`;
}
function generateOptionUploadToken() {
  return `OU_${randomBody(TOKEN_BODY_LENGTH)}`;
}
function isValidOptionsRefToken(token) {
  return OPTION_SUBMISSION_TOKEN_PATTERN.test(token);
}
function isValidOptionUploadToken(token) {
  return OPTION_UPLOAD_TOKEN_PATTERN.test(token);
}

// src/product-options/registry.ts
var PHASE1_SUPPORTED_OPTION_TYPES = [
  "TEXT",
  "TEXTAREA",
  "STRING",
  "NUMBER",
  "CHECKBOX",
  "CHECKBOX_GROUP",
  "BOOLEAN",
  "RADIO",
  "SELECT",
  "SWATCH",
  "BUTTON_GROUP",
  "DATE",
  "CUSTOM_SIZE",
  "INFO",
  "FILE_UPLOAD",
  "IMAGE_UPLOAD_SIZED",
  "GANGSHEET_UPLOAD_SIZED"
];
var PICKER_OPTION_TYPES = [
  "TEXT",
  "TEXTAREA",
  "NUMBER",
  "CHECKBOX",
  "CHECKBOX_GROUP",
  "RADIO",
  "SELECT",
  "SWATCH",
  "BUTTON_GROUP",
  "DATE",
  "CUSTOM_SIZE",
  "INFO",
  "FILE_UPLOAD"
];
function pickerOptionTypesFor(template) {
  if (template.designerMode !== "NONE") return PICKER_OPTION_TYPES;
  const extra = [];
  if (template.type === "DTF_BY_SIZE") {
    extra.push("IMAGE_UPLOAD_SIZED", "GANGSHEET_UPLOAD_SIZED");
  } else if (template.type === "GANGSHEET") {
    extra.push("GANGSHEET_UPLOAD_SIZED");
  }
  return extra.length === 0 ? PICKER_OPTION_TYPES : [...PICKER_OPTION_TYPES, ...extra];
}
var LEGACY_OPTION_TYPES = ["STRING", "BOOLEAN"];
function isLegacyOptionType(optionType) {
  return LEGACY_OPTION_TYPES.includes(optionType);
}
var PHASE1_SET = new Set(PHASE1_SUPPORTED_OPTION_TYPES);
function isPhase1OptionType(optionType) {
  return PHASE1_SET.has(optionType);
}
var registry = /* @__PURE__ */ new Map();
function registerOptionType(definition) {
  registry.set(definition.type, definition);
}
function getOptionType(type) {
  return registry.get(type);
}
function listOptionTypes() {
  return [...registry.values()];
}

// src/product-options/plugins.ts
import { z as z6 } from "zod";

// src/product-options/selection.ts
function isOptionSelectionFilled(selection) {
  if (!selection) return false;
  if ((selection.uploadTokens?.length ?? 0) > 0) return true;
  return (selection.values ?? []).some((value) => {
    const trimmed2 = value.trim();
    return trimmed2 !== "" && trimmed2 !== "false";
  });
}
var isFilled = isOptionSelectionFilled;
function unsafeCustomerPattern(pattern) {
  if (pattern.length > 200) return "Validation pattern is too long.";
  try {
    new RegExp(pattern);
  } catch {
    return "Validation pattern is not a valid regular expression.";
  }
  if (/\((?:[^()\\]|\\.)*[+*](?:[^()\\]|\\.)*\)(?:[+*]|\{\d)/.test(pattern)) {
    return "Validation pattern is too expensive to check.";
  }
  return null;
}
function isRealIsoDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}

// src/product-options/plugins.ts
var NO_UPLOAD = {
  supportsVersions: false,
  supportsRecent: false,
  supportsGallery: false,
  supportsImageTools: false,
  bindsVariantAxis: false,
  usesChoices: false,
  usesPricing: true
};
function requiredValueError(selection, required) {
  if (!required) return null;
  if (!selection || selection.values.every((v) => v.trim() === "")) {
    return "This field is required.";
  }
  return null;
}
function registerTextFamily(type, defaults) {
  registerOptionType({
    type: ProductOptionType[type],
    configSchema: textConfigSchema,
    defaultConfig: defaults,
    capabilities: NO_UPLOAD,
    processingPipeline: [],
    validate: (selection, config, required) => {
      const missing = requiredValueError(selection, required);
      if (missing) return missing;
      if ((selection?.values.length ?? 0) > 1) return "Enter a single value.";
      const raw = selection?.values[0]?.trim() ?? "";
      if (raw === "") return null;
      const value = applyTextTransform(raw, config.textTransform);
      const hardCap = type === "TEXTAREA" ? 2e4 : 2e3;
      const limit = Math.min(config.maxLength, hardCap);
      if (value.length < config.minLength) return `Enter at least ${config.minLength} characters.`;
      if (value.length > limit) return `Keep it under ${limit} characters.`;
      if (config.pattern) {
        if (unsafeCustomerPattern(config.pattern)) return "Invalid validation pattern configured.";
        if (!new RegExp(config.pattern).test(value)) {
          return "The value does not match the required format.";
        }
      }
      return null;
    }
  });
}
registerTextFamily("TEXT", {
  minLength: 0,
  maxLength: 200,
  pattern: null,
  showCounter: false,
  textTransform: "NONE"
});
registerTextFamily("TEXTAREA", {
  minLength: 0,
  maxLength: 2e3,
  pattern: null,
  showCounter: true,
  textTransform: "NONE"
});
registerTextFamily("STRING", {
  minLength: 0,
  maxLength: 500,
  pattern: null,
  showCounter: false,
  textTransform: "NONE"
});
function registerNumber(type) {
  registerOptionType({
    type: ProductOptionType[type],
    configSchema: numberConfigSchema,
    defaultConfig: { min: null, max: null, step: 1 },
    capabilities: NO_UPLOAD,
    processingPipeline: [],
    validate: (selection, config, required) => {
      const missing = requiredValueError(selection, required);
      if (missing) return missing;
      if ((selection?.values.length ?? 0) > 1) return "Enter a single value.";
      const raw = selection?.values[0]?.trim() ?? "";
      if (raw === "") return null;
      if (raw.length > 64) return "Enter a shorter number.";
      const value = Number(raw);
      if (!Number.isFinite(value)) return "Enter a number.";
      if (config.min !== null && config.min !== void 0 && value < config.min) {
        return `Minimum is ${config.min}.`;
      }
      if (config.max !== null && config.max !== void 0 && value > config.max) {
        return `Maximum is ${config.max}.`;
      }
      const step = config.step ?? 1;
      const origin = config.min ?? 0;
      const steps = (value - origin) / step;
      if (Math.abs(steps - Math.round(steps)) > 1e-6) {
        return `Use steps of ${step}.`;
      }
      return null;
    }
  });
}
registerNumber("NUMBER");
var booleanConfigSchema = z6.object({});
function validateCheckbox(selection, required) {
  if (!required) return null;
  return selection?.values[0] === "true" ? null : "This field is required.";
}
registerOptionType({
  type: ProductOptionType.CHECKBOX,
  configSchema: checkboxConfigSchema,
  defaultConfig: {},
  capabilities: NO_UPLOAD,
  processingPipeline: [],
  validate: (selection, _config, required) => validateCheckbox(selection, required)
});
registerOptionType({
  type: ProductOptionType.BOOLEAN,
  configSchema: booleanConfigSchema,
  defaultConfig: {},
  capabilities: NO_UPLOAD,
  processingPipeline: [],
  validate: (selection, _config, required) => validateCheckbox(selection, required)
});
var CHOICE_TYPES2 = ["RADIO", "SELECT", "BUTTON_GROUP"];
registerOptionType({
  type: ProductOptionType.SWATCH,
  configSchema: swatchConfigSchema,
  defaultConfig: { swatchSize: "SMALL" },
  capabilities: { ...NO_UPLOAD, usesChoices: true },
  processingPipeline: [],
  validate: (selection, _config, required) => {
    const missing = requiredValueError(selection, required);
    if (missing) return missing;
    const filled = selection?.values.filter((value) => value.trim() !== "") ?? [];
    if (filled.length > 1) return "Choose one option.";
    return null;
  }
});
for (const type of CHOICE_TYPES2) {
  registerOptionType({
    type: ProductOptionType[type],
    configSchema: z6.object({}),
    defaultConfig: {},
    capabilities: { ...NO_UPLOAD, usesChoices: true },
    processingPipeline: [],
    validate: (selection, _config, required) => {
      const missing = requiredValueError(selection, required);
      if (missing) return missing;
      const filled = selection?.values.filter((value) => value.trim() !== "") ?? [];
      if (filled.length > 1) return "Choose one option.";
      return null;
    }
  });
}
registerOptionType({
  type: ProductOptionType.CHECKBOX_GROUP,
  configSchema: checkboxGroupConfigSchema,
  defaultConfig: { minSelections: 0, maxSelections: null },
  capabilities: { ...NO_UPLOAD, usesChoices: true },
  processingPipeline: [],
  validate: (selection, config, required) => {
    const picked = selection?.values.filter((value) => value.trim() !== "") ?? [];
    if (required && picked.length === 0) return "Choose at least one option.";
    if (picked.length > 0 && picked.length < config.minSelections) {
      return `Choose at least ${config.minSelections}.`;
    }
    if (config.maxSelections != null && picked.length > config.maxSelections) {
      return `Choose at most ${config.maxSelections}.`;
    }
    return null;
  }
});
registerOptionType({
  type: ProductOptionType.DATE,
  configSchema: dateConfigSchema,
  defaultConfig: { minDate: null, maxDate: null, blackoutDates: [], displayFormat: "LOCALE" },
  capabilities: NO_UPLOAD,
  processingPipeline: [],
  validate: (selection, config, required) => {
    const missing = requiredValueError(selection, required);
    if (missing) return missing;
    if ((selection?.values.length ?? 0) > 1) return "Enter a single date.";
    const value = selection?.values[0]?.trim() ?? "";
    if (value === "") return null;
    if (!isRealIsoDate(value)) return "Enter a real calendar date (YYYY-MM-DD).";
    if (config.minDate && value < config.minDate) return `Earliest date is ${config.minDate}.`;
    if (config.maxDate && value > config.maxDate) return `Latest date is ${config.maxDate}.`;
    if (config.blackoutDates.includes(value)) return "That date is not available.";
    return null;
  }
});
registerOptionType({
  type: ProductOptionType.INFO,
  configSchema: infoConfigSchema,
  defaultConfig: { body: "" },
  capabilities: { ...NO_UPLOAD, usesPricing: false },
  processingPipeline: [],
  validate: () => null
});
function customSizeAxisError(label, raw, min, max, step, unit) {
  const trimmed2 = raw?.trim() ?? "";
  if (trimmed2 === "") return `Enter a ${label.toLowerCase()}.`;
  const value = Number(trimmed2);
  if (!Number.isFinite(value)) return `Enter a ${label.toLowerCase()}.`;
  if (value < min || value > max) {
    return `${label} must be between ${min} and ${max} ${unit}.`;
  }
  const steps = (value - min) / step;
  if (Math.abs(steps - Math.round(steps)) > 1e-6) {
    return `${label} uses steps of ${step} ${unit}.`;
  }
  return null;
}
registerOptionType({
  type: ProductOptionType.CUSTOM_SIZE,
  configSchema: customSizeConfigSchema,
  defaultConfig: {
    unit: "in",
    dimensions: 2,
    labels: { x: "Width", y: "Height" },
    min: { x: 1, y: 1 },
    max: { x: 120, y: 120 },
    step: { x: 0.5, y: 0.5 },
    defaults: {}
  },
  capabilities: NO_UPLOAD,
  processingPipeline: [],
  validate: (selection, config, required) => {
    const axes = config.dimensions === 3 ? [
      ["x", config.labels.x, selection?.values[0]],
      ["y", config.labels.y, selection?.values[1]],
      ["z", config.labels.z ?? "Depth", selection?.values[2]]
    ] : [
      ["x", config.labels.x, selection?.values[0]],
      ["y", config.labels.y, selection?.values[1]]
    ];
    const empty = axes.every(([, , raw]) => (raw?.trim() ?? "") === "");
    if (empty) return required ? "This field is required." : null;
    for (const [axis, label, raw] of axes) {
      const min = config.min[axis];
      const max = config.max[axis];
      const step = config.step[axis];
      if (min == null || max == null || step == null) return "This size option is misconfigured.";
      const error = customSizeAxisError(label, raw, min, max, step, config.unit);
      if (error) return error;
    }
    return null;
  }
});
var FILE_UPLOAD_DEFAULT = {
  accept: { mimeTypes: ["application/pdf", "image/png", "image/jpeg"], maxFileMb: 50, maxFiles: 5 },
  sources: ["DEVICE", "RECENT"]
};
registerOptionType({
  type: ProductOptionType.FILE_UPLOAD,
  configSchema: uploadConfigSchema,
  defaultConfig: FILE_UPLOAD_DEFAULT,
  capabilities: {
    ...NO_UPLOAD,
    supportsVersions: true,
    supportsRecent: true,
    supportsGallery: false
  },
  processingPipeline: ["SCAN", "HASH", "THUMB"],
  validate: (selection, config, required) => {
    const count = selection?.uploadTokens?.length ?? 0;
    if (required && count === 0) return "Upload at least one file.";
    if (count > config.accept.maxFiles) return `Up to ${config.accept.maxFiles} files.`;
    return null;
  }
});
registerOptionType({
  type: ProductOptionType.IMAGE_UPLOAD_SIZED,
  configSchema: uploadConfigSchema,
  defaultConfig: {
    accept: { mimeTypes: ["image/png", "image/jpeg", "image/webp"], maxFileMb: 150, maxFiles: 25 },
    sources: ["DEVICE", "RECENT"],
    sizing: {
      assumedDpi: 300,
      trim: true,
      minDpiWarn: 150,
      minSizeIn: 0.1,
      maxWidthIn: 22,
      maxHeightIn: 240,
      stepIn: 0.1,
      dpiSource: "EMBEDDED_IF_PLAUSIBLE",
      dpiGood: 250,
      dpiFair: 150,
      trimMode: "ALPHA",
      trimAlphaThreshold: 8,
      allowResize: true,
      allowDetectedSize: true,
      allowStretch: true,
      presets: []
    },
    sizePricing: { mode: "AREA_RATE", pricingVariantId: null },
    variantBinding: {
      optionTypeId: "",
      defaultVariantRule: "LONGEST_EDGE_CEIL",
      customerCanChangeVariant: false,
      allowSmallerThanDetected: false
    },
    imageTools: { bgRemoval: "OFF", upscale: "OFF", editor: "ON" },
    printRender: {
      ratioLocked: true,
      fit: "CONTAIN",
      allowUpscale: true,
      minEffectiveDpiWarn: 150
    }
  },
  capabilities: {
    supportsVersions: true,
    supportsRecent: true,
    supportsGallery: false,
    supportsImageTools: true,
    bindsVariantAxis: true,
    usesChoices: false,
    usesPricing: true
  },
  processingPipeline: ["SCAN", "HASH", "METADATA", "TRIM", "PRINT_RENDER", "PREVIEW", "THUMB"],
  validate: (selection, config, required) => validateSizedUpload(selection, config, required, null)
});
registerOptionType({
  type: ProductOptionType.GANGSHEET_UPLOAD_SIZED,
  configSchema: uploadConfigSchema,
  defaultConfig: {
    accept: { mimeTypes: ["image/png", "image/jpeg", "image/webp"], maxFileMb: 500, maxFiles: 10 },
    sources: ["DEVICE", "RECENT"],
    sizing: {
      assumedDpi: 300,
      trim: true,
      minDpiWarn: 150,
      minSizeIn: 0.1,
      maxWidthIn: 22,
      maxHeightIn: 240,
      stepIn: 0.1,
      dpiSource: "EMBEDDED_IF_PLAUSIBLE",
      dpiGood: 250,
      dpiFair: 150,
      trimMode: "ALPHA",
      trimAlphaThreshold: 8,
      allowResize: false,
      allowDetectedSize: true,
      allowStretch: false,
      presets: []
    },
    sizePricing: { mode: "LONGEST_EDGE_RATE", pricingVariantId: null },
    variantBinding: {
      optionTypeId: "",
      defaultVariantRule: "HEIGHT_CEIL",
      customerCanChangeVariant: false,
      allowSmallerThanDetected: false,
      fixedWidthIn: 22
    },
    gangsheet: { widthToleranceIn: 0.25 },
    printRender: {
      ratioLocked: true,
      fit: "CONTAIN",
      allowUpscale: false,
      minEffectiveDpiWarn: 150
    }
  },
  capabilities: {
    supportsVersions: true,
    supportsRecent: true,
    supportsGallery: false,
    supportsImageTools: false,
    bindsVariantAxis: true,
    usesChoices: false,
    usesPricing: true
  },
  processingPipeline: ["SCAN", "HASH", "METADATA", "TRIM", "PRINT_RENDER", "THUMB"],
  validate: (selection, config, required) => validateSizedUpload(selection, config, required, "gangsheet")
});
function validateSizedUpload(selection, config, required, kind) {
  const parsed = uploadConfigSchema.safeParse(config);
  if (!parsed.success) return "Invalid upload configuration.";
  const upload = parsed.data;
  const bounds = sizingBounds(upload);
  const message = validateSizedValues({
    values: selection?.values ?? [],
    required,
    uploadCount: selection?.uploadTokens?.length ?? 0,
    maxFiles: upload.accept.maxFiles,
    bounds: kind === "gangsheet" ? { ...bounds, minSizeIn: Math.min(bounds.minSizeIn, 0.01) } : bounds,
    allowResize: kind === "gangsheet" ? false : upload.sizing?.allowResize ?? true,
    allowStretch: kind === "gangsheet" ? false : upload.sizing?.allowStretch ?? true,
    fixedWidthIn: kind === "gangsheet" ? upload.variantBinding?.fixedWidthIn ?? 22 : null
  });
  if (kind === "gangsheet" && message === "Upload an image.") return "Upload a gang sheet.";
  return message;
}

// src/product-options/upload-policy.ts
var PLATFORM_DEFAULT_MIMES = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif",
  "application/pdf"
];
var ALWAYS_DENIED = /* @__PURE__ */ new Set([
  "application/x-msdownload",
  "application/x-executable",
  "application/x-dosexec",
  "application/zip",
  "application/x-zip-compressed",
  "application/gzip",
  "application/x-tar",
  "application/x-rar-compressed",
  "application/java-archive",
  "application/javascript",
  "text/html",
  "text/javascript",
  "image/svg+xml"
]);
var SVG = "image/svg+xml";
function normalizeMime(value) {
  return value.trim().toLowerCase();
}
var PLATFORM_NEVER = new Set(
  [...ALWAYS_DENIED].filter((mime) => mime !== SVG)
);
function normalizePlatformMimeSuperset(mimes) {
  const normalized = [
    ...new Set(mimes.map(normalizeMime).filter((mime) => mime.length > 0))
  ];
  const rejected = normalized.filter(
    (mime) => PLATFORM_NEVER.has(mime) || !/^[\w.+-]+\/[\w.+-]+$/.test(mime)
  );
  if (rejected.length > 0) {
    return {
      ok: false,
      message: `These file types cannot be allowed: ${rejected.join(", ")}.`
    };
  }
  return { ok: true, mimes: normalized };
}
function allowedMimesForOption(input) {
  const superset = input.platformSuperset.length > 0 ? input.platformSuperset.map(normalizeMime) : [...PLATFORM_DEFAULT_MIMES];
  const supersetSet = new Set(superset.filter((mime) => !ALWAYS_DENIED.has(mime)));
  const accepted = input.optionMimes.map(normalizeMime).filter((mime) => supersetSet.has(mime) && !ALWAYS_DENIED.has(mime));
  const optionListsSvg = input.optionMimes.some((mime) => normalizeMime(mime) === SVG);
  const platformAllowsSvg = input.platformSuperset.some((mime) => normalizeMime(mime) === SVG);
  const svgOption = input.optionType === "FILE_UPLOAD" || input.optionType === "IMAGE_UPLOAD_SIZED" || input.optionType === "GANGSHEET_UPLOAD_SIZED";
  if (svgOption && optionListsSvg && platformAllowsSvg) {
    accepted.push(SVG);
  }
  return [...new Set(accepted)];
}
function isMimeAllowed(mime, allowed) {
  return allowed.includes(normalizeMime(mime).split(";")[0]?.trim() ?? "");
}
var DECLARED_MIME_ALIASES = {
  "image/jpg": "image/jpeg",
  "image/pjpeg": "image/jpeg",
  "image/x-citrix-jpeg": "image/jpeg",
  "image/x-png": "image/png",
  "image/apng": "image/png",
  "image/vnd.mozilla.apng": "image/png",
  "image/x-citrix-png": "image/png",
  "image/tif": "image/tiff",
  "image/x-tiff": "image/tiff"
};
var EXTENSION_MIME = {
  png: "image/png",
  apng: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  webp: "image/webp",
  gif: "image/gif",
  pdf: "application/pdf",
  tif: "image/tiff",
  tiff: "image/tiff",
  svg: "image/svg+xml",
  avif: "image/avif"
};
function stripDeclaredMime(mime) {
  const base = normalizeMime(mime).split(";")[0]?.trim() ?? "";
  return DECLARED_MIME_ALIASES[base] ?? base;
}
function canonicalDeclaredMime(declared, fileName) {
  const mime = stripDeclaredMime(declared);
  const undetected = mime.length === 0 || mime === "application/octet-stream" || mime === "application/binary" || mime === "binary/octet-stream";
  if (!undetected) return mime;
  const base = fileName.split(/[/\\]/).pop() ?? "";
  const ext = base.includes(".") ? base.split(".").pop()?.toLowerCase() ?? "" : "";
  return EXTENSION_MIME[ext] ?? mime;
}
function uploadAcceptAttribute(mimes) {
  const extras = [];
  for (const mime of mimes.map((item) => stripDeclaredMime(item))) {
    if (mime === "image/png") extras.push(".png", ".apng");
    else if (mime === "image/jpeg") extras.push(".jpg", ".jpeg");
    else if (mime === "image/webp") extras.push(".webp");
    else if (mime === "image/gif") extras.push(".gif");
    else if (mime === "application/pdf") extras.push(".pdf");
    else if (mime === "image/tiff") extras.push(".tif", ".tiff");
    else if (mime === "image/avif") extras.push(".avif");
    else if (mime === "image/svg+xml") extras.push(".svg");
  }
  return [...mimes, ...extras].join(",");
}
function sanitizeUploadFileName(name) {
  const base = name.split(/[/\\]/).pop() ?? "file";
  const cleaned = base.replace(/[^\w.\- ()]+/g, "_").replace(/^\.+/, "").slice(0, 180);
  return cleaned.length > 0 ? cleaned : "file";
}
function effectiveMaxBytes(input) {
  const mb = Math.min(input.optionMaxMb, input.platformCeilingMb, input.envCeilingMb);
  return Math.floor(mb * 1024 * 1024);
}
function partCountFor(sizeBytes, partSizeBytes) {
  if (sizeBytes < 1 || partSizeBytes < 1) return 0;
  return Math.ceil(sizeBytes / partSizeBytes);
}

// src/product-options/upload-failure.ts
var OptionUploadFailureCode = {
  EMPTY: "EMPTY",
  SIZE_MISMATCH: "SIZE_MISMATCH",
  SIZE_LIMIT: "SIZE_LIMIT",
  TYPE_NOT_ALLOWED: "TYPE_NOT_ALLOWED",
  DECODE_FAILED: "DECODE_FAILED",
  PIXEL_LIMIT: "PIXEL_LIMIT",
  THUMB_FAILED: "THUMB_FAILED",
  MALWARE: "MALWARE",
  SCAN_REQUIRED: "SCAN_REQUIRED",
  SCAN_PROVIDER: "SCAN_PROVIDER",
  ABANDONED: "ABANDONED",
  STUCK: "STUCK",
  NO_OBJECT: "NO_OBJECT",
  INVALID_CONFIG: "INVALID_CONFIG",
  DOWNLOAD_MISMATCH: "DOWNLOAD_MISMATCH",
  PROCESSING_FAILED: "PROCESSING_FAILED",
  WIDTH_EXCEEDS: "WIDTH_EXCEEDS"
};
var CODES = new Set(Object.values(OptionUploadFailureCode));
function optionUploadFailureCode(raw) {
  if (raw && CODES.has(raw)) return raw;
  return OptionUploadFailureCode.PROCESSING_FAILED;
}
var MESSAGES = {
  EMPTY: "The uploaded file is empty.",
  SIZE_MISMATCH: "The stored file size does not match the upload.",
  SIZE_LIMIT: "The file is larger than the allowed size.",
  TYPE_NOT_ALLOWED: "This file type is not accepted.",
  DECODE_FAILED: "The image could not be read.",
  PIXEL_LIMIT: "The image exceeds the pixel limit.",
  THUMB_FAILED: "A preview could not be created for this image.",
  MALWARE: "The file failed the malware scan.",
  SCAN_REQUIRED: "Malware scanning is required but no scanner is configured.",
  SCAN_PROVIDER: "The configured malware scanner is not supported.",
  ABANDONED: "The upload was not finished.",
  STUCK: "Processing did not finish. Please upload the file again.",
  NO_OBJECT: "The uploaded file is missing.",
  INVALID_CONFIG: "This option is not configured for uploads.",
  DOWNLOAD_MISMATCH: "The stored file could not be read completely.",
  PROCESSING_FAILED: "The file could not be processed.",
  WIDTH_EXCEEDS: "The image is wider than this gang sheet allows."
};
var UPLOAD_MAX_PIXELS_DEFAULT = 268402689;
function resolveUploadMaxPixels(raw) {
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 1) return UPLOAD_MAX_PIXELS_DEFAULT;
  return Math.min(Math.floor(parsed), UPLOAD_MAX_PIXELS_DEFAULT);
}
var SIZED_UPLOAD_MAX_PIXELS_DEFAULT = 5e8;
var SIZED_UPLOAD_MAX_PIXELS_HARD = 6e8;
function resolveSizedUploadMaxPixels(raw) {
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 1) return SIZED_UPLOAD_MAX_PIXELS_DEFAULT;
  return Math.min(Math.floor(parsed), SIZED_UPLOAD_MAX_PIXELS_HARD);
}
function optionUploadFailureMessage(code, limits) {
  if (!code) return null;
  if (code === OptionUploadFailureCode.PIXEL_LIMIT && limits?.maxPixels && limits.maxPixels > 0) {
    const megapixels = Math.max(1, Math.round(limits.maxPixels / 1e6));
    return `The image exceeds ${megapixels} megapixels.`;
  }
  if (code === OptionUploadFailureCode.SIZE_LIMIT && limits?.maxFileMb && limits.maxFileMb > 0) {
    return `The file must be ${limits.maxFileMb} MB or smaller.`;
  }
  if (CODES.has(code)) return MESSAGES[code];
  return MESSAGES.PROCESSING_FAILED;
}

// src/product-options/order-display.ts
var PREVIEWABLE_IMAGE = /^image\/(png|jpeg|webp|gif)$/;
function variantAxisLabel(snapshot) {
  if (!snapshot || typeof snapshot !== "object" || Array.isArray(snapshot)) return null;
  const options = snapshot.options;
  if (!Array.isArray(options)) return null;
  const parts = [];
  for (const row of options) {
    if (!row || typeof row !== "object") continue;
    const record = row;
    const type = typeof record.type === "string" ? record.type : record.name;
    if (typeof type !== "string" || typeof record.value !== "string") continue;
    const name = type.trim();
    const value = record.value.trim();
    if (!name || !value || name.startsWith("_")) continue;
    parts.push(`${name}: ${value}`);
  }
  return parts.length > 0 ? parts.join(" / ") : null;
}
var RAW_SIZED_VALUE = /^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)(?:,\s*([^,\s]+))?(?:,\s*stretch)?$/;
var PRETTY_SIZED_VALUE = /(\d+(?:\.\d+)?)\s×\s(\d+(?:\.\d+)?)\s+in/;
function inchesPair(width, height) {
  if (!Number.isFinite(width) || !Number.isFinite(height)) return null;
  return `${formatInches(width)} \xD7 ${formatInches(height)} in`;
}
function sizedInchesFromValue(value) {
  const raw = value.trim().match(RAW_SIZED_VALUE);
  if (raw) {
    const width2 = Number(raw[1]);
    const height2 = Number(raw[2]);
    if (Number.isFinite(width2) && Number.isFinite(height2)) return { width: width2, height: height2 };
  }
  const pretty = value.match(PRETTY_SIZED_VALUE);
  if (!pretty) return null;
  const width = Number(pretty[1]);
  const height = Number(pretty[2]);
  if (!Number.isFinite(width) || !Number.isFinite(height)) return null;
  return { width, height };
}
function selectionInches(customization) {
  if (!customization || typeof customization !== "object" || Array.isArray(customization)) {
    return null;
  }
  const selections = customization.selections;
  if (!Array.isArray(selections)) return null;
  for (const row of selections) {
    if (!row || typeof row !== "object") continue;
    const value = row.value;
    if (typeof value !== "string") continue;
    const size = sizedInchesFromValue(value);
    if (size) return size;
  }
  return null;
}
function chargedInches(customization) {
  if (!customization || typeof customization !== "object" || Array.isArray(customization)) {
    return null;
  }
  const pricing = customization.pricing;
  if (!pricing || typeof pricing !== "object" || Array.isArray(pricing)) return null;
  const row = pricing;
  const width = typeof row.formulaWidth === "number" ? row.formulaWidth : Number(row.formulaWidth);
  const height = typeof row.formulaHeight === "number" ? row.formulaHeight : Number(row.formulaHeight);
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
  return { width, height };
}
function orderedSizeText(customization) {
  const size = selectionInches(customization);
  return size ? inchesPair(size.width, size.height) : null;
}
function printSizeChangedNote(customization) {
  const print = selectionInches(customization);
  const charged = chargedInches(customization);
  if (!print || !charged) return null;
  const same = Math.abs(print.width - charged.width) <= 0.01 && Math.abs(print.height - charged.height) <= 0.01;
  return same ? null : "(updated, price unchanged)";
}
function formatOrderedOptionValue(value) {
  const raw = value.trim().match(RAW_SIZED_VALUE);
  if (!raw?.[3]) return value;
  const size = inchesPair(Number(raw[1]), Number(raw[2]));
  if (!size) return value;
  if (raw[3] === "custom") return `Custom: ${size}`;
  if (raw[3] === "detected") return `Detected: ${size}`;
  return size;
}
function orderedVariantLabel(snapshot, customization) {
  const base = variantAxisLabel(snapshot);
  if (!base) return null;
  const size = orderedSizeText(customization);
  if (!size) return base;
  const note = printSizeChangedNote(customization);
  return base.split(" / ").map((part, index) => {
    const name = part.includes(": ") ? part.slice(part.indexOf(": ") + 2) : part;
    const labeled = `${name}: ${size}`;
    return index === 0 && note ? `${labeled} ${note}` : labeled;
  }).join(" / ");
}
function optionUploadPreviewFiles(customization) {
  if (!customization || typeof customization !== "object" || Array.isArray(customization)) {
    return [];
  }
  const uploads = customization.uploads;
  if (!Array.isArray(uploads)) return [];
  const files = [];
  for (const raw of uploads) {
    if (!raw || typeof raw !== "object") continue;
    const record = raw;
    if (typeof record.mimeType !== "string" || !PREVIEWABLE_IMAGE.test(record.mimeType)) continue;
    const key = [record.keys?.preview, record.keys?.thumb, record.keys?.original].find(
      (item) => typeof item === "string" && item.length > 0
    );
    if (!key) continue;
    const label = typeof record.fileName === "string" && record.fileName.trim().length > 0 ? record.fileName.trim() : "Uploaded file";
    files.push({ key, label });
  }
  return files;
}

// src/product-options/upload-version.ts
var SIZED_PRINT_TYPES = /* @__PURE__ */ new Set(["IMAGE_UPLOAD_SIZED", "GANGSHEET_UPLOAD_SIZED"]);
var VERSION_QUERY = /([?&])v=\d+/;
function withVersion(url, versionNo) {
  if (VERSION_QUERY.test(url)) {
    return url.replace(VERSION_QUERY, `$1v=${versionNo}`);
  }
  return `${url}${url.includes("?") ? "&" : "?"}v=${versionNo}`;
}
function rewriteStoredUploadVersion(customization, update) {
  if (!customization || typeof customization !== "object" || Array.isArray(customization)) {
    return customization;
  }
  const root = customization;
  if (!Array.isArray(root.uploads)) return customization;
  let changed = false;
  let matchedKey = null;
  let matchedType = null;
  const uploads = root.uploads.map((item) => {
    if (!item || typeof item !== "object" || Array.isArray(item)) return item;
    const row = item;
    if (row.token !== update.token) return item;
    changed = true;
    matchedKey = typeof row.optionKey === "string" ? row.optionKey : null;
    matchedType = typeof row.optionType === "string" ? row.optionType : null;
    const urls = row.urls && typeof row.urls === "object" && !Array.isArray(row.urls) ? { ...row.urls } : null;
    if (urls) {
      for (const key of Object.keys(urls)) {
        const value = urls[key];
        if (typeof value === "string" && value.length > 0) {
          urls[key] = withVersion(value, update.versionNo);
        }
      }
    }
    const previousKeys = row.keys && typeof row.keys === "object" && !Array.isArray(row.keys) ? row.keys : {};
    return {
      ...row,
      versionNoAtOrder: update.versionNo,
      ...update.fileName != null ? { fileName: update.fileName } : {},
      ...update.mimeType != null ? { mimeType: update.mimeType } : {},
      ...update.sizeBytes != null ? { sizeBytes: update.sizeBytes } : {},
      ...update.widthPx != null ? { originalWidthPx: update.widthPx } : {},
      ...update.heightPx != null ? { originalHeightPx: update.heightPx } : {},
      ...update.printWidthIn != null ? { printWidthIn: update.printWidthIn } : {},
      ...update.printHeightIn != null ? { printHeightIn: update.printHeightIn } : {},
      ...update.keys ? { keys: { ...previousKeys, ...update.keys } } : {},
      ...urls ? { urls } : {}
    };
  });
  if (!changed) return customization;
  const widthIn = update.printWidthIn;
  const heightIn = update.printHeightIn;
  const hasPrintSize = widthIn != null && heightIn != null && widthIn > 0 && heightIn > 0;
  const sizedLine = matchedType == null || SIZED_PRINT_TYPES.has(matchedType);
  return {
    ...root,
    uploads,
    ...hasPrintSize && sizedLine ? {
      customSize: {
        ...sizeRecord(root.customSize),
        widthIn,
        heightIn
      },
      selections: rewriteSelectionSize(root.selections, matchedKey, widthIn, heightIn)
    } : {}
  };
}
function sizeRecord(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  return { ...value };
}
function rewriteSelectionSize(selections, optionKey, widthIn, heightIn) {
  if (!optionKey || !Array.isArray(selections)) return selections;
  const preset = "detected";
  const text = `${preset === "detected" ? "Detected" : "Custom"}: ${formatInches(widthIn)} \xD7 ${formatInches(heightIn)} in`;
  return selections.map((item) => {
    if (!item || typeof item !== "object" || Array.isArray(item)) return item;
    const row = item;
    const key = typeof row.key === "string" ? row.key : typeof row.optionKey === "string" ? row.optionKey : null;
    if (key !== optionKey || !Array.isArray(row.values) || row.values.length < 2) return item;
    const values = row.values.slice(0, 3);
    values[0] = String(widthIn);
    values[1] = String(heightIn);
    values[2] = preset;
    return { ...row, values, value: text };
  });
}
function positiveInches(value) {
  const parsed = typeof value === "number" ? value : typeof value === "string" ? Number(value) : Number.NaN;
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}
function firstPositive(values) {
  for (const value of values) {
    if (value != null && value > 0) return value;
  }
  return null;
}
function selectedReplacementWidthIn(input) {
  const ordered = firstPositive(
    input.orderCustomizations.map((row) => widthFromOrder(row, input.token, input.optionKey))
  );
  if (ordered != null) return ordered;
  const submitted = firstPositive(
    input.submissionSelections.map((row) => widthFromSubmission(row, input.optionKey))
  );
  if (submitted != null) return submitted;
  const drafted = widthFromDraft(input.draft);
  if (drafted != null) return drafted;
  return positiveInches(input.previousPrintWidthIn);
}
function widthFromOrder(customization, token, optionKey) {
  if (!customization || typeof customization !== "object" || Array.isArray(customization)) return null;
  const root = customization;
  let tokenFound = false;
  if (Array.isArray(root.uploads)) {
    for (const item of root.uploads) {
      if (!item || typeof item !== "object" || Array.isArray(item)) continue;
      const row = item;
      if (row.token !== token) continue;
      tokenFound = true;
      const width = positiveInches(row.printWidthIn);
      if (width != null) return width;
    }
  }
  if (!tokenFound) return null;
  return widthFromSelectionList(root.selections, optionKey) ?? positiveInches(sizeRecord(root.customSize).widthIn);
}
function widthFromSubmission(payload, optionKey) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) return null;
  const root = payload;
  return widthFromSelectionList(root.selections, optionKey);
}
function widthFromSelectionList(selections, optionKey) {
  if (!optionKey || !Array.isArray(selections)) return null;
  for (const item of selections) {
    if (!item || typeof item !== "object" || Array.isArray(item)) continue;
    const row = item;
    const key = typeof row.key === "string" ? row.key : typeof row.optionKey === "string" ? row.optionKey : null;
    if (key !== optionKey || !Array.isArray(row.values)) continue;
    const width = positiveInches(row.values[0]);
    if (width != null) return width;
  }
  return null;
}
function widthFromDraft(draft) {
  if (!draft || typeof draft !== "object" || Array.isArray(draft)) return null;
  return positiveInches(draft.widthIn);
}
export {
  ADMIN_ROLE_CATALOG_MANAGER,
  ADMIN_ROLE_OPS_MANAGER,
  ADMIN_ROLE_SUPER_ADMIN,
  ADMIN_ROLE_SUPPORT_AGENT,
  ADMIN_SYSTEM_ROLES,
  APPAREL_LIBRARY_PREVIEW_JOB,
  APPAREL_LIBRARY_PREVIEW_QUEUE,
  APPAREL_MAX_PRINT_AREA_IN,
  APPAREL_MIN_PRINT_AREA_IN,
  APPAREL_RENDER_JOB,
  APPAREL_RENDER_QUEUE,
  AUTH_CONFIG,
  Action,
  AdminPermissions,
  AdminResource,
  AuthErrorCode,
  BOLD_CAPABLE_MIN_WEIGHT,
  BUILTIN_FONT_FAMILIES,
  BackgroundType,
  BroadcastAudienceType,
  BroadcastStatus,
  COLOR_AXIS_HINTS,
  COLOR_MAP,
  COMPOSITE_PART_KEY,
  COMPOSITE_PREVIEW_TAB_ID,
  COOKIE_NAMES,
  ChannelOrderStatus,
  ChatProvider,
  ColorSpace,
  ConnectionStatus,
  ConnectionType,
  CreditNoteStatus,
  CustomerGroupType,
  DATE_DISPLAY_FORMATS,
  DEFAULT_MAX_IMAGES,
  DEFAULT_MAX_LAYERS,
  DEFAULT_RESOLVED_DESIGNER_TEXT,
  DESIGNER_CHECKOUT_LIMITS,
  DESIGNER_CHECKOUT_MAX_PER_TYPE,
  DESIGNER_CHECKOUT_QUESTION_TYPES,
  DESIGNER_EMBED_MESSAGE_SOURCE,
  DESIGNER_EMBED_PROTOCOL_VERSION,
  DESIGNER_LAUNCH_MODES,
  DESIGNER_TEXT_LIMITS,
  DESIGN_CONTEXT_CARD_INFO,
  DESIGN_REF_ID_REGEX,
  DIMS_PART_KEY_INFIX,
  DPI_SOURCES,
  DYNAMIC_OPTION_PRODUCT_TYPES,
  DesignContext,
  DesignStatus,
  DesignerMode,
  EMPTY_RESOLVED_BRANDING,
  EMPTY_RESOLVED_CHECKOUT,
  ExportFormat,
  ExportStatus,
  ExtendedAction,
  FONT_UPLOAD_CEILINGS,
  FONT_UPLOAD_FALLBACKS,
  FULFILLMENT_METHOD_DESCRIPTIONS,
  FULFILLMENT_METHOD_LABELS,
  FULFILLMENT_PROVIDER_DESCRIPTIONS,
  FULFILLMENT_PROVIDER_LABELS,
  FULFILLMENT_PROVIDER_LABELS_LONG,
  FulfillmentLane,
  FulfillmentMethod,
  FulfillmentProvider,
  FulfillmentStatus,
  FulfillmentSyncStatus,
  GANGSHEET_DEFAULT_MAX_IMAGES,
  GANGSHEET_DEFAULT_MAX_LAYERS,
  GallerySortOrder,
  HEADER_NAMES,
  IMAGE_TOOLS_JOB,
  IMAGE_TOOLS_QUEUE_NAMES,
  IMAGE_TOOL_OPERATION_ORDER,
  INKTEO_SUBMIT_JOB,
  INKTEO_SUBMIT_QUEUE,
  InkteoFulfillmentType,
  InventoryPolicy,
  InvoiceLineType,
  InvoiceStatus,
  JobStatus,
  LIBRARY_ALLOWED_MIME_TYPES,
  LIBRARY_ALPHA_TRIM_THRESHOLD,
  LIBRARY_API_KEY_PREFIX,
  LIBRARY_ASSET_ID_PATTERN,
  LIBRARY_HARD_MAX_PIXELS,
  LIBRARY_IMPORT_MAX_FILE_BYTES,
  LIBRARY_IMPORT_MAX_RAW_ROWS,
  LIBRARY_IMPORT_PREVIEW_ROWS,
  LIBRARY_IMPORT_TITLE_MAX_LENGTH,
  LIBRARY_LARGE_MAX_PX,
  LIBRARY_MAX_BATCH_FILES,
  LIBRARY_MAX_BULK_ASSETS,
  LIBRARY_MAX_EXCEL_ROWS,
  LIBRARY_MAX_PAGE_SIZE,
  LIBRARY_ORIGINAL_KEY_PATTERN,
  LIBRARY_QUEUE_NAMES,
  LIBRARY_THUMB_MAX_PX,
  LIBRARY_TRIM_SCAN_MAX_PIXELS,
  LIBRARY_UPLOAD_DEFAULT_MAX_FILE_MB,
  LIBRARY_WEBP_QUALITY,
  LIBRARY_WORKING_KEY_PATTERN,
  LIBRARY_WORKING_MAX_EDGE_PX,
  LibraryApiScope,
  LibraryAssetSourceType,
  LibraryAssetStatus,
  LibraryDownloadVariant,
  LibraryMissingField,
  LibrarySearchField,
  LibrarySortOrder,
  LibraryTagSource,
  LibraryUploadBatchStatus,
  MAX_PROPERTY_VALUE_LENGTH,
  MAX_UPSCALE_PASSES,
  MERCHANT_ORDER_PROCESSING_STATUSES,
  MIN_REL_DIM,
  MIN_REL_DIM_STRICT,
  MIN_SHEET_HEIGHT_IN,
  MeasurementUnit,
  MessageSenderType,
  MockupLayerType,
  MockupType,
  MoneyError,
  NotificationCategory,
  NotificationChannel,
  NotificationStatus,
  NotificationType,
  OPTION_SUBMISSION_TOKEN_PATTERN,
  OPTION_UPLOAD_TOKEN_PATTERN,
  ORDER_AUTO_MANAGED_STATUSES,
  ORDER_DANGER_STATUSES,
  ORDER_EXPORT_TOKEN_REGEX,
  ORDER_PRIMARY_TRANSITION,
  ORDER_STATUS_DESCRIPTIONS,
  ORDER_STATUS_FLOW,
  ORDER_STATUS_LABELS,
  ORDER_STATUS_MERCHANT_LABELS,
  ORDER_STATUS_MERCHANT_VARIANT,
  ORDER_STATUS_VARIANT,
  ORDER_SUMMARY_PDF_JOB,
  ORDER_SUMMARY_PDF_MAX_PREVIEW_RETRIES,
  ORDER_SUMMARY_PDF_PREVIEW_RETRY_DELAY_MS,
  ORDER_SUMMARY_PDF_QUEUE,
  ORDER_SUMMARY_TOKEN_REGEX,
  ORDER_TERMINAL_STATUSES,
  ORDER_TRANSITIONS,
  ORDER_TRANSITION_LABELS,
  ORG_ROLE_ADMIN,
  ORG_ROLE_DESIGNER,
  ORG_ROLE_MANAGER,
  ORG_ROLE_OWNER,
  ORG_SYSTEM_ROLES,
  OptionUIType,
  OptionUploadFailureCode,
  OrderAnomalyResolution,
  OrderAnomalySeverity,
  OrderAnomalyStatus,
  OrderAnomalyType,
  OrderEventType,
  OrderFulfillmentMix,
  OrderSource,
  OrderStatus,
  OrgPermissions,
  OrgResource,
  OrgStatus,
  OrganizationAccountKind,
  PAGINATION,
  PER_VARIANT_PART_KEY_INFIX,
  PHASE1_SUPPORTED_OPTION_TYPES,
  PICKER_OPTION_TYPES,
  PLATFORM_DEFAULT_MIMES,
  PRESET_PRICING,
  PRODUCT_LIMITS,
  PRODUCT_OPTIONS_ELIGIBLE_DESIGNER_MODE,
  PRODUCT_OPTIONS_SCHEMA_VERSION,
  PRODUCT_OPTION_CHOICE_KEY_PATTERN,
  PROVIDER_REJECT_STATUSES,
  PROVIDER_SUBMISSION_PRODUCTION_STATUSES,
  PROVIDER_TRANSITIONS,
  PaymentMethodStatus,
  PaymentMethodType,
  PaymentStatus,
  PlacementStatus,
  PreviewJobStatus,
  PriceDeltaMode,
  PricingOverrideType,
  PricingStrategy,
  PrintTechnique,
  ProductOptionRole,
  ProductOptionType,
  ProductSourceType,
  ProductStatus,
  ProductType,
  ProductionType,
  ProductionTypeSource,
  ProofStatus,
  ProviderStatus,
  ProviderSubmissionStatus,
  ProviderType,
  PublishMethod,
  QCStatus,
  QUEUE_DEFINITIONS,
  QUEUE_NAMES,
  QueueType,
  RATE_LIMITS,
  RUSH_PRODUCTION_TAG,
  RateLimitErrorCode,
  ReconciliationRunStatus,
  RefundMode,
  RefundReason,
  RefundStatus,
  ReprintStatus,
  ReprintType,
  ResourceErrorCode,
  RoundingRule,
  SELF_FULFILL_CONFIRMATION_MESSAGE,
  SHIPMENT_STATUS_LABELS,
  SHIPMENT_STATUS_VARIANT,
  SHIPMENT_TERMINAL_STATUSES,
  SHIPMENT_TRANSITIONS,
  SHOPIFY_BRANDING_SYNC_QUEUE,
  SHOPIFY_COST_SYNC_JOB,
  SHOPIFY_COST_SYNC_QUEUE,
  SHOPIFY_FULFILLMENT_SYNC_JOB,
  SHOPIFY_FULFILLMENT_SYNC_QUEUE,
  SHOPIFY_LAUNCH_CONFIG_BACKFILL_JOB,
  SHOPIFY_LAUNCH_CONFIG_BACKFILL_QUEUE,
  SHOPIFY_MAX_TAGS_PER_ORDER,
  SHOPIFY_MAX_TAG_LENGTH,
  SHOPIFY_MEDIA_SYNC_JOB,
  SHOPIFY_MEDIA_SYNC_LOCK_MS,
  SHOPIFY_MEDIA_SYNC_QUEUE,
  SHOPIFY_PRODUCT_PUBLISH_JOB,
  SHOPIFY_PRODUCT_PUBLISH_LOCK_MS,
  SHOPIFY_PRODUCT_PUBLISH_QUEUE,
  SHOPIFY_TEMPLATE_CONTEXTS,
  SIZED_STRETCH_FLAG,
  SIZED_UPLOAD_MAX_PIXELS_DEFAULT,
  SIZE_AXIS_HINTS,
  SIZE_DISPLAY_DECIMALS,
  SIZE_PRICE_MODES,
  SNAP_GUIDE_TOLERANCE,
  SNAP_HARD_TOLERANCE,
  STRIPE_API_VERSION,
  STRIPE_DEFAULT_MINIMUM_CHARGE_MINOR_UNITS,
  STRIPE_INTENT_PURPOSES,
  STRIPE_METADATA_KEYS,
  STRIPE_MINIMUM_CHARGE_MINOR_UNITS,
  STRIPE_REQUEST_DEFAULTS,
  STRIPE_WEBHOOK_EVENTS,
  STRIPE_WEBHOOK_EVENT_LIST,
  STRIPE_WEBHOOK_TOLERANCE_SECONDS,
  SUBDOMAINS,
  SUPPORTED_CURRENCIES,
  SWATCH_SIZES,
  SWATCH_SIZE_PX,
  SYNTHETIC_STAFF_EMAIL_PREFIX,
  ServerErrorCode,
  ShipmentStatus,
  ShippingMarkupType,
  ShippingProviderType,
  ShopifyDeliveryMethod,
  SizeCategory,
  SubscriptionProvider,
  SubscriptionStatus,
  SyncStatus,
  TEXT_TRANSFORMS,
  TK_CART_PROPERTIES,
  TRIM_MODES,
  TaxExemptionKind,
  TaxExemptionReviewStatus,
  TenantErrorCode,
  TicketCategory,
  TicketPriority,
  TicketStatus,
  UPLOAD_LIMITS,
  UPLOAD_MAX_PIXELS_DEFAULT,
  UPLOAD_SOURCES,
  UPTStatus,
  UserStatus,
  VARIANT_COMPOSITE_PART_KEY_PREFIX,
  VARIANT_MATCH_RULES,
  ValidationErrorCode,
  WalletTransactionReason,
  WalletTransactionType,
  WebhookErrorCode,
  WebhookStatus,
  WholesaleChargeStatus,
  WholesaleSettledVia,
  activeQuantityTier,
  addMoney,
  adjustPrice,
  alignRectToRatio,
  allowedMimesForOption,
  apparelSideIsEmpty,
  applyLightnessToe,
  applyPercentToPrice,
  applyTextTransform,
  buildCheckoutPricingPayload,
  buildDesignAssetUrl,
  buildDesignerAdminEditUrl,
  buildDesignerEditUrl,
  buildDesignerLaunchUrl,
  buildExportBaseName,
  buildExportFileName,
  buildLineItemProperties,
  buildOrderExportZipUrl,
  buildOrderLineLabel,
  buildOrderSummaryPdfUrl,
  buildPermission,
  buildSyntheticStaffEmail,
  buildVariantFingerprint,
  buildVariantPreviewTabs,
  buildVariantSlug,
  calcContentSizeIn,
  canEditDesign,
  canProviderReject,
  canonicalDeclaredMime,
  canonicalPreviewStorageKey,
  canonicalSideSlugFromPartKey,
  cardInfoForDesignContext,
  catalogProductName,
  centsToDollars,
  changePasswordSchema,
  checkboxConfigSchema,
  checkboxGroupConfigSchema,
  checkoutFulfillmentDisplay,
  checkoutQuantityError,
  clamp,
  clampRect,
  clampRectWithin,
  coerceRelRect,
  compareMoney,
  compositeSideRank,
  computeInitialOrderStatus,
  computeProfit,
  computeSheetContentHeightIn,
  containRectForAspect,
  countOptionAxes,
  createDesignerEmbedEnvelope,
  createOrganizationSchema,
  createShopifyConnectionSchema,
  cuidSchema,
  customSizeConfigSchema,
  dateConfigSchema,
  dateRangeSchema,
  decimalToCents,
  decodeCheckoutSelections,
  deriveFontStyleCapabilities,
  deriveInchFromFrame,
  deriveLibrarySku,
  designLibraryPreviewKey,
  designObjectHasInk,
  designSideDimsPrintCanvasKey,
  designSideDimsPrintExportKey,
  designSidePrintCanvasKey,
  designSidePrintExportKey,
  designStoragePrefix,
  designVariantCompositeKey,
  designVariantSidePreviewKey,
  designerBrandingInputSchema,
  designerCheckoutInputSchema,
  designerCheckoutQuestionInputSchema,
  designerLogoVariantSchema,
  designerTextInputSchema,
  detectImportColumns,
  detectedSizeIn,
  dimsPartKey,
  displayRuleConditionSchema,
  displayRuleSchema,
  displayRulesSchema,
  dollarsToCents,
  dpiQuality,
  earliestSubmissionAt,
  effectiveMaxBytes,
  effectivePrintDpi,
  emailSchema,
  encodeCheckoutSelections,
  extractEmptySideKeys,
  extractOrderDigits,
  extractSheetTrimSizeByPartKey,
  filterDesignedPrintAreas,
  fitSize,
  fontUploadInputSchema,
  forgotPasswordSchema,
  formatActualPrintSize,
  formatCentsString,
  formatInches,
  formatIsoDate,
  formatMoney,
  formatMoneyDto,
  formatMoneyValue,
  formatOrderedOptionValue,
  formulaRawCents,
  gangsheetFixedWidthIn,
  gangsheetVariantHeight,
  generateCorrelationId,
  generateDesignRefId,
  generateOptionSubmissionToken,
  generateOptionUploadToken,
  generateOrderExportToken,
  generateOrderSummaryToken,
  getCancelAbility,
  getFulfillmentLane,
  getMerchantOrderStatusLabel,
  getOptionType,
  getOrderFulfillmentMix,
  getOrderTransitionLists,
  getProviderTransition,
  groupBySize,
  groupCheckboxState,
  groupColorWaySwatches,
  hasAllPermissions,
  hasAnyPermission,
  hasPermission,
  hasRushProductionTag,
  heightFromWidth,
  heightMatchesTrimmedRatio,
  hexColorSchema,
  imageToolOpsFromSignature,
  imageToolPipelineSignature,
  indexHexByColorName,
  infoConfigSchema,
  initialCollapsedSizeKeys,
  initialSelection,
  inkteoFulfillmentTypeFromShopifyDelivery,
  inkteoSubmitJobId,
  inviteMemberSchema,
  isAllowedEmbedOrigin,
  isBelowCost,
  isCompositePartKey,
  isDesignerChildMessage,
  isDesignerParentMessage,
  isDimsPartKey,
  isEditable,
  isFilled,
  isFrontBackCompositeSide,
  isIdempotencyConflict,
  isKnownQueueName,
  isLegacyOptionType,
  isLibraryAssetId,
  isLibraryKey,
  isLibraryPrintKey,
  isMerchantMaskedDanger,
  isMeteredImageToolPipeline,
  isMimeAllowed,
  isNamedBackSide,
  isNamedFrontSide,
  isNonEmptyString,
  isOptionSelectionFilled,
  isOptionVisible,
  isOrderTerminal,
  isPerVariantPartKey,
  isPhase1OptionType,
  isProductOptionsEligible,
  isProviderSubmissionInProduction,
  isRealIsoDate,
  isSatellitePartKey,
  isShipmentTerminal,
  isShopifyTemplateContext,
  isSingleSelectOptionType,
  isSizedUploadOptionType,
  isStretchedSelection,
  isSyntheticStaffEmail,
  isUptDesignContext,
  isValidDesignRefId,
  isValidHex6,
  isValidLineItemLabel,
  isValidOptionUploadToken,
  isValidOptionsRefToken,
  isValidOrderExportToken,
  isValidOrderSummaryToken,
  isValidOrderTransition,
  isValidPartKey,
  isValidShipmentTransition,
  isoDateSchema,
  legacyRectFromPrintArea,
  libraryDerivedLargeKey,
  libraryDerivedThumbKey,
  libraryDerivedWorkingKey,
  libraryOriginalKey,
  libraryPreviewJobId,
  limitSchema,
  lineIsInProduction,
  listEmptySheetNumbers,
  listOptionTypes,
  listQuerySchema,
  loginSchema,
  mapShopifyShippingLinesToDeliveryMethod,
  maskSensitive,
  matchVariantForSize,
  measuredPrintInches,
  moneyFromCents,
  moneyFromDecimalString,
  moneyFromDto,
  moneyIsNegative,
  moneyIsPositive,
  moneyIsZero,
  moneyToDecimalString,
  moneyToDto,
  monotonicProgress,
  moveRect,
  nameSchema,
  negateMoney,
  normalizeChoices,
  normalizeColorName,
  normalizeEmail,
  normalizeLibraryKeyword,
  normalizeLibraryKeywords,
  normalizeMime,
  normalizeOptionValue,
  normalizeOrderTag,
  normalizePlatformMimeSuperset,
  normalizeVariantKey,
  numberConfigSchema,
  oklabDistance,
  oklabToSrgb,
  omit,
  optionDisplayValue,
  optionSelectionSchema,
  optionSubmissionPayloadSchema,
  optionUploadDraftSchema,
  optionUploadFailureCode,
  optionUploadFailureMessage,
  optionUploadPreviewFiles,
  optionValueByAxisHints,
  optionalNameSchema,
  optionsBlockConfigSchema,
  orderAddressSchema,
  orderItemDisplayName,
  orderItemStoreListingTitle,
  orderRequiresFulfillmentRequest,
  orderSummaryPdfJobId,
  orderSummaryPdfStorageKey,
  orderTagSetsEqual,
  orderTagsInclude,
  orderedSizeText,
  orderedVariantLabel,
  pageSchema,
  paginationSchema,
  parseDesignerCheckoutStored,
  parseDesignerEmbedEnvelope,
  parseDesignerLaunchMode,
  parseDesignerTextStored,
  parseDimsPartKey,
  parseFontUploadStored,
  parseHexFill,
  parseLibraryVariantSuffix,
  parseMoneyInput,
  parseNegativePhrases,
  parsePermission,
  parseShopifyTagsString,
  parseSideMockupPartKey,
  parseVariantCompositePartKey,
  partCountFor,
  partitionPrintSides,
  passwordSchema,
  phoneSchema,
  physicalInches,
  pick,
  pickerOptionTypesFor,
  pixelsPerMeterForInches,
  positiveDecimalSchema,
  priceForSize,
  priceFromCostMargin,
  printDimsKey,
  printExportJobId,
  printRectFromInchesAtScale,
  printRectInBounds,
  printSizeChangedNote,
  productOptionChoiceSchema,
  productOptionChoicesSchema,
  productionTypeForPayload,
  productionTypeSourceForTags,
  productionTypeUpdateFromTags,
  quantityConfigSchema,
  quantityTierSchema,
  readDesignSelectionVariantId,
  recenterForRatio,
  recomputeCheckoutUnitCents,
  registerOptionType,
  registerSchema,
  removeLightnessToe,
  resetPasswordSchema,
  resizeRectAspectLocked,
  resizeRectFree,
  resolveActualPrintSize,
  resolveClaimFulfillmentType,
  resolveColorNameToHex,
  resolveDesignEditPermission,
  resolveDesignerBrandingDisplay,
  resolveDesignerCheckout,
  resolveDesignerLaunchMode,
  resolveDesignerObjectLimits,
  resolveDesignerText,
  resolveEffectiveDpi,
  resolveEffectivePrintSizeIn,
  resolveFontUpload,
  resolveFulfillmentSettings,
  resolveGalleryStagePreview,
  resolveManifestFileActualPrintSize,
  resolveOptionPrice,
  resolveOptionUploadEditPermission,
  resolveOrderItemBlankVariantId,
  resolveOrderItemSheetPartKey,
  resolveProductLaunchOverride,
  resolveProductTextOverride,
  resolveProductionTypeFromTags,
  resolveSheetIndexByPartKey,
  resolveSheetNumber,
  resolveSheetPartKey,
  resolveSizedUploadMaxPixels,
  resolveSwatchHex,
  resolveTableHeroPreview,
  resolveUploadMaxPixels,
  resolveVariantEffectivePrintSizeIn,
  resolveVariantHeroPlan,
  retryWithBackoff,
  rewriteStoredUploadVersion,
  roundDisplay,
  roundMoney,
  roundRect,
  safeJsonParse,
  sanitizeCssHex,
  sanitizeFileToken,
  sanitizeUploadFileName,
  scaleConsistency,
  scaleFromMeasure,
  selectDesignerLogoUrl,
  selectableGroupIds,
  selectedReplacementWidthIn,
  shopifyCostSyncJobId,
  shopifyFulfillmentSyncJobId,
  shopifyLaunchConfigBackfillJobId,
  shopifyMediaSyncJobId,
  shopifyProductPublishJobId,
  shopifyVariantNumericId,
  sideMockupPartKey,
  sizeFormulaMode,
  sizePresetSchema,
  sizeRateInches,
  sizedCheckoutDimension,
  sizedUploadEligibilityError,
  sizingBounds,
  sleep,
  slugSchema,
  slugifyLibraryText,
  snapRectToCenter,
  sortDirSchema,
  sortImageToolOperations,
  srgbToOklab,
  srgbToOklabLr,
  storageKeySchema,
  stripDeclaredMime,
  stripNegativePhrases,
  stripUrlQueryAndFragment,
  stripeMinimumChargeCents,
  subtractMoney,
  suggestTrailingPhrases,
  suggestedDuplicateDesignContext,
  swatchConfigSchema,
  swatchSizePx,
  textConfigSchema,
  toggleIdsInSelection,
  toleranceToOklabDistance,
  topUpWalletSchema,
  triggerSyncSchema,
  truncate,
  unsafeCustomerPattern,
  updateOrganizationSchema,
  updateProfileSchema,
  uploadAcceptAttribute,
  uploadConfigSchema,
  uploadLinkProperties,
  uploadProgressPercent,
  urlSchema,
  validateOrderTag,
  validateSizedValues,
  variantAxisLabel,
  variantAxisSelectionSchema,
  variantCompositePartKey,
  variantPreviewJobId,
  variantRowLabel,
  versionedSidePreviewUrl,
  visibleInOrder,
  widthFromHeight,
  withPreviewContentHash,
  zeroMoney
};
//# sourceMappingURL=index.js.map